  // src/pages/AgendaPro.js

  import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
  import FullCalendar from "@fullcalendar/react";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import timeGridPlugin from "@fullcalendar/timegrid";
  import interactionPlugin from "@fullcalendar/interaction";
  import listPlugin from "@fullcalendar/list";
  import itLocale from "@fullcalendar/core/locales/it";


  import "./agenda.css";

  import { useAuth } from "../context/AuthContext";




function PermessiBar({ role, zonaId, caps }) {
  if (!caps) return null;
  const ON  = (v) => !!v;
  const b = (k, lbl) => (
    <span style={{
      display:'inline-block', padding:'3px 8px', borderRadius:999,
      border:'1px solid #e5e7eb', background: ON(caps[k]) ? '#eaffea' : '#f8fafc',
      marginRight:6, fontSize:12, fontWeight:700
    }}>
      {lbl}: {ON(caps[k]) ? 'ON' : 'off'}
    </span>
  );
  return (
    <div style={{margin:'6px 0 10px', padding:'6px 8px', border:'1px dashed #e5e7eb', borderRadius:8}}>
      <strong>Permessi effettivi</strong> · ruolo: <b>{role}</b> · zona: <b>{zonaId}</b>
      <div style={{marginTop:6}}>
        {b('canMoveEvent','move')}
        {b('canConfirm','confirm')}
        {b('canAssignRilevatore','assign rid')}
        {b('canAssignSenior','assign sr')}
        {b('canSetSeniorEsito','sr esito')}
        {b('canCancel','cancel')}
        {b('canReset','reset')}
        {b('canDelete','delete')}
        {b('canToggleSeniorWant','passa sr')}
        {b('canMarkRilNonBuono','ril KO')}
        {b('canUploadFiles','upload')}
        {b('canEditBudgets','budget')}
        {b('canUsePreventivatore','preventivatore')}
        {b('readOnly','readOnly')}
        {b('restrictAssignedOnly','solo assegnati')}
        {b('phoneDelay','tel -20′')}


        {b('canPushToPosa','posa push')}
{b('zoneLock','zone lock')}
{b('zoneMulti','zone multi')}
      </div>
    </div>
  );
}


const __OV_HDR_ANCHORS = new Map(); // yyy-mm-dd -> { el, top }




// ---------- DATE HELPERS (locale/DST safe) ----------
function parseDt(dt) {
  if (dt instanceof Date) return dt;
  if (!dt && dt !== 0) return new Date(NaN);
  let s = String(dt).trim().replace('T',' ');
  const m = s.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:\s+(\d{2})(?::(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?)?)?$/
  );
  if (!m) return new Date(NaN);
  const [, y, mo, d, hh='0', mm='0', ss='0', ms='0'] = m;
  return new Date(+y, +mo-1, +d, +hh, +mm, +ss, +(String(ms).padEnd(3,'0')));
}

function ymdLocal(dLike) {
  const d = parseDt(dLike);
  if (isNaN(d)) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")}`;
}



function mapUrlForYmd(ymd, zonaId) {
  const u = new URL(`${window.location.origin}/preventivi/agenda_map/map_v2.php`);
  u.searchParams.set("d", ymd);
  if (Number(zonaId || 0) > 0) {
    u.searchParams.set("zona", String(zonaId));
  }
  return u.toString();
}


/** Legge day dall’hash: #/agenda-pro?day=YYYY-MM-DD[&event=...] */
function getBootFromHash() {
  try {
    const hash = window.location.hash || ""; // es. "#/agenda-pro?day=2025-11-15&event=123"
    const q = hash.includes("?") ? hash.split("?")[1] : "";
    if (!q) return { day: "", eventId: null };

    const params = new URLSearchParams(q);
    const day = params.get("day") || params.get("d") || "";
    const ev  = params.get("event") || params.get("event_id") || params.get("id") || "";

    return {
      day: day && /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : "",
      eventId: ev ? String(ev) : null, // al momento non lo usiamo
    };
  } catch {
    return { day: "", eventId: null };
  }
} 



function addGlobeToTh(th, ymd, zonaId) {
  if (!th || !ymd) return;

  // 🔥 dedupe: in TUTTI gli header rimuovi eventuali globe già esistenti per quel giorno
  const headerRoot = th.closest('.fc-col-header') || document;
  headerRoot.querySelectorAll(`.ov-globe[data-ymd="${ymd}"]`).forEach(n => {
    try { n.remove(); } catch {}
  });

  // slot destro nel TH scelto
  let slot = th.querySelector(':scope > .ov-slot--right');
  if (!slot) {
    slot = document.createElement('span');
    slot.className = 'ov-slot ov-slot--right';
    Object.assign(slot.style, {
      position:'absolute', right:'6px', top:'6px',
      display:'inline-flex', gap:'6px', alignItems:'center',
      pointerEvents:'auto', zIndex:2,
    });
    th.style.position = th.style.position || 'relative';
    th.appendChild(slot);
  } else {
    // tieni lo slot ma pulisci il contenuto
    while (slot.firstChild) slot.removeChild(slot.firstChild);
  }

  // link mappa (unico)
  const a = document.createElement('a');
  a.className = 'ov-globe';
  a.setAttribute('data-ymd', ymd);
  a.href = mapUrlForYmd(ymd, zonaId);
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.title = 'Apri mappa del giorno';
  a.textContent = '🌐';
  Object.assign(a.style, { textDecoration:'none', fontSize:'16px', lineHeight:1, cursor:'pointer' });

  slot.appendChild(a);
}


function addGlobeToDayTop(topEl, ymd, zonaId) {
  if (!topEl || !ymd) return;
  let slot = topEl.querySelector(':scope > .ov-slot--right');
  if (!slot) {
    slot = document.createElement('span');
    slot.className = 'ov-slot ov-slot--right';
    Object.assign(slot.style, {
      position:'absolute',
      right:'4px',
      top:'18px',            // <- sotto al numero del giorno
      display:'inline-flex',
      gap:'6px',
      alignItems:'center',
      pointerEvents:'auto',
      zIndex:2,
    });
    topEl.style.position = topEl.style.position || 'relative';
    topEl.appendChild(slot);
  } else {
    while (slot.firstChild) slot.removeChild(slot.firstChild);
  }
  const a = document.createElement('a');
  a.href = mapUrlForYmd(ymd, zonaId);
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.title = 'Apri mappa del giorno';
  a.textContent = '🌐';
  Object.assign(a.style, { textDecoration:'none', fontSize:'13px', lineHeight:1, cursor:'pointer' });
  slot.appendChild(a);
}





function dayBounds(ymd) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || '');
  if (!m) return { start: new Date(NaN), end: new Date(NaN) };
  const y=+m[1], mo=+m[2]-1, d=+m[3];
  return {
    start: new Date(y, mo, d, 0, 0, 0, 0),
    end:   new Date(y, mo, d, 23, 59, 59, 999),
  };
}

// overlay che tocca il giorno (intersezione intervalli)
function overlaysForDay(overlays, ymd) {
  const { start: ds, end: de } = dayBounds(ymd);
  return (overlays || []).filter(o => {
    const s = parseDt(o?.start_dt);
    const e0 = parseDt(o?.end_dt || o?.start_dt);
    if (isNaN(s) || isNaN(e0)) return false;
    const e = e0 < s ? s : e0;
    return s <= de && e >= ds;
  });
}

// ---------- DOM HELPERS ----------



function clearChildren(node){ while (node && node.firstChild) node.removeChild(node.firstChild); }
// mini-pallino per header / mese
function makeDot(bg, title, onClick, opts = {}) {
  const { isGlobal = false } = opts;          // 👈 evidenzia overlay aziendali
  const b = document.createElement("span");   // span, non button
  b.className = "ov-dot";
  if (title) {
    b.setAttribute("role", "button");
    b.setAttribute("aria-label", title);
    b.title = title;
  }

  Object.assign(b.style, {
    width: isGlobal ? "11px" : "10px",
    height: isGlobal ? "11px" : "10px",
    display: "inline-block",
    verticalAlign: "middle",
    borderRadius: "9999px",
    background: bg,
    padding: 0,
    margin: 0,
    cursor: "pointer",
    lineHeight: 0,
    appearance: "none",
    outline: "none",
    pointerEvents: "auto",

    // bordo normale
    border: isGlobal
      ? "2px solid #b91c1c"                      // 🔴 bordo rosso per eventi aziendali
      : "1px solid rgba(0,0,0,.28)",
    boxShadow: isGlobal
      ? "0 0 0 1px rgba(248,113,113,.6)"        // alone leggero
      : "none",
  });

  b.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick && onClick(e);
  });

  return b;
}


function designRightSlot(){
  const s = document.createElement('span');
  s.className = 'ov-slot ov-slot--right';
  Object.assign(s.style, { display:'inline-flex', gap:'6px', alignItems:'center' });
  return s;
}




// Renderizza i dots nel TH corretto, ripulendo i duplicati
function renderHeaderDotsForTh(th, ymd, overlaysArr, openNewFn, openEditFn) {
  if (!th || !ymd) return;

  const headerRoot = th.closest('.fc-col-header') || document;
  const first = headerRoot.querySelector(`th[data-date="${ymd}"]`) || th;

  // se questo th NON è il primo del giorno → pulisci ed esci
  if (th !== first) {
    try { th.querySelector(':scope > .ov-dots')?.remove(); } catch {}
    return;
  }

  th.style.position = th.style.position || 'relative';
  let dots = th.querySelector(':scope > .ov-dots');
  if (!dots) {
    dots = document.createElement('span');
    dots.className = 'ov-dots';
    Object.assign(dots.style, {
      position:'absolute', left:'6px', top:'6px',
      display:'inline-flex', gap:'6px', alignItems:'center',
      pointerEvents:'auto', zIndex:2,
    });
    th.appendChild(dots);
  } else {
    clearChildren(dots);
  }

  // grigio (nuovo)
  dots.appendChild(
    makeDot('#9aa1a6', 'Nuovo overlay per questo giorno', () => openNewFn(ymd))
  );

  // colorati (edit)
  overlaysForDay(overlaysArr, ymd)
    .sort((a,b) => String(a.start_dt).localeCompare(String(b.start_dt)))
    .forEach(o => {
      dots.appendChild(
        makeDot(o?.color || '#9aa1a6', o?.note || 'Modifica / elimina overlay', () => openEditFn(o))
      );
    });
}

  const API = "/preventivi/agenda/api"; 
  const API_USERS = "/preventivi/api";   

  const USERS_API = "/preventivi/api";


  /* --- fetch helpers --- */
  async function apiGet(url) {
    const r = await fetch(url, { credentials: "same-origin" });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.message || `HTTP ${r.status}`);
    return j;
  }
  async function apiPost(endpoint, payload = {}) {
    // Accetta sia "endpoint.php" (prefisso con API) che URL completo
    const isFull = /^https?:\/\//i.test(endpoint) || endpoint.startsWith("/preventivi/");
    const url = isFull ? endpoint : `${API}/${endpoint}`;
    const r = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    });
    const txt = await r.text();
    let j; try { j = JSON.parse(txt); } catch { j = {}; }
    if (!r.ok || (j.status && j.status !== "OK")) {
      throw new Error(j.message || `HTTP ${r.status}`);
    }
    return j;
  }
function roleKeyFromNorm(roleNorm) {
  const r = String(roleNorm || "").toLowerCase();
  if (/(^|[-_])admin($|[-_])/.test(r)) return "admin";
  if (/(^|[-_])(centralino|call.?center|ufficio|back.?office)($|[-_])/.test(r)) return "centralino";
  if (/(^|[-_])(formatore|trainer)($|[-_])/.test(r)) return "formatore";
  if (/(^|[-_])(senior_posa|posa_senior|seniorposa|posa)($|[-_])/.test(r)) return "senior_posa";
  if (/(^|[-_])(senior|tecnico_senior)($|[-_])/.test(r)) return "senior";
  if (/(^|[-_])(rilevatore|ril|junior|tecnico|field)($|[-_])/.test(r)) return "rilevatore";
  if (/(^|[-_])(responsabile|resp)($|[-_])/.test(r)) return "responsabile_zona";
  return "user";
}


async function autoAssegnaGiorno(dateISO, zonaId) {
  const res = await fetch('/preventivi/agenda/api/auto_assign_day.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ date: dateISO, zona_id: zonaId })
  });

  let payload = {};
  try { payload = await res.json(); } catch {}

  if (!res.ok) {
    alert(payload?.message || 'Errore interno durante l’auto-assegnazione');
    return { ok:false };
  }
  if (payload?.code === 'NO_COORDS') {
    alert(payload.message || 'Nessun appuntamento con coordinate per quel giorno');
    return { ok:true, assigned:0 };
  }
  alert(`Auto-assegnazioni completate: ${payload?.assigned ?? 0}`);
  return { ok:true, assigned: payload?.assigned ?? 0 };
}



// === KM: calcolo lato server per intera giornata (ID alias-safe) ===
async function computeDayKmServer({ userId, day, eventId = 0, persist = 1 }) {
  const uid = Number(userId || 0);
  const payload = {
    // invio TUTTI gli alias che il BE potrebbe aspettarsi
    user_id:       uid,
    operator_id:   uid,
    rilevatore_id: uid,

    day: String(day),
    event_id: Number(eventId) || 0,
    persist: persist ? 1 : 0,
  };

  const r = await fetch("/preventivi/api/compute_day_km.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify(payload),
  });
  const txt = await r.text();
  let j; try { j = JSON.parse(txt); } catch { j = {}; }
  if (!r.ok) throw new Error(j.message || `HTTP ${r.status}`);
  return j;
}



/* ===================== R012 — Link component ===================== */
function R012Link({ app }) {
  const [st, setSt] = React.useState({ loading: true, exists: false, id: null });

  // Build prefill query
  const qs = React.useMemo(() => {
    const p = new URLSearchParams({
      appointment_id: String(app?.id || ''),
      cliente_nome: app?.cliente_nome || '',
      telefono: app?.telefono || '',
      indirizzo: app?.indirizzo || '',
      data_appuntamento: app?.data || '',
      ora_appuntamento: app?.ora || ''
    });
    return p.toString();
  }, [app]);

  React.useEffect(() => {
    let abort = false;
    const apptId = String(app?.id || '');
    if (!apptId) { setSt({ loading: false, exists: false, id: null }); return; }

    (async () => {
      try {
        const r = await fetch(`/preventivi/R012/exists.php?appointment_id=${encodeURIComponent(apptId)}`, {
          credentials: 'same-origin'
        });
        const j = await r.json().catch(() => ({}));
        if (abort) return;
        setSt({ loading: false, exists: !!j?.exists, id: j?.id || null });
      } catch {
        if (!abort) setSt({ loading: false, exists: false, id: null });
      }
    })();
    return () => { abort = true; };
  }, [app?.id]);

  if (st.loading) {
    return <div className="am-read" style={{opacity:.7}}>Carico link R012…</div>;
  }

  if (st.exists && st.id) {
    const id = st.id;
    const onDelete = async (e) => {
      e.preventDefault();
      if (!window.confirm('Confermi la cancellazione del report R012?')) return;
      try {
        const r = await fetch(`/preventivi/R012/delete.php?id=${encodeURIComponent(id)}`, {
          method: 'POST', credentials: 'same-origin'
        });
        const j = await r.json().catch(()=> ({}));
        if (j?.ok) setSt({ loading:false, exists:false, id:null });
        else alert(j?.error || 'Errore durante la cancellazione');
      } catch (err) {
        alert(String(err?.message || err));
      }
    };

    return (
      <div className="r012-actions" style={{display:'flex', gap:8, alignItems:'center'}}>
        <a href={`/preventivi/R012/view.php?id=${id}`} target="_blank" rel="noopener noreferrer">Vedi R012</a>
        <span>·</span>
        <a href={`/preventivi/R012/form.php?id=${id}`} target="_blank" rel="noopener noreferrer">Modifica</a>
        <span>·</span>
        <a href="#" onClick={onDelete}>Cancella</a>
      </div>
    );
  }

  // Non esiste → mostra "Compila"
  return (
    <a
      href={`/preventivi/R012/form.php?${qs}`}
      target="_blank"
      rel="noopener noreferrer"
      className="r012-new"
    >
      Compila R012 post rilievo
    </a>
  );
}
/* =================== /R012 — Link component ====================== */













// --- Tip forward stub: evita no-undef prima della definizione reale ---
let Tip = {
  show(){},
  hide(){},
  cancel(){},
  lock(){},
};













  /* --------- helper: fetchSlots (barra disponibilità) --------- */
  async function fetchSlots(fromYmd, days = 7, zona_id = 1) {
    const url = `${API}/slots_week.php?from=${encodeURIComponent(fromYmd)}&days=${encodeURIComponent(days)}&zona_id=${encodeURIComponent(zona_id)}`;
    const r = await fetch(url, { credentials: "same-origin" });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.message || `HTTP ${r.status}`);
    return Array.isArray(j.slots) ? j.slots : [];
  }

  /* --------- stili condivisi usati nei filtri in alto --------- */
  const styles = {
    lbl: { fontSize: 12, opacity: 0.8, marginBottom: 4 },
    filtersRow: {
      display: "flex",
      gap: 10,
      alignItems: "flex-end",
      flexWrap: "wrap",
      marginBottom: 10,
    },
  };




  // form-urlencoded (robusto con PHP legacy)
  async function apiPostForm(endpoint, form = {}) {
    const isFull = /^https?:\/\//i.test(endpoint) || endpoint.startsWith("/preventivi/");
    const url = isFull ? endpoint : `${API}/${endpoint}`;
    const body = new URLSearchParams();
    for (const [k, v] of Object.entries(form)) body.append(k, v == null ? "" : String(v));
    const r = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      credentials: "same-origin",
      body,
    });
    const txt = await r.text(); let j; try { j = JSON.parse(txt); } catch { j = {}; }
    if (!r.ok || (j.status && j.status !== "OK")) throw new Error(j.message || `HTTP ${r.status}`);
    return j;
  }

  // vero se 1/"1"/true/"true"/"si"/"sì"/"ok"/"on"/"y"…
  function boolish(v) {
    const s = String(v ?? "").trim().toLowerCase();
    return s === "1" || s === "true" || s === "si" || s === "sì" || s === "ok" || s === "on" || s === "y";
  }

  /* --- costanti minime --- */
  const ZONE = [
    { id: 1, label: "Verona" },
    { id: 2, label: "Modena" },
    { id: 3, label: "Novara" },
    { id: 4, label: "Milano Sud" },
    { id: 5, label: "Milano Nord" },
  ];
  const STATI = [
    "", "prenotato", "confermato", "assegnato",
    "rilievo_fatto", "senior_da_programmare",
    "non_chiuso", "chiuso", "annullato", "no_show",
  ];


/* ====== Overlays (blocchi agenda) ====== */

/* ====== Overlays (blocchi agenda) ====== */
const PASTEL_COLORS = ["#fde68a","#fbcfe8","#bfdbfe","#bbf7d0","#e9d5ff","#fecaca","#d1fae5"];

// util: sovrapposizione date-time
// util: sovrapposizione date-time (true se i due intervalli si intersecano)
function overlaps(aStart, aEnd, bStart, bEnd) {
  const A1 = +new Date(aStart);
  const A2 = +new Date(aEnd || aStart);
  const B1 = +new Date(bStart);
  const B2 = +new Date(bEnd || bStart);
  return A1 < B2 && A2 > B1;
}

function hasOverlayConflictFor(userId, roleKey, startISO, endISO, overlaysArr) {
  if (!userId || !startISO || !overlaysArr || !overlaysArr.length) return false;

  const s = new Date(startISO);
  const e = new Date(endISO || startISO);

  // decide quali liste guardare in base al ruolo
  const pickList = (ov) => {
    switch (roleKey) {
      case "senior":
        return ov.seniori || [];
      case "senior_posa":
        return ov.senior_posa || [];
      case "formatore":
        return ov.formatori || [];
      case "ril":
        return ov.rilevatori || [];
      default:
        return [];
    }
  };

  for (const ov of overlaysArr) {
    const oS = parseDt(ov.start_dt || ov.start);
    const oE = parseDt(ov.end_dt   || ov.end   || ov.start_dt || ov.start);
    if (isNaN(oS) || isNaN(oE)) continue;

    const intersects = oS < e && oE > s;
    if (!intersects) continue;

    // 🔴 EVENTO AZIENDALE: vale per TUTTI i rilevatori / TUTTI i senior
    const isGlobalRil =
      Number(ov.global_rilevatori ?? ov.is_global_ril ?? 0) === 1;
    const isGlobalSnr =
      Number(ov.global_senior ?? ov.is_global_snr ?? 0) === 1;

    if (roleKey === "ril" && isGlobalRil)   return true;
    if (roleKey === "senior" && isGlobalSnr) return true;

    // Caso normale: controllo lista partecipanti
    const arr = pickList(ov).map(Number);
    if (arr.includes(Number(userId))) return true;
  }

  return false;
}


async function fetchOverlayById(id) {
  const r = await fetch(`/preventivi/agenda/overlays/get.php?id=${encodeURIComponent(id)}`, {
    credentials: "same-origin"
  });
  const j = await r.json().catch(()=> ({}));
  if (!r.ok || j.status !== "OK") throw new Error(j.message || `HTTP ${r.status}`);
  return j.row || j;
}



  /* --- Modal basilare --- */
  function Modal({ open, onClose, title, width = 720, children }) {
    if (!open) return null;
    return (
      <div className="Modal" style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,.4)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
      }}>
        <div style={{
          width, maxWidth: "95vw", maxHeight: "90vh", overflow: "auto",
          background: "#fff", borderRadius: 12, boxShadow: "0 10px 40px rgba(0,0,0,.25)"
        }}>
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "10px 14px", borderBottom: "1px solid #eee"
          }}>
            <div style={{ fontWeight: 800 }}>{title}</div>
            <button
              onClick={onClose}
              aria-label="Chiudi"
              title="Chiudi"
              style={{ border: "none", background: "transparent", fontSize: 18, cursor: "pointer" }}
            >✕</button>
          </div>
          <div style={{ padding: 12 }}>{children}</div>
        </div>
      </div>
    );
  }


/* ====== OverlayModal — crea/modifica blocchi ====== */
/* ====== OverlayModal — crea/modifica blocchi ====== */


/* ====== OverlayModal — crea/modifica blocchi ====== */
/* ====== OverlayModal — crea/modifica blocchi ====== */
function OverlayModal({
  open,
  onClose,
  onSaved,
  defaultDay,
  zonaId,
  operatorId,
  editData,
  rilevatori = [],
  seniori = [],
  seniorPosa = [],
  formatori = [],
}) {
  const isEdit = !!(editData && editData.id);

  // stato base
  const [day, setDay] = React.useState(() => defaultDay || todayYMD());
  const [from, setFrom] = React.useState("10:00");
  const [to, setTo] = React.useState("13:00");
  const [titolo, setTitolo] = React.useState("");
  const [color, setColor] = React.useState("#9aa1a6"); // grigio di default
  const [idEdit, setIdEdit] = React.useState(0);
  const [isBlock, setIsBlock] = React.useState(false);

  // flag evento aziendale (applica su tutte le zone)
  const [isGlobalRil, setIsGlobalRil] = React.useState(false);
  const [isGlobalSnr, setIsGlobalSnr] = React.useState(false);

  // partecipanti
  const [selRil, setSelRil] = React.useState([]);
  const [selSNR, setSelSNR] = React.useState([]);
  const [selSNRP, setSelSNRP] = React.useState([]);
  const [selFMT, setSelFMT] = React.useState([]);

  // --- Selezione aziendale (tutti i partecipanti per ruolo) ---
  const selectAllRilevatoriAzienda = () => {
    const ids = (rilevatori || [])
      .map((u) => Number(u.id))
      .filter((n) => Number.isFinite(n) && n > 0);
    setSelRil(ids);
    setIsGlobalRil(true); // evento aziendale per TUTTI i rilevatori
  };

  const selectAllSeniorAzienda = () => {
    const ids = (seniori || [])
      .map((u) => Number(u.id))
      .filter((n) => Number.isFinite(n) && n > 0);
    setSelSNR(ids);
    setIsGlobalSnr(true); // evento aziendale per TUTTI i senior
  };

  // prefill su open/edit
  React.useEffect(() => {
    if (!open) return;

    // reset base ogni volta che apro
    setDay(defaultDay || todayYMD());
    setFrom("10:00");
    setTo("13:00");
    setTitolo("");
    setColor("#9aa1a6");
    setIsBlock(false);
    setIsGlobalRil(false);
    setIsGlobalSnr(false);

    setSelRil([]);
    setSelSNR([]);
    setSelSNRP([]);
    setSelFMT([]);
    setIdEdit(0);

    (async () => {
      try {
        if (!editData || !editData.id) return;

        let row = editData;
        // se dal list non arrivano i partecipanti, ricarico il dettaglio
        if (
          !Array.isArray(editData.rilevatori) &&
          !Array.isArray(editData.seniori)
        ) {
          try {
            row = await fetchOverlayById(editData.id);
          } catch {
            /* no-op */
          }
        }

        setIdEdit(Number(row.id));

        const s = String(row.start_dt || "").slice(0, 16).replace(" ", "T");
        const e = String(row.end_dt || s).slice(0, 16).replace(" ", "T");
        const ymd = s ? s.slice(0, 10) : defaultDay || todayYMD();
        const hh1 = s ? s.slice(11, 16) : "10:00";
        const hh2 = e ? e.slice(11, 16) : "13:00";

        setDay(ymd);
        setFrom(hh1);
        setTo(hh2);
        setTitolo(String(row.note || row.titolo || ""));
        setColor(String(row.color || "#9aa1a6"));
        setIsBlock(Number(row.is_block || row.block || 0) === 1);

        // leggo i flag global dal DB (se presenti)
        const flagGlobalRil =
          Number(row.global_rilevatori ?? row.is_global_ril ?? 0) === 1;
        const flagGlobalSnr =
          Number(row.global_senior ?? row.is_global_snr ?? 0) === 1;

        setIsGlobalRil(flagGlobalRil);
        setIsGlobalSnr(flagGlobalSnr);

        const toIds = (arr) =>
          Array.isArray(arr)
            ? arr
                .map((x) => Number(x?.id ?? x))
                .filter((n) => Number.isFinite(n) && n > 0)
            : [];

        // --- RILEVATORI ---
        const savedRil = toIds(row.rilevatori);
        if (flagGlobalRil) {
          // overlay aziendale: se in questa zona non ci sono id salvati, seleziona tutti
          if (!savedRil.length) {
            const allIds = (rilevatori || [])
              .map((u) => Number(u.id))
              .filter((n) => Number.isFinite(n) && n > 0);
            setSelRil(allIds);
          } else {
            setSelRil(savedRil);
          }
        } else {
          setSelRil(savedRil);
        }

        // --- SENIOR ---
        const savedSnr = toIds(row.seniori);
        if (flagGlobalSnr) {
          if (!savedSnr.length) {
            const allIds = (seniori || [])
              .map((u) => Number(u.id))
              .filter((n) => Number.isFinite(n) && n > 0);
            setSelSNR(allIds);
          } else {
            setSelSNR(savedSnr);
          }
        } else {
          setSelSNR(savedSnr);
        }

        // altri ruoli come prima
        setSelSNRP(toIds(row.senior_posa));
        setSelFMT(toIds(row.formatori));
      } catch {
        /* no-op */
      }
    })();
  }, [open, editData, defaultDay, rilevatori, seniori]);

  if (!open) return null;

  const toggleIn = (arr, id, setter) =>
    setter(arr.includes(id) ? arr.filter((x) => x !== id) : [...arr, id]);

  const submit = async (e) => {
    e.preventDefault();

    const payload = {
      id: idEdit || 0,
      zona_id: Number(zonaId || 0),
      start_dt: `${day} ${from}:00`,
      end_dt: `${day} ${to}:00`,
      color,
      note: titolo,
      is_block: isBlock ? 1 : 0,
      operator_id: Number(operatorId || 0),

      // partecipanti zona corrente
      rilevatori: selRil,
      seniori: selSNR,
      senior_posa: selSNRP,
      formatori: selFMT,

      // flag evento aziendale: il BE li userà per duplicare/cancellare sulle altre zone
      global_rilevatori: isGlobalRil ? 1 : 0,
      global_senior: isGlobalSnr ? 1 : 0,
    };

    try {
      const r = await fetch("/preventivi/agenda/overlays/save.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
      const j = await r.json().catch(() => ({}));
      if (r.status === 409 || j?.status === "DUPLICATE") {
        alert("C'è già un evento che copre quell’orario.");
        return;
      }
      if (!r.ok || j?.status !== "OK")
        throw new Error(j?.message || `HTTP ${r.status}`);
      onSaved?.();
      onClose?.();
    } catch (err) {
      alert(err?.message || "Errore salvataggio evento");
    }
  };

  // helper JSON
  const safeJson = async (res) => {
    try {
      return await res.json();
    } catch {
      return {};
    }
  };

  const doDelete = async () => {
    if (!idEdit) return;
    if (!window.confirm("Confermi la cancellazione dell'evento?")) return;

    try {
      const res = await fetch("/preventivi/agenda/overlays/delete.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          id: Number(idEdit),
          operator_id: Number(operatorId || 0),
        }),
      });

      const payload = await safeJson(res);
      if (!res.ok || payload?.status !== "OK") {
        throw new Error(payload?.message || `HTTP ${res.status}`);
      }

      onSaved?.();
      onClose?.();
    } catch (err) {
      alert(String(err?.message || err) || "Errore cancellazione");
    }
  };

  const fmtIT = (d) => {
    try {
      const [Y, M, D] = d.split("-");
      return `${D}/${M}/${Y}`;
    } catch {
      return d;
    }
  };
  const titoloModale = `Evento del ${fmtIT(day)}`;

  const chipStyle = {
    padding: "3px 7px",
    border: "1px solid #ddd",
    borderRadius: 999,
    background: "#fff",
    color: "#111",
    fontSize: 11,
    cursor: "pointer",
  };
  const chipOn = { ...chipStyle, background: "#111827", color: "#fff" };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={<div style={{ textAlign: "center", width: "100%" }}>{titoloModale}</div>}
      width={680}
    >
      <form onSubmit={submit} style={{ display: "grid", gap: 10 }}>
        <label>
          Giorno{" "}
          <input
            type="date"
            value={day}
            onChange={(e) => setDay(e.target.value)}
            required
          />
        </label>

        {/* Riga: orari + bottoni aziendali */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 10,
            alignItems: "center",
          }}
        >
          <label>
            evento ora inizio{" "}
            <input
              type="time"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              required
            />
          </label>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 8,
            }}
          >
            <label style={{ flex: 1 }}>
              ora fine{" "}
              <input
                type="time"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                required
              />
            </label>

            {/* Blocco evento aziendale */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: 4,
                minWidth: 150,
              }}
            >
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  opacity: 0.8,
                  paddingRight: 2,
                }}
              >
                Evento aziendale
              </div>

              <button
                type="button"
                onClick={selectAllRilevatoriAzienda}
                style={{
                  padding: "4px 10px",
                  borderRadius: 999,
                  border: isGlobalRil ? "2px solid #111827" : "1px solid #d1d5db",
                  background: isGlobalRil ? "#e5f2ff" : "#f9fafb",
                  fontSize: 11,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  fontWeight: isGlobalRil ? 700 : 500,
                }}
                title="Evento aziendale per tutti i rilevatori"
              >
                👥 Tutti i Rilevatori
              </button>

              <button
                type="button"
                onClick={selectAllSeniorAzienda}
                style={{
                  padding: "4px 10px",
                  borderRadius: 999,
                  border: isGlobalSnr ? "2px solid #111827" : "1px solid #d1d5db",
                  background: isGlobalSnr ? "#e5f2ff" : "#f9fafb",
                  fontSize: 11,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  fontWeight: isGlobalSnr ? 700 : 500,
                }}
                title="Evento aziendale per tutti i senior"
              >
                🧑‍🏫 Tutti i Senior
              </button>
            </div>
          </div>
        </div>

        <label>
          Titolo{" "}
          <input
            value={titolo}
            onChange={(e) => setTitolo(e.target.value)}
            placeholder="Es. Corso rilevatori"
          />
        </label>

        {/* Flag blocco/accademia */}
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 12,
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <input
            type="checkbox"
            checked={isBlock}
            onChange={(e) => setIsBlock(e.target.checked)}
          />
          Evento accademia / blocco agenda
        </label>

        {/* Colori */}
        <div>
          <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 6 }}>Colore</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {PASTEL_COLORS.concat(["#9aa1a6"]).map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setColor(c)}
                title={c}
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 6,
                  border: color === c ? "3px solid #111" : "1px solid #ddd",
                  background: c,
                  cursor: "pointer",
                }}
              />
            ))}
          </div>
        </div>

        {/* Partecipanti */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {/* Rilevatori */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>
              Rilevatori
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {(rilevatori || []).map((u) => (
                <button
                  type="button"
                  key={u.id}
                  onClick={() => toggleIn(selRil, u.id, setSelRil)}
                  style={selRil.includes(u.id) ? chipOn : chipStyle}
                >
                  {u.nome}
                </button>
              ))}
            </div>
          </div>

          {/* Senior */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>
              Senior
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {(seniori || []).map((u) => (
                <button
                  type="button"
                  key={u.id}
                  onClick={() => toggleIn(selSNR, u.id, setSelSNR)}
                  style={selSNR.includes(u.id) ? chipOn : chipStyle}
                >
                  {u.nome}
                </button>
              ))}
            </div>
          </div>

          {/* Senior Posa */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>
              Senior Posa
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {(seniorPosa || []).map((u) => (
                <button
                  type="button"
                  key={u.id}
                  onClick={() => toggleIn(selSNRP, u.id, setSelSNRP)}
                  style={selSNRP.includes(u.id) ? chipOn : chipStyle}
                >
                  {u.nome}
                </button>
              ))}
            </div>
          </div>

          {/* Formatori */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>
              Formatori
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {(formatori || []).map((u) => (
                <button
                  type="button"
                  key={u.id}
                  onClick={() => toggleIn(selFMT, u.id, setSelFMT)}
                  style={selFMT.includes(u.id) ? chipOn : chipStyle}
                >
                  {u.nome}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 10,
          }}
        >
          {isEdit && (
            <button
              type="button"
              onClick={doDelete}
              style={{ color: "#b91c1c" }}
            >
              Cancella Evento
            </button>
          )}
          <button type="button" onClick={onClose}>
            Annulla
          </button>
          <button type="submit">
            <b>Salva Evento</b>
          </button>
        </div>
      </form>
    </Modal>
  );
}









  /* --- SlotsStripe segnaposto --- */
  function SlotsStripe({ slots = [], onPick = () => {} }) {
    if (!Array.isArray(slots) || !slots.length) return null;
    return (
      <div style={{ display: "flex", gap: 6, margin: "6px 0 10px", flexWrap: "wrap" }}>
        {slots.map((s, i) => (
          <button
            key={i}
            onClick={() => onPick(s)}
            title={`${s.day} ${s.fascia || ""}`}
            style={{ fontSize: 12, borderRadius: 8, padding: "4px 8px",
                    border: "1px solid #e5e7eb", background: "#f9fafb" }}
          >
            {s.day} {s.fascia || ""}
          </button>
        ))}
      </div>
    );
  }

  /* --- util varie usate nella pagina --- */
  function sqlToIso(s) {
    if (!s) return null;
    const t = String(s).trim().replace(" ", "T");
    // FullCalendar accetta "YYYY-MM-DDTHH:mm:ss"
    return t.length === 19 ? t : t.split(".")[0];
  }
  function todayYMD() {
    const d = new Date();
    const p = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  }
  function dateToSql(d) {
    if (!(d instanceof Date)) return null;
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ` +
          `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }
  function pad2(n) { return String(n).padStart(2, "0"); }
  function fmt(d) {
    const pad = pad2;
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  function diffMin(a, b) { return Math.round((a.getTime() - b.getTime()) / 60000); }
  function dayKey(d) {
    const pad = pad2;
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
  }
  function fasciaFromDate(dOrStr) {
    const d = (dOrStr instanceof Date) ? dOrStr : new Date(dOrStr);
    const h = d.getHours();
    if (h < 13) return "M";
    if (h < 18) return "P";
    return "S";
  }
  // Nota: allineo ai tag usati da AgendaCall → formato [KEY:VAL]
  function upsertNoteTag(note, key, value) {
    const re = new RegExp(`\\[${key}:[^\\]]+\\]`, "ig");
    const base = String(note || "").replace(re, "").trim();
    return `${base} [${key}:${value}]`.trim();
  }
  function getNoteTag(note, key) {
    const re = new RegExp(`\\[${key}:([^\\]]+)\\]`, "i");
    const m = String(note || "").match(re);
    return m ? m[1].trim() : null;
  }


// --- helper tag/flag (incolla vicino a getNoteTag/upsertNoteTag) ---
function pickBellStatus(ex = {}) {
  // priorità al campo DB; fallback dal tag [BELL:]
  const v = (ex.bell_status || getNoteTag(ex.note, "BELL") || "").toLowerCase().trim();
  if (["rotto","broken"].includes(v)) return "rotto";
  if (["off","no","assente"].includes(v)) return "assente";
  if (v === "ok") return "ok";
  return ""; // sconosciuto
}

function presInfo(ex = {}) {
  // 1) se libemax_flag=1 => on
  const flag =
    Number(ex.libemax_flag || ex.in_presenze || 0) === 1 ||
    getNoteTag(ex.note, "PRES") === "1";

  // 2) id operatore (se ti serve ancora)
  const byId =
    ex.libemax_by ||
    getNoteTag(ex.note, "PRES_BY") ||
    "";

  // 3) nome operatore (preferito per la UI)
  const byName =
    ex.libemax_by_name ||
    getNoteTag(ex.note, "PRES_BY_NAME") ||
    "";

  return { flag, byId, byName };
}







  function maskPhone(p) {
    const d = String(p || "").replace(/\D+/g, "");
    if (!d) return "";
    const last3 = d.slice(-3);
    return "•".repeat(Math.max(0, d.length - 3)) + last3;
  }
  function canSeePhone(startDate) {
    try {
      const start = startDate instanceof Date ? startDate : new Date(startDate);
      return Date.now() >= (start.getTime() - 20 * 60 * 1000);
    } catch { return false; }
  }
  function initials(name) {
    const parts = String(name || "").trim().split(/\s+/).slice(0, 2);
    return parts.map(p => p[0]?.toUpperCase() || "").join("");
  }
  function addMinutesHHMM(hhmm, minutes) {
    const [h, m] = String(hhmm || "00:00").split(":").map(n => parseInt(n || "0", 10));
    const d = new Date(); d.setHours(h, m, 0, 0);
    d.setMinutes(d.getMinutes() + (minutes || 0));
    return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
  }
  function pickInfissiTotal(e) {
    const n = Number(e?.fori_qta || 0);
    return Number.isFinite(n) ? n : 0;
  }
  function isBlockEvent(ev) {
    const ex     = ev?.extendedProps || {};
    const titolo = String(ex.nome_cliente || ev?.title || "");
    const stato  = String(ex.stato || "").toLowerCase();
    const note   = String(ex.note || "");

    const flagged =
      Number(ex.is_block) === 1 || Number(ex.block) === 1 ||
      stato.includes("bloc") ||
      /(\[BLOCK|BLOCK:|\[LAST:block\])/i.test(note) ||
      titolo.toUpperCase().includes("BLOCCO");

    return !!flagged;
  }

  /* === Normalizza l'esito del Senior in valori stabili ===
    Ritorna soltanto: "", "chiuso", "non_chiuso" */
  function normalizeSeniorEsito(v) {
    const s = String(v ?? "").trim().toLowerCase();
    if (!s) return "";
    if (["1","ok","si","sì","chiuso","closed","success","successo","true"].includes(s)) return "chiuso";
    if (["0","ko","no","non_chiuso","noclose","fail","false"].includes(s)) return "non_chiuso";
    return s;
  }


// Converte prev_pdf_path (URL assoluto, path assoluto o vecchio filename) in URL apribile
function resolvePrevUrl(path, eventId) {
  const s = String(path || '').trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s) || s.startsWith('/')) return s; // già URL o path assoluto
  // legacy: solo filename salvato → costruisco l'URL pubblico standard
  return `/preventivi/uploads/preventivi/${encodeURIComponent(eventId)}/${encodeURIComponent(s)}`;
}

// Chi è il "titolare" dei vincoli orari di questo evento?
function pickOwnerRoleAndId(evOrEx) {
  const ex  = evOrEx?.extendedProps || evOrEx || {};
  const wantSenior = Number(ex.want_senior || ex.pass_to_senior || 0) === 1;
  const sid = Number(ex.senior_id || 0);
  const rid = Number(ex.rilevatore_id || 0);

  // Se è già passato al senior e c'è un senior assegnato → owner = senior
  if (wantSenior && sid > 0) return { role: "senior", id: sid };
  // Altrimenti, finché non è passato al senior → owner = rilevatore (se presente)
  if (!wantSenior && rid > 0) return { role: "rid", id: rid };
  // Nessun owner certo (no controlli “hard” possibili)
  return { role: "", id: 0 };
}






  // === Conflitti rilevatore (SOFT) ===
  const MIN_GAP_MINUTES = 110; // margine richiesto
  const MIN_GAP_SENIOR  = 150;  // senior (appuntamenti più lunghi)

  const _getRid = (e) => Number(e?.extendedProps?.rilevatore_id || 0);

  const _t = (d) => (d instanceof Date ? d.getTime() : new Date(d).getTime());

  // minuti di distanza fra due eventi (positivi se separati, negativi se sovrapposti)
  function gapMinutes(evA, evB) {
    const a1 = _t(evA.start), a2 = _t(evA.end);
    const b1 = _t(evB.start), b2 = _t(evB.end);
    if (a2 <= b1) return Math.round((b1 - a2) / 60000); // A prima di B
    if (b2 <= a1) return Math.round((a1 - b2) / 60000); // B prima di A
    // sovrapposti
    const overlap = Math.min(a2, b2) - Math.max(a1, b1);
    return -Math.round(overlap / 60000);
  }

  // ritorna Set di event.id in conflitto per ciascun rilevatore (chiaro e sicuro)
  // ritorna Set di event.id in conflitto considerando l'“owner” (rilevatore o senior)
function computeOwnerConflicts(events, minGapRid = 120, minGapSr = 150) {
  if (!Array.isArray(events) || events.length < 2) return new Set();

  // raggruppo per chi deve rispettare i vincoli: "rid:<id>" oppure "senior:<id>"
  const groups = new Map();
  for (const e of events) {
    const { role, id } = pickOwnerRoleAndId(e);
    if (!role || !id) continue;
    const key = `${role}:${id}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(e);
  }

  const bad = new Set();

  for (const [key, list] of groups.entries()) {
    const role = key.split(":")[0]; // "rid" | "senior"
    const minGap = role === "senior" ? minGapSr : minGapRid;

    list.sort((a, b) => new Date(a.start) - new Date(b.start));

    for (let i = 0; i < list.length - 1; i++) {
      const A = list[i], B = list[i + 1];
      const A1 = new Date(A.start), A2 = new Date(A.end || A.start);
      const B1 = new Date(B.start), B2 = new Date(B.end || B.start);

      const overlap = A1 < B2 && A2 > B1;
      let gapMin = Infinity;
      if (!overlap) {
        if (A2 <= B1) gapMin = Math.round((B1 - A2) / 60000);
        else if (B2 <= A1) gapMin = Math.round((A1 - B2) / 60000);
      }

      if (overlap || gapMin < minGap) {
        bad.add(String(A.id));
        bad.add(String(B.id));
      }
    }
  }

  return bad;
}








  // messaggio “soft” per un singolo evento contro gli altri dello stesso rid
  function softConflictMessage(ev, others, minGap = MIN_GAP_MINUTES) {
    let worst = null, worstGap = 9e9;
    for (const o of others) {
      const g = gapMinutes(ev, o);
      if (g < minGap && g < worstGap) { worst = o; worstGap = g; }
    }
    if (!worst) return null;
    const who = String(worst.extendedProps?.rilevatore_name || worst.extendedProps?.rilevatore || "").trim();
    const fmt = (d)=> new Date(d).toLocaleTimeString("it-IT",{hour:'2-digit',minute:'2-digit'});
    return `Attenzione: ${who} ha già ${fmt(worst.start)}–${fmt(worst.end)} (margine richiesto ${minGap}′).`;
  }

let __mouse = { x: 0, y: 0 };
if (typeof window !== "undefined") {
  window.addEventListener(
    "mousemove",
    (e) => { __mouse.x = e.clientX; __mouse.y = e.clientY; },
    { passive: true }
  );
}



// chiudi il tip in modo "aggressivo" (annulla timer + nascondi)
function __tipOff(immediate = true) {
  try { Tip.cancel?.(); } catch {}
  try { Tip.hide?.(immediate); } catch {}
}

// se la tab non è attiva o perdi il focus finestra → chiudi subito
if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) __tipOff(true);
  });
  window.addEventListener("blur", () => __tipOff(true));
}













  /**
   * Evidenzia conflitti tra eventi dello stesso rilevatore.
   * Aggiunge la classe "ev-conflict" quando:
   *  - gli eventi si sovrappongono, oppure
   *  - il margine tra fine/inizio è inferiore a minGapMinutes.
   */
  function markConflictsByRilevatore(events, minGapMinutes = 0) {
    if (!Array.isArray(events) || events.length < 2) return;

    // raggruppo per rilevatore, ignorando non assegnati (rid=0)
    const groups = new Map();
    for (const e of events) {
      const rid = Number(e?.extendedProps?.rilevatore_id || 0);
      if (!rid) continue;
      if (!groups.has(rid)) groups.set(rid, []);
      groups.get(rid).push(e);
    }

    // per ogni gruppo, ordino e cerco conflitti
    for (const list of groups.values()) {
      list.sort((a, b) => new Date(a.start) - new Date(b.start));

      for (let i = 0; i < list.length; i++) {
        const A = list[i];
        const aStart = new Date(A.start);
        const aEnd   = new Date(A.end || A.start);

        for (let j = i + 1; j < list.length; j++) {
          const B = list[j];
          const bStart = new Date(B.start);
          const bEnd   = new Date(B.end || B.start);

          // se B inizia ben dopo la fine di A e oltre il margine richiesto, posso uscire
          if (bStart - aEnd > (minGapMinutes || 0) * 60000 && bStart >= aEnd) break;

          const overlap = aStart < bEnd && aEnd > bStart;
          const gapMin = Math.min(Math.abs(bStart - aEnd), Math.abs(aStart - bEnd)) / 60000;

          if (overlap || (minGapMinutes > 0 && gapMin < minGapMinutes)) {
            A.classNames = Array.from(new Set([...(A.classNames || []), "ev-conflict"]));
            B.classNames = Array.from(new Set([...(B.classNames || []), "ev-conflict"]));
          }
        }
      }
    }
  }













/* ==== helper stato/tempo per le regole colore ==== */
/* ==== helper stato/tempo per le regole colore ==== */
function isConfirmed(ex) {
  const s = String(ex?.stato || "").toLowerCase();
  return s === "confermato" || !!ex?.confirmed_at;
}
function isCancelled(ex) {
  return String(ex?.stato || "").toLowerCase() === "annullato";
}
function isAlertDayBefore(ex) {
  try {
    const startIso = sqlToIso?.(ex.start_dt) || ex.start || "";
    if (!startIso) return false;
    const start = new Date(startIso);
    const now = new Date();
    // vero se è “domani” rispetto a oggi e NON confermato
    return dayDiff(start, now) === 1 && !isConfirmed(ex);
  } catch { return false; }
}

/* ==== Regole COLORI v5 – pulsanti indipendenti + POSA ==== 
   Priorità:
   1) senior_esito = chiuso -> VERDE SCURO
   2) flag POSA (in_posa/posa_flag/posa_transfer_at) -> VIOLA
   3) senior_esito = non_chiuso -> ROSSO
   4) rilievo non buono -> ROSA
   5) passa al senior (oro)
   6) rilevatore assegnato (azzurro)
   7) annullato (grigio chiaro)
   8) confermato (verde)
   9) default (grigio)
*/
function computeEventStyle(ex = {}) {
  const stato       = String(ex.stato || "").toLowerCase();
  const wantSenior  = Number(ex.want_senior || ex.pass_to_senior || 0) === 1;
  const rilNonBuono = Number(ex.ril_non_buono || 0) === 1;
  const rid         = Number(ex.rilevatore_id || 0);
  const sid         = Number(ex.senior_id || 0);
  const srEsito     = normalizeSeniorEsito(ex.senior_esito ?? ex.esito_senior ?? "");

  // NEW: rileva POSA da qualunque campo
  const posaFlag =
    Number(ex.posa_flag || ex.in_posa || ex._posa || 0) === 1 ||
    !!ex.posa_transfer_at;









    






  // 1) Esito Senior — VINCE SEMPRE (verde scuro)
  if (srEsito === "chiuso") {
    return { backgroundColor: UI_COLORS.darkGreen, borderColor: UI_COLORS.borderGold, classNames: ["ev-sr-win"] };
  }

  // 2) POSA — VIOLA (sovrascrive il rosso dopo il trasferimento)
  if (posaFlag) {
    return { backgroundColor: UI_COLORS.violet, borderColor: UI_COLORS.borderViolet, classNames: ["ev-posa"] };
  }

  // 3) Esito Senior non chiuso — ROSSO
  if (srEsito === "non_chiuso") {
    return { backgroundColor: UI_COLORS.red, borderColor: UI_COLORS.red, classNames: ["ev-sr-lose"] };
  }

  // 4) Rilievo non buono — ROSA
  if (rilNonBuono) {
    return { backgroundColor: UI_COLORS.pink, borderColor: UI_COLORS.pink, classNames: ["ev-ril-ko"] };
  }

  // 5) Passa al Senior — ORO (border rosso se senior assegnato)
  if (wantSenior) {
    const border = sid > 0 ? UI_COLORS.borderRed : UI_COLORS.borderGold;
    return { backgroundColor: UI_COLORS.gold, borderColor: border, classNames: ["ev-hot"] };
  }

  // 6) Rilevatore assegnato — AZZURRO
  if (rid > 0) {
    return { backgroundColor: UI_COLORS.blue, borderColor: UI_COLORS.blue, classNames: ["ev-ril"] };
  }

  // 7) Annullato — grigio (solo se nulla di sopra si applica)
  if (stato === "annullato") {
    return { backgroundColor: "#e5e7eb", borderColor: UI_COLORS.grey, classNames: ["ev-cancel"] };
  }

  // 8) Confermato — VERDE
  if (isConfirmed(ex)) {
    return { backgroundColor: UI_COLORS.green, borderColor: UI_COLORS.green, classNames: [] };
  }

  // 9) Default — grigio
  return { backgroundColor: UI_COLORS.grey, borderColor: UI_COLORS.grey, classNames: [] };
}





/* ==== Solo regole + alert bordo rosso “giorno prima” se non confermato ==== */
/* ==== Solo regole + alert bordo rosso “giorno prima” se non confermato ==== */
function styleFromRulesOnly(ex = {}) {
  const base = computeEventStyle(ex);
  if (isAlertDayBefore(ex) && !isConfirmed(ex)) {
    base.borderColor = UI_COLORS.borderRed;
    base.classNames = [...(base.classNames || []), "ev-alert"];
  }
  return base;
}


/* === helper: da "S3S" → "ui-s3s" (coerente col CSS .fc-event.ui-s*) === */
function uiStateClass(code) {
  const s = String(code || "").trim().toLowerCase(); // "S3S" -> "s3s"
  return s ? `ui-${s}` : "";
}



// mappa stati DB (S*) → stile
// mappa stati DB → stile
// mappa stati DB (S*) → stile
function mapUiStateToStyle(code = "S0", ex = {}) {
  const c   = String(code || "S0").toUpperCase();
  const uic = uiStateClass(c); // "S3S" -> "ui-s3s"
  switch (c) {
    case "S6": // senior chiuso → verde scuro + bordo oro
      return { backgroundColor: UI_COLORS.darkGreen, borderColor: UI_COLORS.borderGold, classNames: [uic, "ev-sr-win"] };

    case "S8": // in posa → viola
      return { backgroundColor: UI_COLORS.violet, borderColor: UI_COLORS.borderViolet, classNames: [uic, "ev-posa"] };

    case "S5": // senior non chiuso → rosso
      return { backgroundColor: UI_COLORS.red, borderColor: UI_COLORS.red, classNames: [uic, "ev-sr-lose"] };

    case "S4": // rilievo non buono → pink‑chiaro
      return { backgroundColor: UI_COLORS.pink, borderColor: UI_COLORS.pink, classNames: [uic, "ev-ril-ko"] };

    case "S3S": // passa al senior + senior assegnato → oro (bordo oro)
      return { backgroundColor: UI_COLORS.gold, borderColor: UI_COLORS.borderGold, classNames: [uic, "ev-hot"] };

    case "S3":  // passa al senior (nessun senior assegnato) → oro (bordo rosso)
      return { backgroundColor: UI_COLORS.gold, borderColor: UI_COLORS.borderRed, classNames: [uic, "ev-hot"] };

    case "S2":  // assegnato a rilevatore → azzurro
      return { backgroundColor: UI_COLORS.blue, borderColor: UI_COLORS.blue, classNames: [uic, "ev-ril"] };

    case "S7":  // annullato → marrone chiaro
      return { backgroundColor: UI_COLORS.brownLight, borderColor: UI_COLORS.borderBrown, classNames: [uic, "ev-cancel"] };

    case "S9":  // in gestione → arancione (bordo rosso)
      return { backgroundColor: UI_COLORS.orange, borderColor: UI_COLORS.borderRed, classNames: [uic, "ev-gestione"] };


   case "S10": // da spostare → giallo chiaro
     return { backgroundColor: UI_COLORS.lemon, borderColor: UI_COLORS.borderLemon, classNames: [uic, "ev-da-spostare"] };


    case "S1":  // confermato → verde chiaro
      return { backgroundColor: UI_COLORS.green, borderColor: UI_COLORS.green, classNames: [uic] };

    case "S0":
    default:    // default → grigio
      return { backgroundColor: UI_COLORS.grey, borderColor: UI_COLORS.grey, classNames: [uic] };
  }
}



// ======== STILE SOLO-DB (STRICT) ========
function styleFromDBStrict(ex = {}) {
  // 1) Colori pronti? uso quelli, ma attacco comunque ui-s*
  if (ex.ui_bg) {
    const base = {
      backgroundColor: ex.ui_bg,
      borderColor:     ex.ui_border || ex.ui_bg,
      classNames:      [],
    };
    // eventuali tag dalla vista (es. "ev-hot ev-sr-win")
    const tags = String(ex.ui_tags || "").split(/\s+/).filter(Boolean);
    base.classNames.push(...tags);

    // se ho anche il codice, attacco la ui-s*
    const code = String(ex.ui_state_code || ex.ui_state || ex.ui || "").toUpperCase();
    if (code) base.classNames.push(uiStateClass(code));
    return base;
  }

  // 2) Se ho il codice S*, mappo (aggiunge ui-s* internamente)
  const code = String(ex.ui_state_code || ex.ui_state || ex.ui || "").toUpperCase();
  if (code) return mapUiStateToStyle(code, ex);

  // 3) Default: grigio + ui-s0
  return { backgroundColor: UI_COLORS.grey, borderColor: UI_COLORS.grey, classNames: [uiStateClass('S0')] };
}


// === Stile robusto: se senior_esito=chiuso, vince SEMPRE il verde scuro ===
function styleFromDBSafe(ex = {}) {
  const code = String(ex.ui_state_code || ex.ui_state || '').toUpperCase();
  const sr   = normalizeSeniorEsito(ex.senior_esito ?? ex.esito_senior ?? "");

 // Da spostare (S10) → giallo chiaro con priorità alta
 if (code === 'S10' || String(ex.stato || '').toLowerCase() === 'da_spostare') {
   return { backgroundColor: UI_COLORS.lemon, borderColor: UI_COLORS.borderLemon, classNames: ["ui-s10","ev-da-spostare"] };
 }


  // In gestione → arancione, PRIORITARIO
  if (code === 'S9') {
    return { backgroundColor: UI_COLORS.orange, borderColor: UI_COLORS.borderRed, classNames: ["ui-s9","ev-gestione"] };
  }

  // Esiti senior
  if (sr === "chiuso") {
    return { backgroundColor: UI_COLORS.darkGreen, borderColor: UI_COLORS.borderGold, classNames: ["ui-s6","ev-sr-win"] };
  }
  if (sr === "non_chiuso") {
    return { backgroundColor: UI_COLORS.red, borderColor: UI_COLORS.red, classNames: ["ui-s5","ev-sr-lose"] };
  }

  // altrimenti, mappa DB
  return styleFromDBStrict(ex);
}





















// matrice //
// ===== Matrice permessi per ruolo (v4) =====

/**
 * Normalizza il nome ruolo alle chiavi interne.
 */
function normalizeRole(role) {
  const r = String(role || "user").trim().toLowerCase();

  if (["admin", "amministratore", "root"].includes(r)) return "admin";
  if (["formatore", "trainer"].includes(r)) return "trainer";
  if (["centralino","callcenter","call center","ufficio","backoffice","back office"].includes(r)) return "backoffice";
  if (["rilevatore","rilievo","ril","junior","tecnico","field"].includes(r)) return "rilevatore";
  if (["senior","tecnico_senior","tecnico senior"].includes(r)) return "senior";
  if (["senior_posa","seniorposa","posa","posa_senior","posa senior"].includes(r)) return "senior_posa";
  if (["responsabile_zona","responsabile-di-zona","responsabile","resp"].includes(r)) return "responsabile_zona";
  return "user";
}

/**
 * Merge sicuro dei permessi: un deny (false) da DB o Matrix vince sempre.
 * Se non ci sono deny, vince l'OR tra ruolo/DB/Matrix; altrimenti il valore base.
 */
function mergeCaps(base, roleCaps = {}, dbCaps = null, matrixCaps = null) {
  const keys = new Set([
    ...Object.keys(base),
    ...Object.keys(roleCaps || {}),
    ...(dbCaps ? Object.keys(dbCaps) : []),
    ...(matrixCaps ? Object.keys(matrixCaps) : []),
  ]);

  const out = {};
  for (const k of keys) {
    const baseVal = base[k];
    const votes = [
      roleCaps ? roleCaps[k] : undefined,
      dbCaps ? dbCaps[k] : undefined,
      matrixCaps ? matrixCaps[k] : undefined,
    ];

    // Deny esplicito da DB o Matrix blocca sempre
    const hardDeny = [dbCaps, matrixCaps].some(src => src && src[k] === false);
    if (hardDeny) { out[k] = false; continue; }

    // Qualsiasi allow esplicito abilita
    const anyAllow = votes.some(v => v === true);
    out[k] = anyAllow ? true : (roleCaps[k] ?? baseVal ?? false);
  }
  return out;
}

/**
 * Rende coerenti flag correlati (readOnly, zona ecc.).
 */
function postProcessCaps(caps) {
  const out = { ...caps };

  // Se readOnly, disattiva tutte le azioni can*
  if (out.readOnly) {
    for (const k of Object.keys(out)) {
      if (k.startsWith("can")) out[k] = false;
    }
    // ma preserva i flag di visualizzazione
    out.readOnly = true;
  }

  // Coerenza zone: se blocco zona è attivo, niente multi-zona
  if (out.zoneLock) out.zoneMulti = false;

  return out;
}

/**
 * Quali ruoli sono visibili sulle diverse agende.
 * Senior POSA lavora solo su AgendaPosa (su AgendaPro non mostriamo nulla).
 */
function visibleForRole(role, page /* "AgendaPro" | "AgendaPosa" */) {
  const r = normalizeRole(role);
  if (page === "AgendaPro") {
    return !["senior_posa"].includes(r);
  }
  if (page === "AgendaPosa") {
    return ["senior_posa", "trainer", "admin"].includes(r);
  }
  // Altre pagine: visibile di default
  return true;
}

/**
 * ===== Funzione principale =====
 * Deriva i permessi finali per un ruolo, convalidandoli con DB e Matrix.
 *
 * @param {string} role - ruolo utente (es. "admin", "rilevatore", "senior_posa", ecc.)
 * @param {object} [opts]
 * @param {object|null} [opts.dbPerms]    - Permessi dal DB (solo chiavi interessate), true/false
 * @param {object|null} [opts.matrixPerms]- Permessi dalla pagina Matrix (se presente), true/false
 * @param {string|null} [opts.page]       - Contesto pagina (es. "AgendaPro" | "AgendaPosa")
 * @returns {object} caps finali
 */
function deriveRoleCaps(role, { dbPerms = null, matrixPerms = null, page = null } = {}) {
  const r = normalizeRole(role);

  // Base: tutto spento a meno di specifica contraria
  const base = {
    /* azioni */
    canMoveEvent: false,
    canConfirm: false,
    canAssignRilevatore: false,
    canAssignSenior: false,
    canCancel: false,
    canReset: false,
    canDelete: false,
    canToggleSeniorWant: false,
    canMarkRilNonBuono: false,
    canSetSeniorEsito: false,
    canUsePreventivatore: false,
    canUploadFiles: false,
    canEditBudgets: false,

    /* visualizzazione/limitazioni */
    phoneDelay: false,
    readOnly: false,
    restrictAssignedOnly: false,

    /* NEW */
    canPushToPosa: false,
    zoneLock: false,
    zoneMulti: false,


    /* NEW: visibilità overlay UI (pallini + 🌐) */
    showOverlaysUi: false,

  };

  // Permessi predefiniti per ruolo
  let roleCaps = {};
  switch (r) {
    case "admin":
      roleCaps = {
        ...base,
        canMoveEvent: true, canConfirm: true, canAssignRilevatore: true, canAssignSenior: true,
        canCancel: true, canReset: true, canDelete: true,
        canToggleSeniorWant: true, canMarkRilNonBuono: true, canSetSeniorEsito: true,
        canUsePreventivatore: true, canUploadFiles: true, canEditBudgets: true,
        phoneDelay: false,
        canPushToPosa: true,  // admin può pushare verso Posa
        zoneLock: false,
        zoneMulti: true,      // admin può gestire multi-zona
        showOverlaysUi: true,
      };
      break;

    case "trainer":
      roleCaps = {
        ...base,
        canMoveEvent: true, canConfirm: true, canAssignRilevatore: true, canAssignSenior: true,
        canCancel: true, canReset: true,
        canToggleSeniorWant: true, canMarkRilNonBuono: true, canSetSeniorEsito: true,
        canUsePreventivatore: true, canUploadFiles: true, canEditBudgets: true,
        phoneDelay: false,
        canPushToPosa: true,
        zoneLock: false,
        zoneMulti: true,
        showOverlaysUi: true,
      };
      break;

    case "backoffice":
      roleCaps = {
        ...base,
        canMoveEvent: true, canConfirm: true, canAssignRilevatore: true,
        canCancel: true, canReset: true,
        phoneDelay: false,
        showOverlaysUi: true,
        // niente canDelete / canAssignSenior di default
      };
      break;

    case "rilevatore":
      roleCaps = {
        ...base,
        canToggleSeniorWant: true,      // marca "buono"
        canMarkRilNonBuono: true,       // marca "non fissabile"
        canUsePreventivatore: true, canUploadFiles: true, canEditBudgets: true,
        phoneDelay: true,               // telefono solo -20'
      };
      break;

    case "senior":
      roleCaps = {
        ...base,
        canSetSeniorEsito: true,        // chiuso / non chiuso
        canToggleSeniorWant: true,
        canMarkRilNonBuono: true,
        canUsePreventivatore: true, canUploadFiles: true, canEditBudgets: true,
        phoneDelay: true,
      };
      break;

    // Senior POSA (lavora su AgendaPosa, non su AgendaPro)
    case "senior_posa":
      roleCaps = {
        ...base,
        canSetSeniorEsito: true,
        canUsePreventivatore: true, canUploadFiles: true, canEditBudgets: true,
        phoneDelay: true,
        // su AgendaPro non gli mostriamo nulla (vedi visibleForRole)
      };
      break;

    // Responsabile di zona — sola lettura + solo eventi assegnati
    case "responsabile_zona":
      roleCaps = {
        ...base,
        readOnly: true,
        restrictAssignedOnly: true,
        phoneDelay: false,
        zoneLock: true,   // bloccato alla propria zona di competenza
        zoneMulti: false,
        showOverlaysUi: true,
      };
      break;

    default:
      roleCaps = { ...base };
  }

  // Merge con DB e Matrix (se presenti). Deny esplicito vince sempre.
  const merged = mergeCaps(base, roleCaps, dbPerms, matrixPerms);

  // Coerenza finale (readOnly disattiva can*, zoneLock vs zoneMulti, ecc.)
  const finalCaps = postProcessCaps(merged);

  // Facoltativo: se vuoi basarti sulla pagina, puoi annullare tutto quando non visibile.
  if (page && !visibleForRole(r, page)) {
    // Se la pagina non è rilevante per il ruolo, restituisci caps "inerti"
    return postProcessCaps({
      ...base,
      readOnly: true,
      restrictAssignedOnly: true,
      phoneDelay: finalCaps.phoneDelay, // mantiene eventuale vincolo telefonico
      zoneLock: finalCaps.zoneLock,
      zoneMulti: false,
    });
  }

  return finalCaps;
}

// ---- Esempi d'uso ----
// const caps = deriveRoleCaps("senior", { dbPerms: { canDelete: false }, matrixPerms: { canMoveEvent: true }, page: "AgendaPro" });
// const visibile = visibleForRole("senior_posa", "AgendaPro");














// ===================== ActionModal (COMPLETO con FIX KM) =====================
function ActionModal(props) {
  const {
    open,
    onClose,
    event,
    operatorId = 0,
    rilevatori = [],
    seniori = [],
    caps: capsIn,
    overlays = [],
    onDidChange = () => {},
    meEmail = "",             // 👈 nuovo: mail del rilevatore/loggato
  } = props;

    const opId = Number(operatorId || 0);   // 👈 AGGIUNGI


  /* ===== Permessi (derivati) ===== */
  const C = React.useMemo(() => capsIn || deriveRoleCaps("admin"), [capsIn]);

  /* ===== State principali ===== */
/* ===== State principali ===== */
const [saving, setSaving] = React.useState(false);
const [linkLoading, setLinkLoading] = React.useState(false);
const [prevUrl, setPrevUrl] = React.useState("");




  // Stato per invio mail PDF manuale
const [mailOpen, setMailOpen] = React.useState(false);
const [mailSending, setMailSending] = React.useState(false);
const [mailForm, setMailForm] = React.useState({
  from: "",
  to: "",
  subject: "",
  body: "",
});






// ✅ toast “salvato”
const [savedOk, setSavedOk] = React.useState(0);


  /* ====== Dati evento derivati (DEVONO stare in alto) ====== */
  const ex  = event?.extendedProps || {};

 const isDaSpostare = String(ex.stato || '').toLowerCase() === 'da_spostare'
                   || String(ex.ui_state_code || '').toUpperCase() === 'S10';


  const eid = Number(event?.id || 0);
  const d   = event?.start
    ? (event.start instanceof Date ? event.start : new Date(event.start))
    : new Date();

  /* --- Target helper --- */
  function parsePreventivoJson(raw) {
    if (!raw) return null;
    try { const obj = typeof raw === "string" ? JSON.parse(raw) : raw; return obj && typeof obj === "object" ? obj : null; }
    catch { return null; }
  }
  function pickTargetValue(src = {}) {
    let v = src.pv_total ?? src.preventivo_target_eur ?? null;
    if (v == null && src.preventivo_json) {
      const pj = parsePreventivoJson(src.preventivo_json);
      const t  = pj?.totals?.target;
      if (t != null) v = t;
    }
    if (v == null && src.target != null) v = src.target;
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

// stato locale per il PDF del preventivatore
const [prevQuoteId, setPrevQuoteId] = React.useState(null);
const [prevPdfUrl,  setPrevPdfUrl]  = React.useState("");


  



  /* ===== form locale ===== */
const [form, setForm] = React.useState(() => ({
  pv_total: pickTargetValue(ex),
  pv_budget: Number(ex.pv_budget_rilevatore_eur ?? ex.pv_budget ?? 0) || 0,
  pv_budget_senior_eur: Number(ex.pv_budget_senior_eur ?? 0) || 0,

  // 🔵 NUOVO: dati finanziamento
  real_finanziato: Number(ex.real_finanziato ?? 0) === 1,
  real_mesi: Number(ex.real_mesi ?? ex.finanziamento_mesi ?? 0) || 0,

  audio_path: String(ex.audio_path || ""),
  pdf_path: String(ex.pdf_path || ""),
  km_arrivo: String(ex.km_arrivo || ""),
}));

  const setField = React.useCallback((k, v) => setForm((s) => ({ ...s, [k]: v })), []);

  /* === Prefetch link+target quando si apre la modale === */
/* === Prefetch link+target quando si apre la modale === */
React.useEffect(() => {
  if (!open || !eid) return;
  let aborted = false;

  (async () => {
    try {
      const r = await fetch("/preventivi/agenda/api/link_preventivatore.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ event_id: eid }),
      });
      const j = await r.json().catch(() => ({}));
      if (aborted || j?.status !== "OK") return;

      if (j.url) setPrevUrl(String(j.url));
      if (j.quote_id != null) setPrevQuoteId(String(j.quote_id));
      if (j.pdf_url) setPrevPdfUrl(String(j.pdf_url));

      const tg = Number(j.target ?? j.target_eur ?? 0);
      if (Number.isFinite(tg) && tg > 0) {
        setForm((s) =>
          Number(s.pv_total || 0) > 0 ? s : { ...s, pv_total: tg }
        );
      }
    } catch {}
  })();

  return () => {
    aborted = true;
  };
}, [open, eid]);






// === Rientro dal Preventivatore: aggiorna quote/pdf quando la finestra torna in focus ===
React.useEffect(() => {
  if (!open || !eid) return;

  const onFocus = async () => {
    try {
      const r = await fetch("/preventivi/agenda/api/link_preventivatore.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ event_id: eid }),
      });
      const j = await r.json().catch(() => ({}));
      if (j?.status !== "OK") return;

      if (j.url) setPrevUrl(String(j.url));
      if (j.quote_id != null) setPrevQuoteId(String(j.quote_id));




      // Se l'API ci dà il PDF diretto, usalo e PERSISTILO sul record evento
              if (j.pdf_url) {
          const pdfUrl = String(j.pdf_url);
          setPrevPdfUrl(pdfUrl);

          try {
            await apiPostForm("/preventivi/agenda/api/update_event.php", {
              id: eid,
              ...persistTimes(),
              prev_pdf_path: pdfUrl,
              preventivo_pdf: pdfUrl,
              preventivatore_pdf: pdfUrl,
              operator_id: opId,
              updated_by_operator_id: opId,
            });
            onDidChange?.();
          } catch {
            /* no-op */
          }
        }


      // Target aggiornato dal preventivatore → se il form è vuoto, prefilla
      const tg = Number(j.target ?? j.target_eur ?? 0);
      if (Number.isFinite(tg) && tg > 0) {
        setForm((s) => (Number(s.pv_total || 0) > 0 ? s : { ...s, pv_total: tg }));
      }
    } catch {
      /* no-op */
    }
  };

  window.addEventListener("focus", onFocus);
  return () => window.removeEventListener("focus", onFocus);
}, [open, eid, apiPostForm, persistTimes, onDidChange, setForm]);

/* ===== ESC chiude ===== */
React.useEffect(() => {
  if (!open) return;
  const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
  window.addEventListener("keydown", onKey);
  return () => window.removeEventListener("keydown", onKey);
}, [open, onClose]);

// === Toast "Salvato ✓" auto-hide ===
React.useEffect(() => {
  if (!savedOk) return;
  const t = setTimeout(() => setSavedOk(0), 1200);
  return () => clearTimeout(t);
}, [savedOk]);









  /* ===== helper tempi coerenti nei PATCH ===== */
  function persistTimes() {
    // ⚠️ Fonte unica: l’istanza FullCalendar (è sempre aggiornata dopo il drag)
    const s = dateToSql(event.start);
    const e = dateToSql(event.end || event.start);
    const fascia  = fasciaFromDate(s);
    const zona_id = Number(event?.extendedProps?.zona_id ?? ex.zona_id ?? 0);
    const out = { start_dt: s, end_dt: e, fascia };
    if (zona_id > 0) out.zona_id = zona_id;
    return out;
  }

  /* ===== PATCH evento ===== */
  async function savePatch(patch) {


 if (blockPosa()) return;   

    setSaving(true);
    try {
      const opid = Number(operatorId || 0);
      const payload = { id: eid, ...patch };
      if (opid > 0) {
        payload.operator_id = opid;
        payload.updated_by_operator_id = opid;
      }
      await apiPostForm("/preventivi/agenda/api/update_event.php", payload);
      onDidChange?.();
    } catch (err) {
      alert(err.message || "Errore salvataggio");
      throw err;
    } finally { setSaving(false); }
  }






/* ===== Salvataggio campi della form (Target/Budget/Allegati/Km) ===== */
const saveFields = React.useCallback(async () => {
  if (blockPosa()) return;

  const curTarget = pickTargetValue(ex);
  const tgtNum = Number(form.pv_total);
  const pv_total_to_send =
    Number.isFinite(tgtNum) && tgtNum >= 0 ? tgtNum : curTarget;

  const budgetRil = Number(form.pv_budget) || 0;
  const budgetSr  = Number(form.pv_budget_senior_eur) || 0;

  await savePatch({
    ...persistTimes(),

    // === TARGET ===
    pv_total: pv_total_to_send,

    // === BUDGET RILEVATORE ===
    pv_budget_rilevatore_eur: budgetRil,
    pv_budget:                budgetRil,
    budget_rilevatore_eur:    budgetRil,

    // === REAL / BUDGET SENIOR ===
    pv_budget_senior_eur: budgetSr,
    pv_real:              budgetSr,
    real_eur:             budgetSr,

    // 🔵 NUOVO: FINANZIAMENTO
    real_finanziato: form.real_finanziato ? 1 : 0,
    real_mesi:       Number(form.real_mesi || 0) || 0,

    // === ALLEGATI ===
    audio_path: String(form.audio_path || ""),
    pdf_path:   String(form.pdf_path   || ""),

    // === KM ===
    km_arrivo:  String(form.km_arrivo  || ""),
  });
}, [form, ex, savePatch, persistTimes]);











  /* ===== Derivati UI ===== */
  const HH  = (x) => String(x.getHours()).padStart(2, "0");
  const MM  = (x) => String(x.getMinutes()).padStart(2, "0");
  const ora = `${HH(d)}:${MM(d)}`;

  const nome   = String(ex.nome_cliente || ex.cliente_nome || "Cliente");
  const seePh  = !C.phoneDelay || (event?.start && canSeePhone(event.start));
  const telRaw = String(ex._telView || ex.cliente_telefono || "").trim();
  const telShow = seePh ? (telRaw || "—") : `${maskPhone(telRaw)}  (20′ prima)`;
  const addr    = String(ex.cliente_indirizzo || "—");
  const comune  = String(ex._comuneView || ex.comune || "—").trim();
  const cap     = String(ex.cap || "—");
  const comuneCap = `${comune} · ${cap}`;

  const rid = Number(ex.rilevatore_id || 0);
  const sid = Number(ex.senior_id || 0);
  const seniorEsito = normalizeSeniorEsito(ex.senior_esito ?? ex.esito_senior ?? "");





  // è in POSA se c'è la flag o la data di trasferimento
const isPushedToPosa = React.useMemo(
  () => Number(ex.posa_flag || 0) === 1 || !!ex.posa_transfer_at,
  [ex.posa_flag, ex.posa_transfer_at]
);




// In AgendaPro gli eventi in POSA sono di fatto "sola lettura"
const isPosaReadOnly = isPushedToPosa;

// Avvisa e blocca eventuali modifiche
const blockPosa = React.useCallback(
  (msg = "Appuntamento trasferito in POSA: non è modificabile da questa Agenda.") => {
    if (!isPosaReadOnly) return false;
    alert(msg);
    return true;
  },
  [isPosaReadOnly]
);


  // === Email cliente / mittente ===
  const clientEmail = String(ex.cliente_email || ex.email || "").trim();
  const fromEmail   = String(meEmail || "").trim();   // mittente = utente loggato
  const toEmail     = clientEmail;                    // destinatario = cliente


  // Prefill form mail quando apro la modale
  React.useEffect(() => {
    if (!open) return;

    const dataApp = (ex.start_dt || ex.start || "").slice(0, 10) || "";
    const defaultSubject = dataApp
      ? `Preventivo infissi – appuntamento del ${dataApp}`
      : "Preventivo infissi";

    const defaultBody =
      "Buongiorno,\n\n" +
      "le inviamo il preventivo relativo al sopralluogo effettuato.\n" +
      "In caso di dubbi o modifiche non esiti a contattarci.\n";

  setMailForm({
    from: fromEmail || "",
    to: toEmail || "",
    subject: defaultSubject,
    body: defaultBody,
  });



    setMailOpen(false);
    setMailSending(false);
  }, [open, fromEmail, toEmail, ex.start_dt, ex.start]);






  // Invio mail con PDF manuale
   const sendPdfMail = React.useCallback(async () => {
  if (blockPosa()) return;

  const pdfUrl = String(form.pdf_path || "").trim();
  if (!pdfUrl) {
    alert("Non c'è nessun PDF manuale da inviare (campo vuoto).");
    return;
  }

  // Usa quello che l'utente ha scritto nel box, con fallback ai default
  const to   = String(mailForm.to   || toEmail   || "").trim();
  const from = String(mailForm.from || fromEmail || "").trim();

  if (!to) {
    alert("Manca l'email del cliente (campo 'A').");
    return;
  }

  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRe.test(to)) {
    alert("L'indirizzo email del cliente non sembra valido.");
    return;
  }

  if (!from) {
    alert("Manca l'email del mittente (campo 'Da').");
    return;
  }

  setMailSending(true);
  try {
    const payload = {
      event_id: eid,
      pdf_url: pdfUrl,
      to,
      from,
      subject: String(mailForm.subject || "").trim(),
      body: String(mailForm.body || "").trim(),
    };

    const r = await fetch("/preventivi/mailtoclient/send_pdf.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    });
    const txt = await r.text();
    let j = {};
    try { j = JSON.parse(txt); } catch {}

    if (!r.ok || j.status !== "OK") {
      throw new Error(j.message || `HTTP ${r.status}`);
    }

    alert("Mail inviata al cliente.");
    setMailOpen(false);
  } catch (err) {
    alert(err?.message || "Errore durante l'invio della mail.");
  } finally {
    setMailSending(false);
  }
}, [
  blockPosa,
  form.pdf_path,
  mailForm.subject,
  mailForm.body,
  mailForm.from,
  mailForm.to,
  eid,
  fromEmail,
  toEmail,
]);








  // Campanello / Presenze
  const bell = pickBellStatus(ex);
  const bellLabel =
    bell === "rotto"   ? "No Campanello" :
    bell === "assente" ? "No campanello"    :
    bell === "ok"      ? "Campanello OK"     : "—";
  const { flag: presFlag } = presInfo(ex);

  
  

  // Dati per il prefill del R012 (id appuntamento, anagrafiche e data/ora)
const r012App = React.useMemo(() => {
  const startSql = (ex.start_dt || (event?.start ? dateToSql(event.start) : '') || '');
  const ymd = startSql ? startSql.slice(0, 10) : '';
  return {
    id: eid,
    cliente_nome: nome,
    // telefono solo se visibile (rispetta delay -20')
    telefono: seePh ? (telRaw || '') : '',
    indirizzo: addr && addr !== '—' ? addr : '',
    data: ymd,
    ora: ora
  };
}, [eid, nome, seePh, telRaw, addr, ex.start_dt, event?.start, ora]);





  
  
  
  
  
  /* ===== selettori assegnazioni ===== */
  const [selRid, setSelRid] = React.useState(Number(ex.rilevatore_id || 0));
  const [selSid, setSelSid] = React.useState(Number(ex.senior_id || 0));
  const [okRid, setOkRid] = React.useState(false);
  const [okSid, setOkSid] = React.useState(false);
  const flash = (setter, ms = 1600) => { setter(true); window.setTimeout(() => setter(false), ms); };

 
 
 // === DISASSEGNA SOLO (senza usare action) ===
// === DISASSEGNA SOLO (senza usare action) ===
// DISASSEGNA RILEVATORE (senza mandare rilevatore_id:0)
/* ======================= DISASSEGNA / ASSEGNA ======================= */

// ✅ DISASSEGNA RILIEVATORE SENZA PASSARE action
const unassignRid = async () => {
  try {
    setSaving(true);
    await apiPostForm("/preventivi/agenda/api/update_event.php", {
      id: eid,
      ...persistTimes(),
      clear_rilevatore: 1,
      ui_state_code: "S1",
      ui_state_at: dateToSql(new Date()),
      operator_id: Number(operatorId || 0),
      updated_by_operator_id: Number(operatorId || 0),
    });
    setSelRid(0);
    onDidChange?.();
  } finally {
    setSaving(false);
  }
};

// ✅ DISASSEGNA SENIOR SENZA passare action
const unassignSid = async () => {
  try {
    setSaving(true);
    const wantSenior = Number(ex?.want_senior || ex?.pass_to_senior || 0) === 1;
    await apiPostForm("/preventivi/agenda/api/update_event.php", {
      id: eid,
      ...persistTimes(),
      clear_senior: 1,
      ui_state_code: wantSenior ? "S3" : "S1",
      ui_state_at: dateToSql(new Date()),
      operator_id: Number(operatorId || 0),
      updated_by_operator_id: Number(operatorId || 0),
    });
    setSelSid(0);
    onDidChange?.();
  } finally {
    setSaving(false);
  }
};




/** Cambio selezione Rilevatore: salva subito */
const onChangeRid = async (e) => {
  const v = Number(e?.target?.value ?? 0);
  setSelRid(v);

  // --- BUSY by overlay (rilevatore) ---
  try {
    const evStart = event?.start ? dateToSql(event.start) : (ex.start_dt || "");
    const evEnd   = event?.end   ? dateToSql(event.end)   : (ex.end_dt   || evStart);
    if (v > 0 && hasOverlayConflictFor(v, 'ril', evStart, evEnd, overlays || [])) {
      alert("Questo rilevatore è impegnato in un BLOCCO (es. corso/riunione) che copre quell'orario.");
      setSelRid(Number(ex.rilevatore_id || 0)); // revert UI
      return;
    }
  } catch {}

  // Blocchi hard già presenti
  if (isDaSpostare) {
    alert("Appuntamento marcato 'da spostare': non è possibile assegnare il rilevatore.");
    setSelRid(Number(ex.rilevatore_id || 0));
    return;
  }
  if (blockPosa()) { setSelRid(Number(ex.rilevatore_id || 0)); return; }
  if (!C?.canAssignRilevatore) {
    alert("Non hai i permessi per assegnare il rilevatore.");
    setSelRid(Number(ex.rilevatore_id || 0));
    return;
  }
  if (saving) return;

  try {
    if (v === 0) {
      await unassignRid();
    } else if (Number.isFinite(v) && v > 0) {
      await applyState("assign_rid", { rilevatore_id: v });
    } else {
      setSelRid(Number(ex.rilevatore_id || 0));
    }
  } catch {
    setSelRid(Number(ex.rilevatore_id || 0));
  }
};





/** Cambio selezione Senior: salva subito */

/** Cambio selezione Senior: salva subito */
const onChangeSid = async (e) => {
  const v = Number(e?.target?.value ?? 0);
  setSelSid(v);

  // --- BUSY by overlay (senior) ---
  try {
    const evStart = event?.start ? dateToSql(event.start) : (ex.start_dt || "");
    const evEnd   = event?.end   ? dateToSql(event.end)   : (ex.end_dt   || evStart);
    if (v > 0 && hasOverlayConflictFor(v, 'senior', evStart, evEnd, overlays || [])) {
      alert("Questo senior è impegnato in un BLOCCO (es. corso/riunione) che copre quell'orario.");
      setSelSid(Number(ex.senior_id || 0)); // revert UI
      return;
    }
  } catch {}

  // Blocchi hard già presenti
  if (isDaSpostare) {
    alert("Appuntamento marcato 'da spostare': non è possibile assegnare il senior.");
    setSelSid(Number(ex.senior_id || 0));
    return;
  }
  if (blockPosa()) { setSelSid(Number(ex.senior_id || 0)); return; }
  if (!C?.canAssignSenior) {
    alert("Non hai i permessi per assegnare il senior.");
    setSelSid(Number(ex.senior_id || 0));
    return;
  }
  if (saving) return;

  try {
    if (v === 0) {
      await unassignSid();
    } else if (Number.isFinite(v) && v > 0) {
      await applyState("assign_senior", { senior_id: v });
    } else {
      setSelSid(Number(ex.senior_id || 0));
    }
  } catch {
    setSelSid(Number(ex.senior_id || 0));
  }
};

/* ===================== /DISASSEGNA / ASSEGNA ======================= */

 
  /* ===== Stato pannello km (parziale/total giornata) ===== */
  const [kmCalc, setKmCalc] = React.useState({ loading: false, partialKm: null, dayTotalKm: null, msg: "" });
  React.useEffect(() => { setKmCalc({ loading: false, partialKm: null, dayTotalKm: null, msg: "" }); }, [eid]);

  // riallinea form/selector al cambiare dell'evento
React.useEffect(() => {
  const nx = event?.extendedProps || {};
  setForm({
    pv_total: pickTargetValue(nx),
    pv_budget:
      Number(nx.pv_budget_rilevatore_eur ?? nx.pv_budget ?? 0) || 0,
    pv_budget_senior_eur:
      Number(nx.pv_budget_senior_eur ?? 0) || 0,

    // 🔵 NUOVO: dati finanziamento
    real_finanziato: Number(nx.real_finanziato ?? 0) === 1,
    real_mesi: Number(nx.real_mesi ?? nx.finanziamento_mesi ?? 0) || 0,

    audio_path: String(nx.audio_path || ""),
    pdf_path: String(nx.pdf_path || ""),
    km_arrivo: String(nx.km_arrivo || ""),
  });
  setSelRid(Number(nx.rilevatore_id || 0));
  setSelSid(Number(nx.senior_id || 0));
}, [event]);




  /* ====== Preventivatore ====== */
  /* ====== Preventivatore ====== */
  const openPreventivatore = React.useCallback(async () => {
  setLinkLoading(true);
  try {
    let url = prevUrl;
    let tg  = 0;

    // crea/recupera link
    if (!url) {
      const r = await fetch("/preventivi/agenda/api/link_preventivatore.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ event_id: eid }),
      });
      const j = await r.json().catch(() => ({}));
      if (j?.status !== "OK" || !j.url) {
        alert(j?.message || "Impossibile generare il link del preventivatore.");
        return;
      }
      url = j.url; setPrevUrl(url);

      // NEW: se il BE ci dà già quote_id/pdf_url, tienili
      if (j.quote_id) setPrevQuoteId(String(j.quote_id));
      if (j.pdf_url)  setPrevPdfUrl(String(j.pdf_url));

      // target eventualmente restituito dal BE
      tg = Number(j.target ?? j.target_eur ?? 0);
    }

    // salva/propaga il target se utile
    if (Number.isFinite(tg) && tg > 0) {
      setForm((s) => ({ ...s, pv_total: Number(s.pv_total || 0) > 0 ? s.pv_total : tg }));
      try {
        const cur = Number(ex.pv_total);
        if (!Number.isFinite(cur) || cur <= 0) {
          await apiPostForm("/preventivi/agenda/api/update_event.php", {
            id: eid,
            pv_total: tg,
            ...persistTimes(),
            operator_id: opId,
            updated_by_operator_id: opId,
          });
          onDidChange?.();
        }
      } catch {}
    }


    // apri il preventivatore
    window.open(url, "_blank", "noopener,noreferrer");
  } finally {
    setLinkLoading(false);
  }
}, [eid, prevUrl, ex.pv_total, setForm, onDidChange, persistTimes]);



/* 1) URL finale del PDF (memo **puro**) */
const pdfPrevUrl = React.useMemo(() => {
  const exLocal = event?.extendedProps || {};

  // 0) Campo già salvato a DB (preferito)
  const fromField =
    exLocal.prev_pdf_path ||
    exLocal.prevPdfPath ||
    exLocal.preventivo_pdf ||
    exLocal.preventivo_pdf_url ||
    exLocal.preventivatore_pdf ||
    exLocal.preventivatore_pdf_url ||
    "";
  if (fromField) return resolvePrevUrl(fromField, eid);

  // 1) URL diretto restituito dall'API
  if (prevPdfUrl && /^https?:\/\//i.test(prevPdfUrl)) return prevPdfUrl;

  // 2) Ricostruzione da link/JSON
  const quoteFromUrl = (u) => {
    try {
      if (!u) return "";
      const url = new URL(u, window.location.origin);
      const qsId =
        url.searchParams.get("quoteId") ||
        url.searchParams.get("qid") ||
        url.searchParams.get("id");
      if (qsId && /^\d+$/.test(qsId)) return qsId;
      const pathNum = url.pathname.match(/(\d+)/g);
      if (pathNum && pathNum.length) return pathNum.pop();
      return "";
    } catch { return ""; }
  };

  let qid =
    (prevQuoteId != null && String(prevQuoteId).trim()) ? String(prevQuoteId).trim() :
    (exLocal.preventivo_id != null ? String(exLocal.preventivo_id) : "") ||
    (exLocal.preventivoId    != null ? String(exLocal.preventivoId) : "") ||
    (exLocal.quote_id        != null ? String(exLocal.quote_id)     : "");

  if (!qid) {
    try {
      const raw = exLocal.preventivo_json;
      const obj = typeof raw === "string" ? JSON.parse(raw) : raw;
      const cand = obj?.id ?? obj?.quoteId ?? obj?.quote_id;
      if (cand != null && /^\d+$/.test(String(cand))) qid = String(cand);
      const pdfInJson = obj?.links?.pdf || obj?.pdf_url;
      if (!qid && pdfInJson) return pdfInJson;
    } catch {}
  }

  if (!qid) qid = quoteFromUrl(prevUrl || exLocal.prev_url || exLocal.preventivatore_url || "");

  if (qid && /^\d+$/.test(qid)) {
    const v = Date.now(); // cache-buster
    return `/preventivi/generapdf.php?quoteId=${encodeURIComponent(qid)}&v=${v}`;
  }

  return "";
}, [eid, event?.extendedProps, prevPdfUrl, prevQuoteId, prevUrl]);

/* 2) Stato spinner per il pulsante "Trova PDF" */
const [findingPdf, setFindingPdf] = React.useState(false);

/* 3) Fallback stile "Elenco": prova a trovare/rigenerare il PDF */
const findPdfLikeElenco = React.useCallback(async () => {
  // se ho già un PDF funzionante apro direttamente
  if (pdfPrevUrl) {
    try { window.open(pdfPrevUrl, "_blank", "noopener,noreferrer"); } catch {}
    return;
  }

  try {
    setFindingPdf(true);

    /* === Primo tentativo: API ufficiale del preventivatore === */
    try {
      const r = await fetch("/preventivi/agenda/api/link_preventivatore.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ event_id: eid }),
      });
      const j = await r.json().catch(() => ({}));
      if (j?.status === "OK") {
        if (j.url)      setPrevUrl(String(j.url));
        if (j.quote_id != null) setPrevQuoteId(String(j.quote_id));

        

        if (j.pdf_url) {
  const pdfUrl = String(j.pdf_url);
  setPrevPdfUrl(pdfUrl);

  // prova a leggere l'id del preventivo restituito dall'API
  const qidStr =
    j.quote_id != null
      ? String(j.quote_id)
      : j.preventivo_id != null
      ? String(j.preventivo_id)
      : "";

  if (qidStr) setPrevQuoteId(qidStr);

  try {
    await apiPostForm("/preventivi/agenda/api/update_event.php", {
      id: eid,
      ...persistTimes(),
      ...(qidStr ? { preventivo_id: qidStr, quote_id: qidStr } : {}),
      prev_pdf_path: pdfUrl,
      preventivo_pdf: pdfUrl,
      preventivatore_pdf: pdfUrl,
      operator_id: opId,
      updated_by_operator_id: opId,
    });
    onDidChange?.();
  } catch {}

  // ho un pdf_url diretto, posso uscire
  return;
}



      }
    } catch { /* continua col fallback */ }

    /* === Secondo tentativo: fallback "stile elenco" === */
    const exLocal = event?.extendedProps || {};
    const norm = (s) => String(s || "").trim().toLowerCase();

    const name = norm(exLocal.cliente_nome || exLocal.nome_cliente || event?.title || "");
    const city = norm(exLocal._comuneView || exLocal.comune || "");
    const day  = String(exLocal.start_dt || exLocal.start || "").slice(0, 10);
    const evTarget = Number(pickTargetValue(exLocal)) || 0;

    // Se dal link del preventivatore ricavo già un quoteId → uso quello
    try {
      if (prevUrl) {
        const u = new URL(prevUrl, window.location.origin);
        const qidFromUrl =
          u.searchParams.get("quoteId") || u.searchParams.get("qid") || u.searchParams.get("id");
        if (qidFromUrl && /^\d+$/.test(qidFromUrl)) {
          const qid = String(qidFromUrl);
          setPrevQuoteId(qid);
          const url = `/preventivi/generapdf.php?quoteId=${encodeURIComponent(qid)}&v=${Date.now()}`;
          setPrevPdfUrl(url);
          if (!isPosaReadOnly) {
            try {
           await apiPostForm("/preventivi/agenda/api/update_event.php", {
  id: eid,
  ...persistTimes(),
  preventivo_id: qid,
  quote_id: qid,
  prev_pdf_path: url,
  preventivo_pdf: url,
  preventivatore_pdf: url,
  operator_id: opId,
  updated_by_operator_id: opId,
});
              onDidChange?.();
            } catch {}
          }
          return;
        }
      }
    } catch { /* ignore */ }

    // Scan dell'elenco preventivi (paginato)
    const PER_PAGE  = 50;
    const MAX_PAGES = 4;

    let best = null;
    let bestScore = -1;

    for (let page = 1; page <= MAX_PAGES; page++) {
      const qs  = new URLSearchParams({ page: String(page), perPage: String(PER_PAGE) });



      const res = await fetch(`/preventivi/elenco_preventivi.php?${qs}`, { credentials: "same-origin" });
      const txt = await res.text();
      let j; try { j = JSON.parse(txt); } catch { j = {}; }
      const arr = Array.isArray(j?.preventivi) ? j.preventivi : [];

      for (const p of arr) {
        const pn  = norm(p.nome);
        const loc = norm(p.localita);
        const dt  = String(p.data_creazione || p.date || "").slice(0, 10);
        const pTarget = Number(p.target || 0) || 0;

        let score = 0;
        if (name && pn) {
          if (pn === name) score += 4;
          else if (pn.includes(name) || name.includes(pn)) score += 3;
        }
        if (city && loc) {
          if (loc === city) score += 2;
          else if (loc.includes(city) || city.includes(loc)) score += 1;
        }
        if (day && dt) {
          const d1 = new Date(day).getTime();
          const d2 = new Date(dt).getTime();
          const dd = Math.abs((d1 - d2) / 86400000);
          if (dd <= 0.5) score += 4;
          else if (dd <= 1.5) score += 3;
          else if (dd <= 3.5) score += 1;
        }
        if (evTarget > 0 && pTarget > 0) {
          const delta = Math.abs(evTarget - pTarget);
          if (delta === 0) score += 2;
          else if (delta <= 100) score += 1;
        }

        if (score > bestScore) { best = p; bestScore = score; }
      }

      if (bestScore >= 7) break;
    }

    if (best?.id) {
      const qid = String(best.id);
      setPrevQuoteId(qid);
      const url = `/preventivi/generapdf.php?quoteId=${encodeURIComponent(qid)}&v=${Date.now()}`;
      setPrevPdfUrl(url);

      if (!isPosaReadOnly) {
        try {
   await apiPostForm("/preventivi/agenda/api/update_event.php", {
  id: eid,
  ...persistTimes(),
  preventivo_id: qid,
  quote_id: qid,
  prev_pdf_path: url,
  preventivo_pdf: url,
  preventivatore_pdf: url,
  operator_id: opId,
  updated_by_operator_id: opId,
});
          onDidChange?.();
        } catch {}
      }
    } else {
      alert("Non sono riuscito a trovare automaticamente il PDF. Apri il Preventivatore (🚀 Prev.) e salva.");
    }
  } catch (err) {
    alert(String(err?.message || "Errore ricerca PDF"));
  } finally {
    setFindingPdf(false);
  }
}, [
  pdfPrevUrl,
  prevUrl,
  eid,
  event?.extendedProps,
  isPosaReadOnly,
  persistTimes,
  onDidChange
]);

/* 4) Auto‑lookup: se c’è il Target ma manca il PDF, prova una volta */
React.useEffect(() => {
  const tgt = Number(pickTargetValue(ex));
  if (open && !pdfPrevUrl && tgt > 0 && !findingPdf) {
    findPdfLikeElenco();
  }
}, [open, pdfPrevUrl, ex, findingPdf, findPdfLikeElenco]);


/* ===== Azioni stato / processo (stateless + action) ===== */
const applyState = React.useCallback(async (kind, extra = {}) => {
  // FE → BE action code
  const action =
    ({
      confirm:        'CONFIRM',
      cancel:         'CANCEL',
      reset:          'RESET',
      assign_rid:     'ASSIGN_RIL',
      assign_senior:  'ASSIGN_SENIOR',
      pass_to_senior: 'RIL_POS',            // tasto “Passa al Senior” (oro)
      ril_non_buono:  'RIL_NEG',            // tasto “Segna non buono” (giallo)
      senior_esito:   (String(extra.value || '') === 'chiuso'
                        ? 'SENIOR_CHIUSO'
                        : 'SENIOR_NONCHIUSO'),
      posa_push:      'POSA_PUSH',          // tasto POSA (viola)
      in_gestione:    'IN_GESTIONE',        // arancione
    }[kind] || '');

  if (!action) { alert('Azione non riconosciuta'); return; }

  // ⬇️ QUI il blocco POSA: consenti solo la PUSH verso POSA, blocca tutto il resto
  if (isPosaReadOnly && action !== 'POSA_PUSH') {
    blockPosa();
    return;
  }

  // hint UI immediato (il BE può ignorarlo)
  const uiCode = ({
    CONFIRM:          'S1',
    ASSIGN_RIL:       'S2',
    ASSIGN_SENIOR:    'S3S',
    RIL_POS:          'S3',
    RIL_NEG:          'S4',
    SENIOR_NONCHIUSO: 'S5',
    SENIOR_CHIUSO:    'S6',
    CANCEL:           'S7',
    POSA_PUSH:        'S8',
    IN_GESTIONE:      'S9',
    RESET:            'S0',
  }[action] || 'S0');

  const nowSql = dateToSql(new Date());




    const patch = {
    id: eid,
    action,                 // richiesto dal BE
    ui_state_code: uiCode,  // hint per resa immediata
    ui_state_at: nowSql,
    operator_id: opId,
    updated_by_operator_id: opId,
  };





  // extra mirati
  if (action === 'ASSIGN_RIL')     patch.rilevatore_id = Number(extra.rilevatore_id || 0);
  if (action === 'ASSIGN_SENIOR')  patch.senior_id      = Number(extra.senior_id || 0);
  if (action === 'SENIOR_CHIUSO' || action === 'SENIOR_NONCHIUSO') {
    patch.importo      = extra.importo != null ? String(extra.importo) : '';
    patch.senior_esito = (action === 'SENIOR_CHIUSO') ? 'chiuso' : 'non_chiuso';
  }

  try {
    await apiPostForm("/preventivi/agenda/api/update_event.php", patch);
    onDidChange?.();
  } catch (err) {
    alert(err.message || "Errore salvataggio");
  }
}, [eid, operatorId, onDidChange, persistTimes, isPosaReadOnly, blockPosa]);






// toggle POSA: push ↔ unpush
const handleTogglePosa = React.useCallback(async () => {
  try {
    setSaving(true);

    // guardia: serve un id valido
    if (!eid || Number(eid) <= 0) {
      alert("ID appuntamento mancante (eid).");
      return;
    }

    if (!isPushedToPosa) {
      // === PUSH ===
      await applyState("posa_push");

      // safety: forza/garantisce la riga su agenda_posa
      try {
        const payloadPush = {
          agenda_id: Number(eid),
          id:        Number(eid),
          event_id:  Number(eid),
                    operator_id: opId,                 // 👈 nuovo
          updated_by_operator_id: opId,    
        };
        await fetch("/preventivi/agenda/api/posa_transfer_one.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify(payloadPush),
        });
      } catch { /* best-effort */ }

      // refresh locale e notifica alle altre tab
      onDidChange?.();
      try { new BroadcastChannel("agenda_sync").postMessage({ type: "posa:changed", at: Date.now() }); } catch {}

    } else {
      // === UNPUSH ===
      if (!window.confirm("Togliere l'appuntamento dall'Agenda POSA?")) return;

      const payload = {
        agenda_id:  Number(eid),
        id:         Number(eid),
        event_id:   Number(eid),
        operator_id: Number(operatorId || 0),
      };

      const res = await fetch("/preventivi/agenda/api/posa_revert.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });

      const j = await res.json().catch(() => ({}));
      if (!res.ok || j.status !== "OK") {
        throw new Error(j?.message || j?.hint || "Errore posa_revert");
      }

      // refresh locale e notifica alle altre tab
      onDidChange?.();
      try { new BroadcastChannel("agenda_sync").postMessage({ type: "posa:changed", at: Date.now() }); } catch {}
    }

  } catch (err) {
    alert(String(err?.message || err));
  } finally {
    setSaving(false);
  }
}, [isPushedToPosa, eid, operatorId, applyState, onDidChange]);




  /* === Wrapper UI === */
const doConfirm = () => applyState("confirm");
const doCancel  = () => { if (window.confirm("Confermi annullamento?")) applyState("cancel"); };
const doReset   = () => { if (window.confirm("Resetto l’appuntamento come 'Appena messo'?")) applyState("reset"); };



// === POSA: trasferisci con conferma esplicita ===
const isAlreadyInPosa =
  Number(ex.posa_flag || 0) === 1 ||
  !!(ex.posa_transfer_at && String(ex.posa_transfer_at).trim() !== "");

const doPosa = async () => {
  const when = ex.start_dt
    ? new Date(ex.start_dt.replace(" ", "T")).toLocaleString("it-IT")
    : (ex.start || "—");

  const msg = [
    "⚠️ ATTENZIONE",
    "",
    "Stai per trasferire questo appuntamento in POSA.",
    "Da quel momento NON sarà più modificabile da questa Agenda.",
    "",
    `• Evento #${eid}`,
    `• Cliente: ${ex.cliente_nome || ex.nome_cliente || "—"}`,
    `• Quando: ${when}`,
    "",
    "Confermi il trasferimento in POSA?"
  ].join("\n");

  if (!window.confirm(msg)) return;

  try {
    setSaving(true);

    // ✅ usa il KIND minuscolo: 'posa_push'
    await applyState("posa_push", {
      // 'extra' qui non è necessario; la conferma è solo lato FE
      // se vuoi comunque loggare qualcosa lato BE, puoi estendere applyState a unire 'extra' nel patch
    });

    // Best-effort: garantisci anche la riga su agenda_posa subito
    try {
      await fetch("/preventivi/agenda/api/posa_transfer_one.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ agenda_id: Number(eid), id: Number(eid), event_id: Number(eid) }),
      });
    } catch {
      /* opzionale: ignora eventuali errori, il batch ci riproverà */
    }

    onDidChange?.();
  } catch (err) {
    alert(err?.message || "Errore: non sono riuscito a trasferire in POSA");
  } finally {
    setSaving(false);
  }
};



/* Disassegna Rilevatore – compat con BE “rigidi” */
const assignRid = async () => {
  if (!selRid) {
    const payload = {
      id: eid,
      ...persistTimes(),
      action: "ASSIGN_RIL",            // molti BE vogliono l'azione
      // svuota TUTTI gli alias che il BE potrebbe leggere
      rilevatore_id: "",               // ← stringa vuota, NON 0
      rilevatore: "",
      rid: "",
      rilevatore_name: "",
      clear_rilevatore: 1,             // se il BE la supporta
      ui_state_code: "S1",             // facoltativo: torna “confermato”
      ui_state_at: dateToSql(new Date()),
      operator_id: Number(operatorId || 0),
      updated_by_operator_id: Number(operatorId || 0),
    };

    try {
      await apiPostForm("/preventivi/agenda/api/update_event.php", payload);
      setSelRid(0);             // UI locale
      onDidChange?.();          // refetch calendario
    } catch (err) {
      alert(err?.message || "Errore: non sono riuscito a togliere il rilevatore");
    }
    return;
  }

  // Assegna normale

if (isDaSpostare) { alert("Appuntamento da spostare: non assegnabile."); return; }

  await applyState("assign_rid", { rilevatore_id: Number(selRid) });
};

/* Disassegna Senior – compat con BE “rigidi” */
const assignSid = async () => {
  if (!selSid) {
    const wantSenior = Number(ex.want_senior || ex.pass_to_senior || 0) === 1;
    const payload = {
      id: eid,
      ...persistTimes(),
      action: "ASSIGN_SENIOR",
      senior_id: "",                    // ← stringa vuota
      senior: "",
      sid: "",
      senior_name: "",
      clear_senior: 1,
      ui_state_code: wantSenior ? "S3" : "S1",
      ui_state_at: dateToSql(new Date()),
      operator_id: Number(operatorId || 0),
      updated_by_operator_id: Number(operatorId || 0),
    };

    try {
      await apiPostForm("/preventivi/agenda/api/update_event.php", payload);
      setSelSid(0);
      onDidChange?.();
    } catch (err) {
      alert(err?.message || "Errore: non sono riuscito a togliere il senior");
    }
    return;
  }

  // Assegna normale

if (isDaSpostare) { alert("Appuntamento da spostare: non assegnabile."); return; }

  await applyState("assign_senior", { senior_id: Number(selSid) });
};



const setPassaAlSenior = () => applyState("pass_to_senior");  // oro
const markRilNonBuono  = () => applyState("ril_non_buono");   // giallo
const setEsitoSenior   = (v) => applyState("senior_esito", { value: v }); // 'chiuso'/'non_chiuso'




const startISO = React.useMemo(() => {
  if (event?.start instanceof Date) return dateToSql(event.start); // ✅ prima l’evento
  const fromFields = String(form.start_dt || form.start || ex.start_dt || ex.start || "");
  return fromFields || "";
}, [event?.start, form.start_dt, form.start, ex.start_dt, ex.start]);






  const effectiveUserId = React.useMemo(
    () => (selRid || selSid || rid || sid || 0),
    [selRid, selSid, rid, sid]
  );




// kilometri auto codice lungo  

const autoKm = React.useCallback(
  async (userId = effectiveUserId, eventId = eid, { persistField = true } = {}) => {
    const dayStr = (startISO || "").slice(0, 10);
    if (!userId || !dayStr) {
      setKmCalc({ loading: false, partialKm: null, dayTotalKm: null, msg: "Dati insufficienti (user/day)." });
      return;
    }

    setKmCalc((s) => ({ ...s, loading: true, msg: "" }));

    // 1) tenta in form-urlencoded (più compatibile con PHP)
    const tryForm = async () => {
      const body = new URLSearchParams();
      body.append("user_id", String(userId));
      body.append("day", dayStr);
      body.append("event_id", String(eventId || 0));
      body.append("persist", "1");

      const r = await fetch("/preventivi/api/compute_day_km.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        credentials: "same-origin",
        body,
      });
      const txt = await r.text(); let j; try { j = JSON.parse(txt); } catch { j = null; }
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      if (!j || j.status !== "OK") throw new Error(j?.message || "Errore servizio km (FORM).");
      return j;
    };

    // 2) seconda chance con JSON
    const tryJson = async () => {
      const payload = { user_id: Number(userId), day: dayStr, event_id: Number(eventId || 0), persist: 1 };
      const r = await fetch("/preventivi/api/compute_day_km.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
      const txt = await r.text(); let j; try { j = JSON.parse(txt); } catch { j = null; }
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      if (!j || j.status !== "OK") throw new Error(j?.message || "Errore servizio km (JSON).");
      return j;
    };

    try {
      let j;
      try { j = await tryForm(); } catch { j = await tryJson(); }

      // estrazione compatibile
      const m =
        (j?.current && (j.current.distance_m ?? j.current.distance ?? j.current.meters)) ?? null;
      const partialKm = m != null ? Number((Number(m) / 1000).toFixed(1)) : null;
      const dayTotalKm = (j && j.total_km != null) ? Number(Number(j.total_km).toFixed(1)) : null;

      setKmCalc({ loading: false, partialKm, dayTotalKm, msg: j?.message || "" });

      // persistenza opzionale su evento
   // persistenza opzionale su evento
if (persistField && partialKm != null) {
  const cur = Number(form.km_arrivo);
  setField("km_arrivo", String(partialKm));
  if (!Number.isFinite(cur) || Math.abs(cur - partialKm) >= 0.1) {
    try {
      await savePatch({ ...persistTimes(), km_arrivo: String(partialKm) });
    } catch (e1) {
      // fallback se il BE usa un altro nome colonna
      try { await savePatch({ ...persistTimes(), km: String(partialKm) }); } catch (e2) {}
    }
  }
}

    } catch (e) {
      const msgRaw = String(e?.message || "");
      const pretty = /HTTP\s*\d+/.test(msgRaw) ? "Servizio km non disponibile" : msgRaw;
      setKmCalc({ loading: false, partialKm: null, dayTotalKm: null, msg: pretty });
    }
  },
  [effectiveUserId, startISO, eid, form.km_arrivo, setField, savePatch, persistTimes]
);




  // calcolo automatico all'apertura / quando cambia assegnazione
  React.useEffect(() => {
    if (open && effectiveUserId && startISO) autoKm(effectiveUserId, eid, { persistField: false });
  }, [open, effectiveUserId, startISO]); // eslint-disable-line

  /* ===== RENDER ===== */
  const bellShort = /ok/i.test(String(bellLabel || "")) ? "OK" : (bellLabel || "—");
  const presShort = presFlag ? "sì" : "no";

  const ridAssignedPersistent = (rid > 0 && selRid === rid);
  const sidAssignedPersistent = (sid > 0 && selSid === sid);
  const ridAssignedUI = okRid || ridAssignedPersistent;
  const sidAssignedUI = okSid || sidAssignedPersistent;



  // Helper etichette selezioni (evita no-undef)
const labelRid = (rilevatori.find(r => Number(r.id) === Number(selRid))?.nome) || "Seleziona";
const labelSid = (seniori.find(s => Number(s.id) === Number(selSid))?.nome) || "Seleziona";


// === safety handlers per i bottoni del JSX ===

// DELETE — handler completo (non dipende da doDelete)
const onClickDelete = React.useCallback(async () => {
  if (!window.confirm("Eliminare definitivamente l’appuntamento?")) return;
  setSaving(true);
  try {
    const baseIds = { id: eid, operator_id: Number(operatorId) || 0, deleted_by_operator_id: Number(operatorId) || 0 };

    // tenta hard delete
    try { 
      await apiPost("/preventivi/agenda/api/delete_event.php", baseIds); 
    } catch {
      // fallback: soft delete su update_event.php
      await apiPost("/preventivi/agenda/api/update_event.php", {
        ...persistTimes(),
        ...baseIds,
        updated_by_operator_id: Number(operatorId) || 0,
        deleted_at: dateToSql(new Date()),
        delete: 1,
        confirmed_by_operator_id: null,
      });
    }

    onClose?.();
    onDidChange?.();
  } catch (err) {
    alert(err?.message || "Errore eliminazione");
  } finally {
    setSaving(false);
  }
}, [eid, operatorId, onClose, onDidChange]);

// SAVE — semplice wrapper che chiama la tua saveFields
const onClickSave = React.useCallback(async () => {
  try {
    await saveFields();     // salva target/budget/real/allegati
    setSavedOk(Date.now()); // mostra toast
  } catch {}
}, [saveFields]);






  return (
    <Modal open={open} onClose={onClose} title={`Evento #${eid}`} width={780}>
      {/* ======= TESTATA 2 COLONNE ======= */}
      <div
        className="am-top"
        style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 12, alignItems: "start", marginBottom: 8 }}
      >
        {/* COLONNA SINISTRA — dati cliente */}
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 6, marginBottom: 10 }}>
            <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 2 }}>
              {ora} &nbsp; {nome}
            </div>
            <div>📞 {telShow}</div>
            <div>📍 {addr}</div>
            <div>🏙️ {comuneCap}</div>
            <div className="am-quick-row" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <span className="am-info">🔔 {bellShort}</span>
              <span className="am-info">🕒 {presShort}</span>
            </div>
          </div>
        </div>

    

<div className="am-sel-col" style={{ display: "grid", gridTemplateColumns: "1fr", gap: 12 }}>
  {/* Rilevatore */}
  <div>
    <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 4 }}>Selezione Rilevatore</div>
    <div className="am-sel-row">
      <select
        className={`am-sel am-sel--junior ${ (okRid || (Number(ex.rilevatore_id||0)>0 && selRid===Number(ex.rilevatore_id))) ? "is-assigned" : "" }`}
        value={selRid}
        onChange={onChangeRid}
        disabled={!C.canAssignRilevatore || saving || isDaSpostare}
        title={(rilevatori.find(r => Number(r.id)===Number(selRid))?.nome) || "Seleziona"}
      >
        <option value={0}>— Nessuno —</option>
        {(rilevatori || []).map((opt) => (
          <option key={opt.id} value={opt.id}>{opt.nome}</option>
        ))}
      </select>

      {C.canAssignRilevatore && (
        <button
          type="button"
          onClick={unassignRid}
         disabled={saving || isDaSpostare || !(Number(ex.rilevatore_id || 0) > 0)}
          title="Togli assegnazione rilevatore"
          className="am-btn am-ghost am-sel-apply"
          aria-label="Togli assegnazione rilevatore"
        >
          ✖︎
        </button>
      )}
    </div>
  </div>

  {/* Senior */}
  <div>
    <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 4 }}>Selezione Senior</div>
    <div className="am-sel-row">
      <select
        className={`am-sel am-sel--senior ${ (okSid || (Number(ex.senior_id||0)>0 && selSid===Number(ex.senior_id))) ? "is-assigned" : "" }`}
        value={selSid}
        onChange={onChangeSid}
        disabled={!C.canAssignSenior || saving || isDaSpostare}
        title={(seniori.find(s => Number(s.id)===Number(selSid))?.nome) || "Seleziona"}
      >
        <option value={0}>— Nessuno —</option>
        {(seniori || []).map((opt) => (
          <option key={opt.id} value={opt.id}>{opt.nome}</option>
        ))}
      </select>

      {C.canAssignSenior && (
        <button
          type="button"
          onClick={unassignSid}
       disabled={saving || isDaSpostare || !(Number(ex.senior_id || 0) > 0)}
          title="Togli assegnazione senior"
          className="am-btn am-ghost am-sel-apply"
          aria-label="Togli assegnazione senior"
        >
          ✖︎
        </button>
      )}
    </div>
  </div>
</div>






      </div>
      {/* ======= /TESTATA 2 COLONNE ======= */}
{/* ===== AZIONI / INDICATORI ===== */}
<div className="am-status-grid">
  {/* — Colonna SINISTRA — */}
  <div className="am-status-col am-col-left">

    {/* 🟡 DA SPOSTARE (solo informativo) */}
    {isDaSpostare && (
      <span
        className="chip"
        style={{ background:'#fff79a', border:'1px solid #e0d85c', color:'#333' }}
        title="Questo appuntamento è marcato 'da spostare'"
      >
        🟡 Da spostare
      </span>
    )}

    {/* POSA (viola) — tieni lo stile "static", ma è cliccabile e fa POSA_PUSH */}
    {C.canPushToPosa && (
      <button
        type="button"
        className={`chip chip-static ${isAlreadyInPosa ? "on" : ""}`}
        onClick={doPosa}
        disabled={saving || isAlreadyInPosa}
        title={
          isAlreadyInPosa
            ? "Appuntamento già trasferito in POSA"
            : "Trasferisci in POSA (non sarà più modificabile in questa Agenda)"
        }
      >
        🧰 POSA
      </button>
    )}

    {/* Segna non buono */}
    {C.canMarkRilNonBuono && (
      <button
        type="button"
        className={`chip chip-red ${Number(ex.ril_non_buono || 0) === 1 ? "on" : ""}`}
        onClick={markRilNonBuono}
        disabled={saving}
        title="Segna come rilievo non buono"
      >
        🚫 Non buono
      </button>
    )}

    {/* Passa al Senior */}
    {C.canToggleSeniorWant && (
      <button
        type="button"
        className={`chip ${Number(ex.want_senior || ex.pass_to_senior || 0) === 1 ? "chip-gold on" : ""}`}
        onClick={setPassaAlSenior}
        disabled={saving}
        title="Marca come 'da passare al Senior'"
      >
        ⭐ ➜ Sen.
      </button>
    )}
  </div>

  {/* — Colonna DESTRA — */}
  <div className="am-status-col am-col-right">
    {C.canSetSeniorEsito && (
      <>
        {/* NON CHIUSO */}
        <button
          type="button"
          className={`chip ${seniorEsito === "non_chiuso" ? "chip-red on" : "chip-red"}`}
          onClick={() => setEsitoSenior("non_chiuso")}
          disabled={saving}
          title="Segna 'Senior non chiuso'"
        >
          🟥 Non chiuso
        </button>

        {/* CHIUSO */}
        <button
          type="button"
          className={`chip ${seniorEsito === "chiuso" ? "chip-deepgreen on" : "chip-deepgreen"}`}
          onClick={() => setEsitoSenior("chiuso")}
          disabled={saving}
          title="Segna 'Senior chiuso'"
        >
          🟩 Chiuso
        </button>

        {/* IN GESTIONE (arancione S9) */}
        <button
          type="button"
          className={`chip chip-orange ${String(ex.ui_state_code || "").toUpperCase() === "S9" ? "on" : ""}`}
          onClick={() => applyState("in_gestione")}
          disabled={saving}
          title="Segna 'In gestione' (arancione)"
        >
          📋 Attesa
        </button>
      </>
    )}
  </div>

  {/* — Riga unica in basso: Annullato · Reset · Elimina — */}
  <div className="am-bottom-row">
    {C.canCancel && (
      <button
        type="button"
        className={`chip chip-brown ${String(ex.stato || "").toLowerCase() === "annullato" ? "on" : ""}`}
        onClick={doCancel}
        disabled={saving}
        title="Segna annullato"
      >
        ⛔ Annullato
      </button>
    )}

    {C.canReset && (
      <button type="button" className="chip" onClick={doReset} disabled={saving} title="Reset">
        🧹 Reset
      </button>
    )}

    {C.canDelete && (
      <button type="button" className="chip chip-danger" onClick={onClickDelete} disabled={saving} title="Elimina">
        🗑 Elimina
      </button>
    )}
  </div>
</div>






<hr className="am-divider-red am-divider-red--modern" />



{/* ===== FORM 3x3 ===== */}
<div className="am-rows-3">

  {/* === RIGA 1: Target / Budget / Real === */}
  <div className="am-row three">
    {/* Target (€) */}
    <div className="am-cell am-col">
      <label className="am-lbl am-lbl-red">Target (€)</label>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        className="am-input am-money"
        value={String(form.pv_total ?? "")}
        onChange={(e) => setField("pv_total", e.target.value.replace(/\D/g, "").slice(0, 6))}
        disabled={!C.canEditBudgets || saving}
        placeholder="0"
      />
    </div>

    {/* Budget (€) */}
    <div className="am-cell am-col">
      <label className="am-lbl am-lbl-red">Budget (€)</label>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        className="am-input am-money"
        value={String(form.pv_budget ?? "")}
        onChange={(e) => setField("pv_budget", e.target.value.replace(/\D/g, "").slice(0, 6))}
        disabled={!C.canEditBudgets || saving}
        placeholder="0"
      />
    </div>




  {/* Real (€) + Finanziamento */}
  <div className="am-cell am-col">
    <label className="am-lbl am-lbl-red">Real (€)</label>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        flexWrap: "nowrap",
      }}
    >
      {/* input Real: metà larghezza */}
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        className="am-input am-money"
        style={{ maxWidth: 60 }}
        value={String(form.pv_budget_senior_eur ?? "")}
        onChange={(e) =>
          setField(
            "pv_budget_senior_eur",
            e.target.value.replace(/\D/g, "").slice(0, 6)
          )
        }
        disabled={!C.canEditBudgets || saving}
        placeholder="0"
      />
{/* checkbox Fin. – quadretto piccolo ma ben visibile */}
<label
  style={{
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: 10,
    cursor: "pointer",
    whiteSpace: "nowrap",
  }}
>
  <input
    type="checkbox"
    checked={!!form.real_finanziato}
    onChange={(e) => setField("real_finanziato", e.target.checked)}
    style={{
      width: 10,
      height: 10,
      borderRadius: 1,
      cursor: "pointer",
      margin: 0,
      border: form.real_finanziato ? "2px solid #dc2626" : "1px solid #000",
      accentColor: "#dc2626",
      boxShadow: form.real_finanziato
        ? "0 0 0 2px rgba(220,38,38,.45)"
        : "none",
    }}
  />
  <span>Fin.</span>
</label>

{/* select mesi: piccola, senza testo "mesi..." */}
<select
  value={form.real_mesi || 0}
  onChange={(e) => setField("real_mesi", Number(e.target.value) || 0)}
  disabled={!form.real_finanziato || saving}
  style={{
    height: 20,
    borderRadius: 5,
    border: "1px solid #16a34a",
    padding: "0 2px",
    fontSize: 10,
    minWidth: 25,
  }}
>
  <option value={0}>—</option>
  {[12, 24, 36, 48, 60, 72, 84, 96, 108, 120].map((m) => (
    <option key={m} value={m}>
      {m}
    </option>
  ))}
</select>

    </div>
  </div>




  </div>

  {/* === RIGA 2: Audio / Prev. / PDF === */}
  <div className="am-row three">

    {/* AUDIO */}
    <div className="am-cell am-col">
      <div className="am-lbl" style={{display:'flex',alignItems:'center',gap:8}}>
        <button
          type="button"
          onClick={() => document.getElementById(`audioFileHidden-${eid}`)?.click()}
          disabled={saving}
          title="Carica un file audio (mp3, wav, m4a, aac, ogg)"
          className="am-ico-btn"
          style={{display:'inline-flex',alignItems:'center',gap:6,padding:'4px 8px',border:'1px solid #e5e7eb',borderRadius:8,background:'#f9fafb',cursor:'pointer'}}
        >
          🎧 <b>audio</b>
        </button>
      </div>

      <input
        name="audio_path"
        type="text"
        inputMode="url"
        className="am-input am-url am-url-sm"
        value={form.audio_path || ""}
        onChange={(e) => setField("audio_path", e.target.value)}
        disabled={saving}
        placeholder="URL o percorso"
        aria-label="Percorso o URL audio"
        autoComplete="off"
      />

      {form.audio_path ? (
        <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
          <button
            type="button"
            className="chip chip-sm"
            onClick={() => {
              try {
                const u = /^https?:\/\//i.test(form.audio_path)
                  ? form.audio_path
                  : `${window.location.origin}${form.audio_path.startsWith("/") ? "" : "/"}${form.audio_path}`;
                window.open(u, "_blank", "noopener,noreferrer");
              } catch {}
            }}
            title="Apri audio"
            aria-label="Apri audio"
          >
            🔗 Apri
          </button>
        </div>
      ) : null}

      {/* file picker nascosto */}
      <input
        id={`audioFileHidden-${eid}`}
        type="file"
        accept=".mp3,.wav,.m4a,.aac,.ogg,audio/*"
        style={{ display: "none" }}
        onChange={async (e) => {
          const f = e.target.files?.[0];
          if (!f) return;
          const ext = (f.name.split(".").pop() || "").toLowerCase();
          if (!["mp3", "wav", "m4a", "aac", "ogg"].includes(ext)) {
            alert("Formato non supportato. Usa MP3, WAV, M4A, AAC o OGG.");
            e.target.value = "";
            return;
          }
          try {
            setSaving(true);
    const fd = new FormData();
fd.append("event_id", String(eid));
fd.append("kind", "audio");
fd.append("file", f);
fd.append("operator_id", String(opId));               // 👈 nuovo
fd.append("uploaded_by_operator_id", String(opId));   // 👈 nuovo
const r = await fetch("/preventivi/agenda/api/upload_file.php", {
  method: "POST",
  body: fd,
  credentials: "same-origin",
});

            const j = await r.json().catch(() => ({}));
            if (!r.ok || j.status !== "OK" || !j.url) throw new Error(j.message || `HTTP ${r.status}`);
            const nextUrl = /^https?:\/\//i.test(j.url) ? j.url : `${window.location.origin}${j.url.startsWith("/") ? "" : "/"}${j.url}`;
            setField("audio_path", nextUrl);
            onDidChange?.();
          } catch (err) {
            alert(String(err?.message || err));
          } finally {
            setSaving(false);
            e.target.value = "";
          }
        }}
      />
    </div>
{/* PREV. (bottone app + link PDF generato o fallback "Trova PDF") */}
<div className="am-cell am-col am-cell-prev">
  <div className="am-lbl" style={{display:'flex',alignItems:'center',gap:8}}>
    <button
      type="button"
      onClick={openPreventivatore}
      disabled={linkLoading || saving}
      title="Apri il Preventivatore"
      className="am-ico-btn"
      style={{display:'inline-flex',alignItems:'center',gap:6,padding:'4px 8px',border:'1px solid #e5e7eb',borderRadius:8,background:'#f9fafb',cursor:'pointer'}}
    >
      🚀 <b>Prev.</b>
    </button>
  </div>

  {pdfPrevUrl ? (
    <a
      className="am-read am-link"
      href={pdfPrevUrl}
      target="_blank"
      rel="noopener noreferrer"
      title="Apri PDF generato dal preventivatore"
    >
      PDF Preventivatore
    </a>
  ) : (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div className="am-read am-missing">—</div>
      <button
        type="button"
        className="chip chip-sm"
        onClick={findPdfLikeElenco}
        disabled={findingPdf || linkLoading || saving}
        title="Prova ad individuare il PDF cercandolo nell’Elenco preventivi"
      >
        {findingPdf ? "Cerco…" : "🔎 PDF"}
      </button>
    </div>
  )}
</div>

    {/* PDF manuale */}
    <div className="am-cell am-col">
      <div className="am-lbl" style={{display:'flex',alignItems:'center',gap:8}}>
        <button
          type="button"
          onClick={() => document.getElementById(`pdfFileHidden-${eid}`)?.click()}
          disabled={saving}
          title="Carica un PDF"
          className="am-ico-btn"
          style={{display:'inline-flex',alignItems:'center',gap:6,padding:'4px 8px',border:'1px solid #e5e7eb',borderRadius:8,background:'#f9fafb',cursor:'pointer'}}
        >
          📄 <b>PDF</b>
        </button>
      </div>

      <input
        name="pdf_path"
        type="text"
        inputMode="url"
        className="am-input am-url am-url-sm"
        value={form.pdf_path || ""}
        onChange={(e) => setField("pdf_path", e.target.value)}
        disabled={saving}
        placeholder="URL PDF"
        aria-label="URL PDF"
      />



{form.pdf_path && (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: 4,
      marginTop: 6,
    }}
  >
    <div style={{ display: "flex", gap: 6 }}>
      <button
        type="button"
        className="chip chip-sm"
        onClick={() =>
          window.open(form.pdf_path, "_blank", "noopener,noreferrer")
        }
        title="Apri PDF"
      >
        🔗 Apri
      </button>

      <button
        type="button"
        className="chip chip-sm"
        onClick={() => setMailOpen((v) => !v)}
        disabled={mailSending}
        title={
          clientEmail
            ? `Invia il PDF a ${clientEmail}`
            : "Invia il PDF via mail"
        }
      >
        ✉️ Invia mail
      </button>
    </div>
  </div>
)}







    </div>





      {/* file picker nascosto */}
      <input
        id={`pdfFileHidden-${eid}`}
        type="file"
        accept="application/pdf,.pdf"
        style={{ display: "none" }}
        onChange={async (e) => {
          const f = e.target.files?.[0];
          if (!f) return;
          try {
            setSaving(true);
     const fd = new FormData();
fd.append("event_id", String(eid));
fd.append("kind", "pdf");
fd.append("file", f);
fd.append("operator_id", String(opId));               // 👈 nuovo
fd.append("uploaded_by_operator_id", String(opId));   // 👈 nuovo
const r = await fetch("/preventivi/agenda/api/upload_file.php", {
  method: "POST",
  body: fd,
  credentials: "same-origin",
});

            const j = await r.json().catch(() => ({}));
            if (!r.ok || j.status !== "OK" || !j.url) throw new Error(j.message || `HTTP ${r.status}`);
            const nextUrl = /^https?:\/\//i.test(j.url) ? j.url : `${window.location.origin}${j.url.startsWith("/") ? "" : "/"}${j.url}`;
            setField("pdf_path", nextUrl);
            onDidChange?.();
          } catch (err) {
            alert(String(err?.message || err));
          } finally {
            setSaving(false);
            e.target.value = "";
          }
        }}
      />
    </div>
  </div>

  {/* === RIGA 3: R012 / Km / Salva === */}
  <div className="am-row three">

    {/* R012 */}
    <div className="am-cell am-col am-actions">
      <button
        type="button"
        className="chip chip-sm"
        disabled={saving}
        title="Apri/compila R012"
        aria-label="Apri/compila R012"
        onClick={async () => {
          try {
            const res = await fetch(`/preventivi/R012/exists.php?appointment_id=${encodeURIComponent(eid)}`, {
              credentials: 'same-origin',
            });
            const js = await res.json().catch(() => ({}));
            if (js?.exists && js?.id) {
              window.open(`/preventivi/R012/view.php?id=${encodeURIComponent(js.id)}`, '_blank', 'noopener,noreferrer');
              return;
            }
          } catch {}
          const qs = new URLSearchParams({
            appointment_id: String(eid || ''),
            cliente_nome:   r012App?.cliente_nome || '',
            telefono:       r012App?.telefono || '',
            indirizzo:      r012App?.indirizzo || '',
            data_appuntamento: r012App?.data || '',
            ora_appuntamento:  r012App?.ora  || '',
            rilevatore: (ex?.rilevatore_name || ''),
          }).toString();
          window.open(`/preventivi/R012/form.php?${qs}`, '_blank', 'noopener,noreferrer');
        }}
      >
        R012
      </button>
    </div>

    {/* Km */}
    <div className="am-cell am-col">
      <label className="am-lbl" aria-label="Distanze">🚗</label>
      <div className="am-km-info" style={{ fontSize: 12, marginTop: 6, display: "grid", gap: 6 }}>
        {kmCalc.loading ? (
          <div>🚗 Calcolo distanza…</div>
        ) : (
          <>
            <div>Prox.: <b>{kmCalc.partialKm != null ? `${kmCalc.partialKm} km` : "—"}</b></div>
            <div>Tot.: <b>{kmCalc.dayTotalKm != null ? `${kmCalc.dayTotalKm} km` : "—"}</b></div>
            <div style={{ opacity: 0.7 }}>
              {kmCalc.msg ? kmCalc.msg : (kmCalc.partialKm == null && kmCalc.dayTotalKm == null ? "Servizio km non disponibile" : "")}
            </div>
          </>
        )}
        <div style={{ display: "flex", gap: 6 }}>
          <button
            type="button"
            className="chip chip-sm"
            onClick={() => autoKm()}
            disabled={kmCalc.loading}
            title="Ricalcola distanza e aggiorna"
          >
            ♻︎ Ricalcola km
          </button>
        </div>
      </div>
    </div>

    {/* Salva */}
    <div className="am-cell am-col am-actions-right">
      <button
        type="button"
        className="chip chip-primary chip-sm"
        onClick={onClickSave}
        disabled={saving}
        title="Salva i dati dell'appuntamento"
        aria-label="Salva dati"
      >
        💾 Salva dati
      </button>
    </div>
  </div>
  
  {/* Toast “Salvato ✓” */}
  {savedOk > 0 && (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        right: 12,
        bottom: 12,
        background: "#16a34a",
        color: "#fff",
        padding: "8px 10px",
        borderRadius: 10,
        boxShadow: "0 8px 20px rgba(22,163,74,.25)",
        zIndex: 10000
      }}
    >
      Salvato ✓
    </div>
  )}




  {/* Overlay invio mail PDF */}
  {mailOpen && (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(15,23,42,0.30)", // sfondo leggermente scuro
      }}
    >
      <div
        style={{
          width: "min(840px, 100% - 48px)",
          maxHeight: "min(520px, 100% - 48px)",
          overflow: "auto",
          border: "1px solid #e5e7eb",
          borderRadius: 16,
          padding: 16,
          fontSize: 12,
          background: "#f9fafb",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        {/* intestazione semplice */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <div style={{ fontWeight: 700, fontSize: 14 }}>
            Invia PDF preventivo via email
          </div>
          <button
            type="button"
            onClick={() => setMailOpen(false)}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontSize: 16,
              lineHeight: 1,
            }}
            aria-label="Chiudi"
            title="Chiudi"
          >
            ✕
          </button>
        </div>

        {/* Da / A */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
            gap: 8,
          }}
        >
          <div>
            <div style={{ marginBottom: 2 }}>Da</div>
            <input
              type="email"
              value={mailForm.from}
              onChange={(e) =>
                setMailForm((m) => ({ ...m, from: e.target.value }))
              }
              placeholder={mailForm.from || "mittente"}
              style={{
                width: "100%",
                fontSize: 12,
                padding: "4px 8px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                background: "#fff",
              }}
            />
          </div>

          <div>
            <div style={{ marginBottom: 2 }}>A</div>
            <input
              type="email"
              value={mailForm.to}
              onChange={(e) =>
                setMailForm((m) => ({ ...m, to: e.target.value }))
              }
              placeholder={mailForm.to || "— (manca email cliente)"}
              style={{
                width: "100%",
                fontSize: 12,
                padding: "4px 8px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                background: "#fff",
              }}
            />
          </div>
        </div>

        {/* Oggetto */}
        <div>
          <div style={{ marginBottom: 2 }}>Oggetto</div>
          <input
            type="text"
            value={mailForm.subject}
            onChange={(e) =>
              setMailForm((m) => ({ ...m, subject: e.target.value }))
            }
            style={{
              width: "100%",
              fontSize: 12,
              padding: "4px 8px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              background: "#fff",
            }}
          />
        </div>

        {/* Testo */}
        <div>
          <div style={{ marginBottom: 2 }}>Testo</div>
          <textarea
            rows={6}
            value={mailForm.body}
            onChange={(e) =>
              setMailForm((m) => ({ ...m, body: e.target.value }))
            }
            style={{
              width: "100%",
              fontSize: 12,
              padding: "4px 8px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              background: "#fff",
              resize: "vertical",
            }}
          />
        </div>

        {/* Bottoni */}
        <div
          style={{
            marginTop: 12,
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <button
            type="button"
            className="chip chip-sm"
            onClick={() => setMailOpen(false)}
            disabled={mailSending}
          >
            Annulla
          </button>

          <button
            type="button"
            className="chip chip-primary chip-sm"
            onClick={sendPdfMail}
            disabled={mailSending}
          >
            {mailSending ? "Invio…" : "Invia"}
          </button>
        </div>
      </div>
    </div>
  )}





</Modal>
  );
} // =================== /ActionModal (FINE) =====================

  // Utils minimi
  const toDate = (s) => s ? new Date(String(s).replace(' ', 'T')) : null;
  const dayDiff = (a, b) => {
    const d1 = new Date(a.getFullYear(), a.getMonth(), a.getDate());
    const d2 = new Date(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.round((d1 - d2) / 86400000);
  };

 // Mappa UI (puoi spostarla in un file di costanti)
// Mappa UI (puoi spostarla in un file di costanti)
const UI_COLORS = {
  grey:        '#9aa1a6',

  // S1 — Confermato
  green:       '#59c36a',          // verde chiaro

  // S2 — Rilevatore assegnato
  blue:        '#38bdf8',          // azzurro

  // S3 / S3S — Passa al Senior
  gold:        '#f5c542',          // oro

  // S4 — Rilievo non buono (pink-chiaro)
  pink:        '#fde2e8',          // ⬅️ più chiaro

  // S5 — Senior non chiuso
  red:         '#e24d4d',          // rosso

  // S6 — Senior chiuso
  darkGreen:   '#0f6c3d',          // verde scuro

  // S7 — Annullato (marrone chiaro)
  brownLight:  '#d7b59a',
  borderBrown: '#8b5e34',

  // S8 — POSA
  violet:      '#8b5cf6',
  borderViolet:'#6d28d9',

  // S9 — In gestione (arancione con bordo rosso)
  orange:      '#f6a623',

   lemon:       '#fff79a', // S10: da spostare
 borderLemon: '#e0d85c',

  // Bordi
  borderRed:   '#d0021b',
  borderGold:  '#d4a017',
};


  function deriveEventUI(ev, now = new Date()) {
    const ex = ev?.extendedProps || ev || {};
    const isBlock = (typeof isBlockEvent === 'function') ? isBlockEvent(ev) : false;

    const stato        = String(ex.stato || '').toLowerCase();
    const rilId        = Number(ex.rilevatore_id || 0);
    const senId        = Number(ex.senior_id || 0);
    const wantSenior   = Number(ex.want_senior || ex.pass_to_senior || 0) === 1 || stato === 'senior_da_programmare';
    const rilNonBuono  = Number(ex.ril_non_buono || 0) === 1;
    const seniorEsito  = String(ex.senior_esito || '').toLowerCase(); // '', 'chiuso', 'non_chiuso'
    const confirmed    = stato === 'confermato' || !!ex.confirmed_at;

    const start = toDate(ex.start_dt || ev.start || ex.start);
    const tomorrowAlert = (!confirmed && start && dayDiff(start, now) === 1);

    // Default
    let bg = UI_COLORS.grey;
    let border = null;
    let state = 'prenotato';

    if (isBlock) {
      bg = UI_COLORS.orange; state = 'blocco';
    } else if (seniorEsito === 'chiuso') {
      bg = UI_COLORS.darkGreen; border = UI_COLORS.borderGold; state = 'senior_chiuso';
    } else if (seniorEsito === 'non_chiuso') {
      bg = UI_COLORS.red; state = 'senior_non_chiuso';
    } else if (rilNonBuono) {
      bg = UI_COLORS.pink; state = 'non_buono';
    } else if (wantSenior) {
      bg = UI_COLORS.gold; state = 'senior';
      if (senId > 0) border = UI_COLORS.borderRed; // senior assegnato → bordo rosso
    } else if (rilId > 0) {
      bg = UI_COLORS.blue; state = 'assegnato';
    } else if (confirmed) {
      bg = UI_COLORS.green; state = 'confermato';
    } else if (stato === 'annullato') {
      bg = UI_COLORS.grey; state = 'annullato';
    }

    if (!border && tomorrowAlert) border = UI_COLORS.borderRed;

    const showOnPro  = true;
    const showOnCall = !(wantSenior || seniorEsito); // sparisce da call quando passa al Senior o ha esito Senior

    return {
      bg, border, state, showOnCall, showOnPro,
      badges: {
        rilevatore: ex.rilevatore_name || '',
        senior: ex.senior_name || ''
      }
    };
  }
  // Utils minimi
  // Utils minimi
  // Utils minimi


// Normalizza una riga evento proveniente dai vari endpoint (list/get_events.php)
function normalizeApiEventRow(row = {}) {
  const pick = (...vals) => {
    for (const v of vals) {
      const s = (v ?? "").toString().trim();
      if (s) return s;
    }
    return "";
  };

  // id (accetta anche stringhe)
  const idRaw = row.id ?? row.event_id ?? row.ID ?? row.pk ?? row._id;
  const id = idRaw != null ? String(idRaw) : null;

  // orari
  const start_dt = pick(row.start_dt, row.start, row.startDateTime, row.data_inizio, row.data, row.inizio);
  const end_dt   = pick(row.end_dt,   row.end,   row.endDateTime,   row.data_fine,  row.fine) || start_dt;

  // fascia: tag [PF:] > campo > calcolata dall’orario
  let fascia = (pick(row.fascia, getNoteTag?.(row.note, "PF")) || "").toUpperCase();
  if (!["M","P","S"].includes(fascia)) {
    if (start_dt) fascia = fasciaFromDate(start_dt);
  }

  // anagrafiche
  const nome_cliente       = pick(row.nome_cliente, row.cliente_nome, row.nome, row.title, "Cliente");
  const cliente_telefono   = pick(row._telView, row.cliente_telefono, row.telefono, row.cliente_tel, row.phone);
  const cliente_indirizzo  = pick(row.cliente_indirizzo, row.indirizzo, row.address);
  const comune             = pick(row._comuneView, row.comune, row.citta, row.city, getNoteTag?.(row.note, "CITTA"));
  const cap                = pick(row.cap, row.CAP, row.zip, getNoteTag?.(row.note, "CAP"));
  const stato              = String(row.stato || "");

  // fori/quantità (rispetta _qtaView dal BE se già presente)
  const fori_qta   = row.fori_qta != null ? Number(row.fori_qta) : null;
  const fori_descr = pick(row.fori_descr, row.qta_descr, getNoteTag?.(row.note, "QTA"));
  let _qtaView = row._qtaView || "—";
  if (!_qtaView || _qtaView === "—") {
    if (Number.isFinite(fori_qta) && fori_qta > 0) {
      _qtaView = String(fori_qta);
    } else if (fori_descr) {
      const toInt = (s) => {
        const n = parseInt(String(s || "").replace(/[^\d]/g, ""), 10);
        return Number.isFinite(n) ? n : 0;
      };
      const pickNum = (reA, reB) => {
        const m = String(fori_descr).match(reA) || String(fori_descr).match(reB);
        return m ? toInt(m[1]) : 0;
      };
      const fin = pickNum(/Finestre\s*[:=]\s*(\d+)/i, /(?:^|\b)Fin\s*=\s*(\d+)/i);
      const pf  = pickNum(/Porte[-\s]?finestre\s*[:=]\s*(\d+)/i, /(?:^|\b)PF\s*=\s*(\d+)/i);
      const por = pickNum(/Portoncino\s*[:=]\s*(\d+)/i, /(?:^|\b)Por\s*=\s*(\d+)/i);
      const bli = pickNum(/Blindato\s*[:=]\s*(\d+)/i, /(?:^|\b)Bli\s*=\s*(\d+)/i);
      const alt = pickNum(/Altro\s*[:=]\s*(\d+)/i, /(?:^|\b)Altro\s*=\s*(\d+)/i);
      const tot = fin + pf + por + bli + alt;
      _qtaView = tot ? `Fin=${fin}, PF=${pf}, Por=${por}, Bli=${bli}, Altro=${alt}` : "—";
    }
  }

  // assegnazioni / processo (mappa anche eventuali alias)
  const rilevatore_id   = Number(row.rilevatore_id ?? row.rilevatore ?? row.rid ?? 0) || 0;
  const senior_id       = Number(row.senior_id     ?? row.senior     ?? row.sid ?? 0) || 0;
  const rilevatore_name = pick(row.rilevatore_name, row.rilevatore_label, row.rilevatore_nome);
  const senior_name     = pick(row.senior_name, row.senior_label, row.senior_nome);

  const want_senior   = Number(row.want_senior ?? row.pass_to_senior ?? 0) ? 1 : 0;
  const ril_non_buono = Number(row.ril_non_buono ?? 0) ? 1 : 0;

  let senior_esito = pick(row.senior_esito, row.esito_senior, "");
  senior_esito = senior_esito.toString().toLowerCase();

   // preventivi/budget + campi preventivatore [PDF_FIX]
  const pv_total                 = row.pv_total ?? null;
  const pv_budget                = row.pv_budget ?? null;
  const pv_budget_rilevatore_eur = row.pv_budget_rilevatore_eur ?? row.pv_budget ?? null;
  const pv_budget_senior_eur     = row.pv_budget_senior_eur ?? null;


    // 🔵 NUOVO: info finanziamento Real
  const real_finanziato = row.real_finanziato ?? row.finanziato ?? null;
  const real_mesi       =
    row.real_mesi ?? row.finanziamento_mesi ?? row.fin_mesi ?? null;




  // [PDF_FIX] 👉 servono per costruire il link PDF
  const preventivo_id   = row.preventivo_id ?? row.preventivoId ?? row.quote_id ?? null;
  const quote_id        = row.quote_id ?? null;            // qualcuno lo salva così
  const preventivo_json = row.preventivo_json ?? row.prev_json ?? null;
  const prev_url        = row.prev_url ?? row.preventivatore_url ?? row.preventivatore_link ?? null;

  // allegati (manuali e del preventivatore)
  const pdf_path        = row.pdf_path   ?? null;                // PDF esterno (colonna standard)
  const audio_path      = row.audio_path ?? null;                // audio esterno (colonna standard)
  const prev_pdf_path   = row.prev_pdf_path   ?? row.prevPdfPath   ?? null; // PDF Preventivatore
  const prev_audio_path = row.prev_audio_path ?? row.prevAudioPath ?? null; // (se mai servirà)





  // altri campi “convenience” già presenti nel tuo BE
  const created_by_name = row.created_by_name ?? row.updated_by_name ?? row.created_by ?? "";
  const history = Array.isArray(row.history) ? row.history : [];
  const note = row.note || "";

  return {
    ...row,
    id,
    start_dt,
    end_dt,
    fascia,
    nome_cliente,
    cliente_telefono,
    cliente_indirizzo,
    comune,
    cap,
    stato,
    fori_qta,
    fori_descr,
    _qtaView,
    rilevatore_id,
    senior_id,
    rilevatore_name,
    senior_name,
    want_senior,
    ril_non_buono,
    senior_esito,
    esito_senior: senior_esito,
    pv_total,
    pv_budget,
    pv_budget_rilevatore_eur,
    pv_budget_senior_eur,


    // 🔵 NUOVO
    real_finanziato,
    real_mesi,


     preventivo_id,
    quote_id,
    preventivo_json,
    prev_url,
    // Allegati
    pdf_path,
    audio_path,
    prev_pdf_path,
    prev_audio_path,
    // Extra
    created_by_name,
    history,
    note,
  };
} 




/* ====================== COMPONENTE PRINCIPALE ====================== */
export default function AgendaPro() {
  /* =============== Auth & permessi (safe per i rules-of-hooks) =============== */
  const auth = useAuth();                 // <-- HOOK: chiamato una volta sola
  const user = auth?.user || null;



  // ID utente normalizzato (mai NaN/negativo)
  const UID = useMemo(() => {
    const raw = user?.id ?? user?.ID ?? auth?.ID ?? auth?.uid ?? auth?.user_id ?? null;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : 0;
  }, [user, auth]);



  // Email utente loggato (mittente mail preventivo)
  const meEmail = useMemo(() => {
    const raw =
      user?.email ??
      user?.mail ??
      user?.username_email ??
      auth?.email ??
      auth?.user_email ??
      null;
    return raw ? String(raw).trim() : "";
  }, [user, auth]);


  // Ruolo normalizzato (prima 'ruolo' DB, poi eventuale 'role')
  const roleNorm = useMemo(() => {
    const raw = auth?.ruolo ?? auth?.role ?? user?.ruolo ?? user?.role ?? "user";
    return String(raw).trim().toLowerCase();
  }, [auth?.ruolo, auth?.role, user]);


  // 🔹 Parametri di boot dall’hash (#/agenda-pro?day=YYYY-MM-DD&event=...)
  const boot = useMemo(() => {
    if (typeof window === "undefined") return { day: "", eventId: null };
    return getBootFromHash();
  }, []);


  // Flag derivati dal ruolo
  const isSeniorPosa = useMemo(
    () => /(?:^|_)(?:senior_posa|posa_senior|seniorposa)(?:$|_)/.test(roleNorm) || /^posa(?:$|-)/.test(roleNorm),
    [roleNorm]
  );

  const isFieldUser = useMemo(
    () =>
      !isSeniorPosa &&
      (["rilevatore", "rilievo", "ril", "junior", "tecnico", "field"].includes(roleNorm) ||
        roleNorm.includes("senior")),
    [roleNorm, isSeniorPosa]
  );

  const isResponsabile = useMemo(
    () => roleNorm.startsWith("resp") || roleNorm.includes("responsabile"),
    [roleNorm]
  );


  /* ================= Stato / utility locali base ================= */
  // Modale azioni
  const [openAction, setOpenAction] = useState(false);
  const [actionEvent, setActionEvent] = useState(null);

  // Rileva touch (per non mostrare tip su mobile)
  const isTouchRef = useRef(false);
  useEffect(() => {
    const onTouchStart = () => { isTouchRef.current = true; Tip.hide(true); };
    window.addEventListener("touchstart", onTouchStart, { passive: true });
    return () => window.removeEventListener("touchstart", onTouchStart);
  }, []);

  // Chiudi tip su scroll/resize/ESC
  useEffect(() => {
    const off = () => Tip.hide(true);
    const onKey = (e) => { if (e.key === "Escape") Tip.hide(true); };
    const opt = { capture: true, passive: true };
    window.addEventListener("scroll", off, opt);
    window.addEventListener("resize", off);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("scroll", off, opt);
      window.removeEventListener("resize", off);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  // Click evento → apri modale azioni
  


  
const handleEventClick = useCallback((click) => {
  try { Tip.cancel?.(); Tip.hide?.(true); } catch {}
  click.jsEvent?.preventDefault();
  click.jsEvent?.stopPropagation();

  // ⬇️ IGNORA overlay (e anche i blocchi, se vuoi)
  const ex = click?.event?.extendedProps || {};
  if (ex.overlay /* || isBlockEvent(click.event) */) return;

  setActionEvent(click.event);
  setOpenAction(true);
}, []);


  // ⬇️ BLOCCO TIP quando la modale è aperta + chiudi eventuale popup
  useEffect(() => {
    Tip.lock?.(!!openAction);          // disabilita/abilita i popover
    if (openAction) {
      try { Tip.hide?.(true); } catch {}
    }
  }, [openAction]);

  // Canale di sync con AgendaCall
  const bcRef = useRef(null);
  useEffect(() => {
    try { bcRef.current = new BroadcastChannel("agenda_sync"); } catch {}
    return () => { try { bcRef.current?.close(); } catch {} };
  }, []);



// Evita loop: ricalcola conflitti solo se la lista eventi è davvero cambiata
const lastEventsSigRef = useRef("");

const onEventsSetSafe = useCallback((events) => {
  try {
    const sig = (events || [])
      .map(e => {
        const s = +new Date(e.start || e.extendedProps?.start);
        const t = +new Date((e.end || e.start || e.extendedProps?.end || e.extendedProps?.start));
        const rid = Number(e.extendedProps?.rilevatore_id || 0);
        const sid = Number(e.extendedProps?.senior_id || 0);
        return `${e.id}:${s}:${t}:${rid}:${sid}`;
      })
      .join("|");

    if (sig === lastEventsSigRef.current) return; // nessun cambiamento strutturale
    lastEventsSigRef.current = sig;

    const next = computeOwnerConflicts(events, MIN_GAP_MINUTES, MIN_GAP_SENIOR);
    setRidConflictIds(prev => {
      if (prev.size === next.size && [...prev].every(x => next.has(x))) return prev;
      return next;
    });
  } catch {}
}, []);




  // --- FILTRI (zona bloccata per responsabile) ---
  // --- FILTRI (zona bloccata per responsabile) ---
// Legge prima da localStorage, altrimenti dalla zona utente, altrimenti 1 (Verona)
const [zonaId, setZonaId] = useState(() => {
  try {
    const saved = window.localStorage.getItem("agendaZonaId");
    if (saved != null && saved !== "") {
      const n = Number(saved);
      if (Number.isFinite(n) && n > 0) return n;
    }
  } catch {}
  const z = Number(user?.zona_id || 1);
  return Number.isFinite(z) && z > 0 ? z : 1;
});

// [B] Forza la zona dell'utente se lockZone è ON (o se responsabile)


// ▼▼▼ PERMESSI DAL DB (fetch invariato sopra) ▼▼▼
const [srvCaps, setSrvCaps] = useState(null);

useEffect(() => {
  if (!UID) return;
  // caps.php → legge la sessione PRINFSESSID e risponde con i bit reali (snake + alias)
  const q = zonaId ? `?zone_id=${zonaId}` : "";
  fetch(`/preventivi/agenda/api/acl/caps.php${q}`, { credentials: "include" })
    .then(r => r.json())
    .then(j => {
      // j = { status:'OK', role:'admin', caps:{…} }
      setSrvCaps(j?.caps || {});
      if (j?.role === 'ospite') {
        console.warn('[ACL] caps.php ha risposto role=ospite: verifica cookie di sessione/PRINFSESSID');
      }
    })
    .catch(() => setSrvCaps({}));
}, [UID, zonaId]);


// helper: interpreta 1/0, true/false, "YES"/"NO", "SI"/"NO"
const yn = useCallback((v) => {
  if (typeof v === "string") {
    const s = v.trim().toUpperCase();
    return s === "YES" || s === "SI" || s === "TRUE" || s === "1" || s === "ON";
  }
  return !!v;
}, []);

const isAdmin = useMemo(() => /(^|[_-])admin($|[_-])/.test(String(roleNorm)), [roleNorm]);




// 0) Normalizzazione caps dal server: mappa/alias e NON scrivere chiavi assenti
const caps = useMemo(() => {
  const s = srvCaps ?? {};

  const hasOwn = (k) => Object.prototype.hasOwnProperty.call(s, k);
  const pick = (...keys) => {
    for (const k of keys) if (hasOwn(k)) return yn(s[k]);
    return undefined; // chiave assente -> non sovrascrivere il base
  };

  const out = {};
  const set = (k, v) => { if (v !== undefined) out[k] = v; };

    // core
  set('canMoveEvent',         pick('canMoveEvent'));
  set('canConfirm',           pick('canConfirm'));
  set('canAssignRilevatore',  pick('canAssignRilevatore'));
  set('canAssignSenior',      pick('canAssignSenior'));
  set('canCancel',            pick('canCancel'));
  set('canReset',             pick('canReset'));
  set('canDelete',            pick('canDelete'));
  set('canToggleSeniorWant',  pick('canToggleSeniorWant'));
  set('canMarkRilNonBuono',   pick('canMarkRilNonBuono'));
  set('canSetSeniorEsito',    pick('canSetSeniorEsito'));
  set('canUsePreventivatore', pick('canUsePreventivatore'));
  set('canUploadFiles',       pick('canUploadFiles'));
  set('canEditBudgets',       pick('canEditBudgets'));

  // sicurezza / visibilità
  set('phoneDelay',           pick('phoneDelay'));
  set('readOnly',             pick('readOnly'));
  set('restrictAssignedOnly', pick('restrictAssignedOnly'));

  // field: supporta sia camelCase che snake_case da caps_get.php
  set('seniorViewEsiti', pick(
    'seniorViewEsiti',
    'senior_view_esiti',
    'senior_view_esito'
  ));
  set('seniorViewPass', pick(
    'seniorViewPass',
    'senior_view_pass'
  ));

  // nuovi permessi + alias snake_case (compat con camelCase)
  set('canPushToPosa', pick('posa_push', 'canPushToPosa'));
  set('zoneLock',      pick('zone_lock', 'zoneLock'));
  set('zoneMulti',     pick('zone_multi', 'zoneMulti'));

    set('showOverlaysUi', pick('showOverlaysUi', 'show_overlays_ui', 'overlays_ui'));


  return out;
}, [srvCaps, yn]);

// 1) Base permessi dal ruolo (default locali, es. admin = tutto aperto)
const baseCaps = useMemo(
  () => deriveRoleCaps(roleKeyFromNorm(roleNorm)),
  [roleNorm]
);

// 2) Evita flicker: se il server non ha ancora risposto, non toccare i base
const hasSrvCaps = useMemo(
  () => !!(srvCaps && Object.keys(srvCaps).length > 0),
  [srvCaps]
);

// 3) Merge finale — server override solo quando presenti; admin non viene ristretto
const capsMerged = useMemo(() => {
  const merged = hasSrvCaps ? { ...baseCaps, ...caps } : { ...baseCaps };

  if (isAdmin) {
    merged.readOnly = false;
    merged.restrictAssignedOnly = false;
  }

  return merged;
}, [hasSrvCaps, baseCaps, caps, isAdmin]);

// chi può vedere i pallini overlay e la 🌐
const canSeeOverlaysUi = !!capsMerged.showOverlaysUi;




// 4) Debug: esponi i caps calcolati (comodo da console)
useEffect(() => {
  if (isAdmin) {
    window.__CAPS = { roleNorm, baseCaps, srvCaps, caps, capsMerged };
  }
}, [isAdmin, roleNorm, baseCaps, srvCaps, caps, capsMerged]);






// (debug facoltativo)
useEffect(() => {
  window.__CAPS = { roleNorm, baseCaps, srvCaps, capsMerged };
  console.log('__CAPS', window.__CAPS);
}, [roleNorm, baseCaps, srvCaps, capsMerged]);

// [A] Lock zona (dipende dai permessi effettivi)
const lockZone = !!capsMerged.zoneLock;

// (facoltativo) whitelist zone dal BE se hai implementato caps.viewZones in caps_get.php
const allowedZones = Array.isArray(srvCaps?.viewZones)
  ? new Set(srvCaps.viewZones.map(Number))
  : null;

useEffect(() => {
  const z = Number(user?.zona_id || 0);
  if (z > 0 && (lockZone || isResponsabile) && z !== zonaId) {
    setZonaId(z);
  }
}, [lockZone, isResponsabile, user?.zona_id, zonaId]);


// Salva sempre la zona corrente in localStorage
useEffect(() => {
  try {
    if (Number.isFinite(Number(zonaId)) && Number(zonaId) > 0) {
      window.localStorage.setItem("agendaZonaId", String(zonaId));
    }
  } catch {}
}, [zonaId]);






const [filterRil, setFilterRil] = useState(0);
const [fStato, setFStato] = useState("");
const [q, setQ] = useState("");

/* === DATA per Auto-assegna (default: oggi) === */
const _today = () => {
  const d = new Date();
  const y = d.getFullYear(), m = String(d.getMonth()+1).padStart(2,'0'), dd = String(d.getDate()).padStart(2,'0');
  return `${y}-${m}-${dd}`;
};
const [assignDate, setAssignDate] = useState(_today());

// Usa la data visibile nel calendario (locale) se non imposti manualmente assignDate
const dayISO = useCallback(() => {
  const api = calRef.current?.getApi?.();
  const d = api?.getDate?.() || new Date();
  const y = d.getFullYear(), m = String(d.getMonth()+1).padStart(2,'0'), dd = String(d.getDate()).padStart(2,'0');
  return `${y}-${m}-${dd}`;
}, []);



// === MAPPA: costruisci URL e apri in nuova scheda ===
const mapUrlForCurrentDay = React.useCallback(() => {
  const d = dayISO();                       // giorno attualmente visibile
  const z = Number(zonaId || 0) || '';      // zona selezionata nel filtro
  const u = new URL(`${window.location.origin}/preventivi/agenda_map/map_v2.php`);
  u.searchParams.set('d', d);
  if (z) u.searchParams.set('zona', String(z));
  return u.toString();
}, [dayISO, zonaId]);

const openMapInNewTab = React.useCallback(() => {
  window.open(mapUrlForCurrentDay(), '_blank', 'noopener,noreferrer');
}, [mapUrlForCurrentDay]);




const dateForOps = useCallback(() => assignDate || dayISO(), [assignDate, dayISO]);


// Riferimenti base
const calRef = useRef(null);



// ── Ricostruisce i dots negli header (solo viste a colonne) ─────────────
const rebuildHeaderDots = useCallback(
  (overlaysArr, openNewFn, openEditFn) => {
    // se il ruolo NON deve vedere pallini + globe, pulisco e basta
    if (!canSeeOverlaysUi) {
      document
        .querySelectorAll(".ov-dots, .ov-slot--right")
        .forEach((n) => {
          try { n.remove(); } catch {}
        });
      return;
    }

    const api = calRef.current?.getApi?.();
    const vt  = api?.view?.type || "";

    // quali view hanno l’header "a colonne" sopra le ore?
    const isTimeCols =
      vt === "standard" ||              // 👈 vista custom 7 giorni
      vt === "timeGridWeek" ||
      vt === "timeGridDay"  ||
      vt === "timeGridThreeDay" ||
      vt.startsWith("timeGrid");

    // la logica pallini-header serve SOLO su colonne orarie, + eventualmente dayGridWeek
    if (!isTimeCols && vt !== "dayGridWeek") return;

    // 0) Pulizia TOTALE in TUTTO il documento (sia pallini che slot-destra)
    document
      .querySelectorAll(".ov-dots, .ov-slot--right")
      .forEach((n) => {
        try { n.remove(); } catch {}
      });

    // 1) prendi TUTTI i th[data-date] visibili di QUALSIASI header
    const ths = Array
      .from(document.querySelectorAll(".fc-col-header th[data-date]"))
      .filter((el) => el && el.offsetParent !== null);
    if (!ths.length) return;

    // 2) scegli il PRIMO (quello più in alto) per ciascun ymd
    const pick = new Map(); // ymd -> { th, top }
    ths.forEach((th) => {
      const ymd = th.getAttribute("data-date");
      if (!ymd) return;
      const top = th.getBoundingClientRect().top;
      const cur = pick.get(ymd);
      if (!cur || top < cur.top - 0.5) pick.set(ymd, { th, top });
    });

    // 3) disegna i pallini (sinistra) e la 🌐 (destra) solo sul th scelto
    pick.forEach(({ th }, ymd) => {
      th.style.position = th.style.position || "relative";

      // contenitore pallini a SINISTRA
      const dots = document.createElement("span");
      dots.className = "ov-dots";
      Object.assign(dots.style, {
        position: "absolute",
        left: "6px",
        top: "6px",
        display: "inline-flex",
        gap: "6px",
        alignItems: "center",
        pointerEvents: "auto",
        zIndex: 2,
      });
      th.appendChild(dots);

      // pallino grigio = crea nuovo overlay
      dots.appendChild(
        makeDot("#9aa1a6", "Nuovo overlay per questo giorno", () =>
          openNewFn(ymd)
        )
      );

      // pallini colorati = modifica overlay esistenti
overlaysForDay(overlaysArr, ymd)
  .sort((a, b) => String(a.start_dt).localeCompare(String(b.start_dt)))
  .forEach((o) => {
    const isGlobal =
      Number(o.global_rilevatori ?? o.is_global_ril ?? 0) === 1 ||
      Number(o.global_senior     ?? o.is_global_snr ?? 0) === 1;

    dots.appendChild(
      makeDot(
        o?.color || "#9aa1a6",
        o?.note || "Modifica / elimina overlay",
        () => openEditFn(o),
        { isGlobal }                 // 👈 bordo rosso se aziendale
      )
    );
  });


      // 🌐 a DESTRA
      addGlobeToTh(th, ymd, zonaId);
    });
  },
  [calRef, zonaId, canSeeOverlaysUi]
);











const [loading, setLoading] = useState(false);


// ===== Overlays (stato dentro al componente) =====
const [overlays, setOverlays]       = useState([]);      
const [overlayOpen, setOverlayOpen] = useState(false);   
const [editOverlay, setEditOverlay] = useState(null);    










// giorno di default per il modale overlay
const [ovDefaultDay, setOvDefaultDay] = useState(dayISO());

// apri "nuovo" overlay sul giorno (pallino grigio)
const openOverlayNew = useCallback((ymd) => {
  setEditOverlay(null);
  setOvDefaultDay(ymd || dayISO());
  setOverlayOpen(true);
}, []);

// apri in "edit" un overlay esistente (pallino colorato)
const openOverlayEdit = useCallback((ov) => {
  setEditOverlay(ov || null);
  const ymd = String(ov?.start_dt || "").slice(0,10) || dayISO();
  setOvDefaultDay(ymd);
  setOverlayOpen(true);
}, []);

// dettaglio overlay per edit (serve se dal list.php non arrivano i partecipanti)







const decorateDayHeader = useCallback((arg) => {
  try {
   
  } catch {}
}, []);


const decorateDayCell = useCallback(
  (arg) => {
    try {
      // ✅ SOLO nella vista "Mese"
      const viewType = arg.view?.type || arg.view?.calendar?.view?.type;
      if (viewType !== "dayGridMonth") return;
      if (!arg?.el || !arg?.date) return;

      const top = arg.el.querySelector(".fc-daygrid-day-top") || arg.el;
      if (!top) return;

      // pulizia sempre, così non rimangono residui
      Array.from(
        top.querySelectorAll(
          ":scope > .ov-dots, :scope > .ov-slot--right, :scope > .ov-dot"
        )
      ).forEach((n) => {
        try { n.remove(); } catch {}
      });

      // se l’utente NON deve vedere pallini + globe, esci qui
      if (!canSeeOverlaysUi) return;

      if (!Array.isArray(overlays)) return;
      const ymd = ymdLocal(arg.date);
      if (!ymd) return;

      top.style.position = top.style.position || "relative";

      // ⬅️ contenitore pallini a SINISTRA
      const dots = document.createElement("span");
      dots.className = "ov-dots";
      Object.assign(dots.style, {
        position: "absolute",
        left: "4px",
        top: "4px",
        display: "inline-flex",
        gap: "6px",
        alignItems: "center",
        pointerEvents: "auto",
        zIndex: 2,
      });
      top.appendChild(dots);

      // grigio (crea)
      dots.appendChild(
        makeDot("#9aa1a6", "Nuovo overlay per questo giorno", () =>
          openOverlayNew(ymd)
        )
      );

      // colorati (edit)overlaysForDay(overlays, ymd)overlaysForDay(overlays, ymd)
overlaysForDay(overlays, ymd)
  .sort((a, b) => String(a.start_dt).localeCompare(String(b.start_dt)))
  .forEach((o) => {
    const isGlobal =
      Number(o.global_rilevatori ?? o.is_global_ril ?? 0) === 1 ||
      Number(o.global_senior     ?? o.is_global_snr ?? 0) === 1;

    dots.appendChild(
      makeDot(
        o?.color || "#9aa1a6",
        o?.note || "Modifica / elimina overlay",
        () => openOverlayEdit(o),
        { isGlobal }
      )
    );
  });




      // ➡️ slot a DESTRA per la 🌐 (spostato a sinistra del numero del giorno)
      const right = document.createElement("span");
      right.className = "ov-slot ov-slot--right";
      Object.assign(right.style, {
        position: "absolute",
        right: "26px",
        top: "4px",
        display: "inline-flex",
        gap: "6px",
        alignItems: "center",
        pointerEvents: "auto",
        zIndex: 2,
      });
      top.appendChild(right);

      const a = document.createElement("a");
      a.href = mapUrlForYmd(ymd, zonaId);
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.title = "Apri mappa del giorno";
      a.textContent = "🌐";
      Object.assign(a.style, {
        textDecoration: "none",
        fontSize: "14px",
        lineHeight: 1,
        cursor: "pointer",
      });
      right.appendChild(a);
    } catch {
      // no-op
    }
  },
  [overlays, openOverlayNew, openOverlayEdit, zonaId, canSeeOverlaysUi]
);




// Sync + refetch
const notifyChanged = useCallback(() => {
  try { bcRef.current?.postMessage({ type: "events:changed", at: Date.now() }); } catch {}
}, []);
const refetch = useCallback(() => {
  const api = calRef.current?.getApi?.();
  if (api) api.refetchEvents();
}, []);

// Barra disponibilità
const [slots, setSlots] = useState([]);
useEffect(() => {
  (async () => {
    try {
      const s = await fetchSlots(todayYMD(), 7, zonaId);
      setSlots(s);
    } catch {
      setSlots([]);
    }
  })();
}, [zonaId]);


/* === AUTO-ASSEGNA & GEOCODE (allineato a BE v3.5) === */
const [assignLoading, setAssignLoading] = useState(false);
const [geoLoading, setGeoLoading]       = useState(false);
const [assignReport, setAssignReport]   = useState(null);
const [geoReport, setGeoReport]         = useState(null);

// ✅ includi anche i "prenotato" (di default)
const [confirmedOnly, setConfirmedOnly] = useState(false);

// opzionale: se in futuro il BE supporta forzare riassegnazioni
const [forceAssign, setForceAssign]     = useState(false);

// parser robusto (tenta JSON, altrimenti torna testo)
const readJson = useCallback(async (res) => {
  const t = await res.text();
  try { return JSON.parse(t); } catch { return { status: "ERR", message: t }; }
}, []);

// 📍 Geocodifica del giorno
// scope: "missing" | "all" | "dryrun"
const geocodeDay = useCallback(async (scope = "missing") => {
  try {
    setGeoLoading(true);
    setGeoReport(null);

    const qs = new URLSearchParams({
      date: dateForOps(),
      zona_id: String(zonaId),
      scope,
    });

    const res  = await fetch(`/preventivi/agenda/api/geocode_day.php?${qs}`, {
      method: "POST",
      credentials: "include",
      headers: { "Accept": "application/json" },
    });
    const data = await readJson(res);
    setGeoReport(data);

    if (data?.status === "OK" && scope !== "dryrun") {
      await refetch();
      notifyChanged();
    } else if (data?.status !== "OK") {
      alert(`Geo: ${data?.message || "errore"}`);
    }
  } catch (err) {
    console.error("[geo] error:", err);
    setGeoReport({ status: "ERR", message: String(err) });
    alert(`Errore geocodifica: ${err?.message || err}`);
  } finally {
    setGeoLoading(false);
  }
}, [zonaId, dateForOps, readJson, refetch, notifyChanged]);

// ⚙️ Auto-assegna (fasce 100', RIL→RESP→SEN, bilanciamento, stato='assegnato')
const autoAssignDay = useCallback(async () => {
  try {
    setAssignLoading(true);
    setAssignReport(null);

    const qs = new URLSearchParams({
      date: dateForOps(),
      zona_id: String(zonaId),
      debug: "1",
      confirmed_only: confirmedOnly ? "1" : "0",
    });
    if (forceAssign) qs.append("force", "1");

    const res  = await fetch(`/preventivi/agenda/api/auto_assign_day.php?${qs}`, {
      method: "POST",
      credentials: "include",
      headers: { "Accept": "application/json" },
    });
    const data = await readJson(res);
    setAssignReport(data);

    if (data?.status === "OK") {
      await refetch();
      notifyChanged();
      console.log("[auto-assign OK]", data);
    } else {
      console.warn("[auto-assign FAIL]", data);
      alert(`Auto-assegna: ${data?.message || data?.hint || "errore"}`);
    }
  } catch (err) {
    console.error("[auto-assign] error:", err);
    setAssignReport({ status: "ERR", message: String(err) });
    alert(`Auto-assegna fallita: ${err?.message || err}`);
  } finally {
    setAssignLoading(false);
  }
}, [zonaId, dateForOps, confirmedOnly, forceAssign, readJson, refetch, notifyChanged]);

// 🧪 Dry-run: simula senza scrivere
const autoAssignDayDryRun = useCallback(async () => {
  try {
    setAssignLoading(true);
    setAssignReport(null);

    const opId = Number(
  user?.operatori_id ??
  user?.operatore_id ??
  user?.operator_id ??
  user?.id ??
  UID ??
  0
);

    const qs = new URLSearchParams({
      date: dateForOps(),
      zona_id: String(zonaId),
      debug: "1",
      confirmed_only: confirmedOnly ? "1" : "0",
      operator_id: String(opId),            // 👈 nuovo
    });
    if (forceAssign) qs.append("force", "1");


    const res  = await fetch(`/preventivi/agenda/api/auto_assign_day.php?${qs}`, {
      method: "POST",
      credentials: "include",
      headers: { "Accept": "application/json" },
    });
    const data = await readJson(res);
    setAssignReport(data);

    if (data?.status === "OK") {
      const tot = Object.values(data?.assigned_count || {}).reduce((a,b)=>a+b,0);
      alert(`Dry-run: eventi=${data?.debug?.events_total ?? 0} · slot=${(data?.debug?.slots||[]).join(',')} · assegnati=${tot}`);
      console.log("[auto-assign DRYRUN]", data);
    } else {
      console.warn("[auto-assign DRYRUN FAIL]", data);
      alert(`Dry-run: ${data?.message || data?.hint || "errore"}`);
    }
  } catch (err) {
    console.error("[auto-assign DRYRUN] error:", err);
    setAssignReport({ status: "ERR", message: String(err) });
    alert(`Dry-run fallita: ${err?.message || err}`);
  } finally {
    setAssignLoading(false);
  }
}, [zonaId, dateForOps, confirmedOnly, readJson]);



// 🔁 Wrapper: geolocalizza i mancanti e POI auto-assegna
const autoAssignWithGeo = useCallback(async () => {
  try {
    // 1) Geolocalizza SOLO i mancanti (data + zona corrente)
    await geocodeDay("missing");

    // 2) Poi esegue l’auto-assegna vera
    await autoAssignDay();
  } catch (err) {
    console.error("autoAssignWithGeo error:", err);
    alert(`Errore auto-assign con geo: ${err?.message || err}`);
  }
}, [geocodeDay, autoAssignDay]);




  // Model base per “Nuovo appuntamento”
  const makeEmptyNew = useCallback((zid) => ({
    cliente_id: 0,
    created_by_operator_id: 1,
    zona_id: zid || zonaId,
    date: todayYMD(),
    start_time: "10:00",
    end_time: "11:00",
    fascia: "",
    nome_cliente: "",
    cliente_telefono: "",
    cliente_indirizzo: "",
    comune: "",
    cap: "",
    note: "",
    want_senior: 0,
    pv_total: "",
    pv_budget: "",
  }), [zonaId]);

  // Selezione nel calendario → apre “Nuovo”
  const handleSelect = useCallback((sel) => {
    if (isFieldUser) return;
    const start = sel.startStr;
    const end   = sel.endStr;
    const ymd   = start.slice(0,10);
    const sHHMM = start.slice(11,16);
    const eHHMM = end.slice(11,16);
    setNewForm({
      ...makeEmptyNew(zonaId),
      date: ymd,
      start_time: sHHMM || "10:00",
      end_time:   eHHMM || "11:00",
    });
    setOpenNew(true);
  }, [isFieldUser, zonaId, makeEmptyNew]);


/* =================== UTENTI (Rilevatori + Senior) =================== */
const [utenti, setUtenti] = useState([]);

useEffect(() => {
  let alive = true;
  (async () => {
    const tryUrls = [
      `${API_USERS}/users_list.php?zona_id=${zonaId}`,
      `${API}/users_list.php?zona_id=${zonaId}`,
    ];
    for (const url of tryUrls) {
      try {
        const r = await fetch(url, { credentials: "same-origin" });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const j = await r.json().catch(() => ({}));
        const arr =
          Array.isArray(j?.rows)   ? j.rows   :
          Array.isArray(j?.items)  ? j.items  :
          Array.isArray(j?.users)  ? j.users  :
          Array.isArray(j?.utenti) ? j.utenti :
          Array.isArray(j)         ? j        : [];
        if (alive) setUtenti(arr);
        return;
      } catch {}
    }
    if (alive) setUtenti([]);
  })();
  return () => { alive = false; };
}, [zonaId]);

/* ---- helpers anagrafica/ruoli ---- */
const normRole  = useCallback((u) => String(u.ruolo ?? u.role ?? "").trim().toLowerCase(), []);
const isActiveU = useCallback((u) => boolish(u.attivo ?? u.active ?? 1), []);
const labelOf   = useCallback((u) => (u.nome ?? u.name ?? u.label ?? u.fullname ?? u.username ?? "").toString().trim(), []);
const idOf      = useCallback((u) => Number(u.id ?? u.user_id ?? u.ID ?? 0), []);

/* ---- set ruoli ammessi ---- */

// tutte le varianti di "responsabile di zona" che girano nel DB
const RESPONSABILI_ZONA_ROLES = [
  "responsabile_zona",
  "responsabile-di-zona",
  "responsabile di zona",
  "responsabile",
  "resp",
];

// SOLO ruoli da rilevatore (niente senior, niente responsabili)
const IS_RIL = useMemo(
  () => new Set([
    "rilevatore",
    "rilievo",
    "ril",
    "junior",
    "tecnico",
    "field",
    "rilevatori",
  ]),
  []
);


const IS_SNR = useMemo(
  () => new Set([
    // senior “puri”
    "senior","tecnico_senior","snr",
    // e i responsabili di zona
    ...RESPONSABILI_ZONA_ROLES,
  ]),
  []
);

const IS_SNR_POSA = useMemo(
  () => new Set(["senior_posa","posa","seniorposa","posa_senior"]),
  []
);
const IS_FMT = useMemo(
  () => new Set(["formatore","trainer","formatori"]),
  []
);


/* ---- filtro di zona (accetta numerico o liste CSV) ---- */
const inSelectedZone = useCallback((u) => {
  const z = Number(u.zona_id ?? u.zone_id ?? u.area_id ?? u.zona ?? 0);
  if (Number.isFinite(z) && z > 0) return z === zonaId;

  const raw = String(u.zone_ids ?? u.zona_ids ?? u.zones ?? "").trim();
  if (raw) {
    const arr = raw.split(/[,\s]+/).map(n => Number(n)).filter(n => Number.isFinite(n) && n > 0);
    return arr.includes(zonaId);
  }
  return false;
}, [zonaId]);

/* ---- liste derivate per UI ---- */
const rilevatori = useMemo(() => (
  (utenti || [])
    .filter(u => isActiveU(u) && IS_RIL.has(normRole(u)) && inSelectedZone(u))
    .map(u => ({ id: idOf(u), nome: labelOf(u) }))
    .filter(u => u.id > 0 && u.nome)
    .sort((a,b) => a.nome.localeCompare(b.nome, "it"))
), [utenti, isActiveU, IS_RIL, normRole, idOf, labelOf, inSelectedZone]);

const seniori = useMemo(() => (
  (utenti || [])
    .filter(u => isActiveU(u) && IS_SNR.has(normRole(u)) && inSelectedZone(u))
    .map(u => ({ id: idOf(u), nome: labelOf(u) }))
    .filter(u => u.id > 0 && u.nome)
    .sort((a,b) => a.nome.localeCompare(b.nome, "it"))
), [utenti, isActiveU, IS_SNR, normRole, idOf, labelOf, inSelectedZone]);

/* 👇 nuove liste usate dalla modale “+ Blocco” */
const seniorPosa = useMemo(() => (
  (utenti || [])
    .filter(u => isActiveU(u) && IS_SNR_POSA.has(normRole(u)) && inSelectedZone(u))
    .map(u => ({ id: idOf(u), nome: labelOf(u) }))
    .filter(u => u.id > 0 && u.nome)
    .sort((a,b) => a.nome.localeCompare(b.nome, "it"))
), [utenti, isActiveU, IS_SNR_POSA, normRole, idOf, labelOf, inSelectedZone]);

const formatori = useMemo(() => (
  (utenti || [])
    .filter(u => isActiveU(u) && IS_FMT.has(normRole(u)) && inSelectedZone(u))
    .map(u => ({ id: idOf(u), nome: labelOf(u) }))
    .filter(u => u.id > 0 && u.nome)
    .sort((a,b) => a.nome.localeCompare(b.nome, "it"))
), [utenti, isActiveU, IS_FMT, normRole, idOf, labelOf, inSelectedZone]);

/* ---- map id → nome per badge/tooltip (opzionale) ---- */
const rilById = useMemo(
  () => new Map((rilevatori || []).map(r => [Number(r.id), (r.nome || r.label || "").trim()])),
  [rilevatori]
);
const snrById = useMemo(
  () => new Map((seniori || []).map(s => [Number(s.id), (s.nome || s.label || "").trim()])),
  [seniori]
);

// Esponi le mappe ID → nome in window per i log
useEffect(() => {
  if (typeof window === "undefined") return;
  window.__RIL_BY_ID = rilById;
  window.__SNR_BY_ID = snrById;
}, [rilById, snrById]);



const nameById = useCallback((id, type = "ril") => {
  const map = type === "snr" ? snrById : rilById;
  return map.get(Number(id)) || "";
}, [rilById, snrById]);
/* =================== /UTENTI =================== */








  
  /* =================== Drag/resize con vincoli =================== */
  const handleEventChange = useCallback(async (chg) => {
  if (!capsMerged.canMoveEvent || capsMerged.readOnly) return chg.revert();

const opId = Number(
  user?.operatori_id ??
  user?.operatore_id ??
  user?.operator_id ??
  user?.id ??
  UID ??
  0
);


    const ev    = chg.event;
    const start = ev.start;
    const end   = ev.end || ev.start;



    

// --- HARD CHECK: assegnati in conflitto con overlay (rilevatore e/o senior)
try {
  const ridNow = Number(ev?.extendedProps?.rilevatore_id || 0);
  const sidNow = Number(ev?.extendedProps?.senior_id || 0);
  const sISO = dateToSql(start);
  const eISO = dateToSql(end);

  if (ridNow && hasOverlayConflictFor(ridNow, 'ril', sISO, eISO, overlays || [])) {
    alert("Il rilevatore assegnato è impegnato in un BLOCCO su questo orario.");
    chg.revert(); return;
  }
  if (sidNow && hasOverlayConflictFor(sidNow, 'senior', sISO, eISO, overlays || [])) {
    alert("Il senior assegnato è impegnato in un BLOCCO su questo orario.");
    chg.revert(); return;
  }
} catch {}







 const { role: ownerRole, id: ownerId } = pickOwnerRoleAndId(ev);

    const api = calRef.current?.getApi();
    const all = api?.getEvents() || [];

    const dKey = dayKey(start);
    const sameDay = (e) => e.start && dayKey(e.start) === dKey;

    const HH = (d) => String(d.getHours()).padStart(2, "0");
    const MM = (d) => String(d.getMinutes()).padStart(2, "0");
    const hhmm = (d) => `${HH(d)}:${MM(d)}`;

    const clientOf = (e) =>
      (e.extendedProps?.nome_cliente || e.extendedProps?.cliente_nome || "Cliente").trim();

    // HARD: sovrapposizione stesso rilevatore/senior
     const hardCheckOwner = () => {
   if (!ownerId) return false;
   const idKey   = ownerRole === "senior" ? "senior_id" : "rilevatore_id";
   const nameKey = ownerRole === "senior" ? "senior_name" : "rilevatore_name";

   const cand = all.filter(e =>
     e.id !== ev.id &&
     Number(e.extendedProps?.[idKey] || 0) === ownerId &&
     sameDay(e)
   );
   for (const o of cand) {
     const overlap = start < (o.end || o.start) && (end) > (o.start);
     if (overlap) {
       const who = (o.extendedProps?.[nameKey] || (ownerRole === "senior" ? "Senior" : "Rilevatore")).trim();
       const cli = clientOf(o);
       alert(`Conflitto ${ownerRole === "senior" ? "senior" : "rilevatore"}: ${who} ${hhmm(o.start)}–${hhmm(o.end||o.start)} · ${cli}.`);
       chg.revert();
       return true;
     }
   }
   return false;
 };

 if (hardCheckOwner()) return;

 const softWarnOwner = () => {
   if (!ownerId) return;
   const idKey   = ownerRole === "senior" ? "senior_id" : "rilevatore_id";
   const nameKey = ownerRole === "senior" ? "senior_name" : "rilevatore_name";
   const minGap  = ownerRole === "senior" ? MIN_GAP_SENIOR : MIN_GAP_MINUTES;

   const cand = all.filter(e =>
     e.id !== ev.id &&
     Number(e.extendedProps?.[idKey] || 0) === ownerId &&
    sameDay(e)
   );
   let bestMsg = "", bestGap = Infinity;
   for (const o of cand) {
     let gapMin = Infinity;
     const oStart = o.start, oEnd = o.end || o.start;
     if (end <= oStart)      gapMin = Math.round((oStart - end) / 60000);
     else if (oEnd <= start) gapMin = Math.round((start - oEnd) / 60000);
     if (gapMin < minGap && gapMin < bestGap) {
       const who = (o.extendedProps?.[nameKey] || (ownerRole === "senior" ? "Senior" : "Rilevatore")).trim();
       const cli = clientOf(o);
       bestGap = gapMin;
       bestMsg = `Servono ${minGap}′ di margine (gap ${gapMin}′): ${who} ${hhmm(oStart)}–${hhmm(oEnd)} · ${cli}.`;
     }
   }
   if (bestMsg) alert(bestMsg);
 };

 softWarnOwner();


 // Capienza fascia & BLOCCO  — IGNORA eventi “di Senior”
const targetDay    = dayKey(start);
const targetFascia = fasciaFromDate(start);

// tutti gli eventi nella stessa fascia/giorno
const sameDayFascia = all.filter(e =>
  e.start && dayKey(e.start) === targetDay && fasciaFromDate(e.start) === targetFascia
);

const isActive = (evx) => {
  const st = String(evx.extendedProps?.stato || "").toLowerCase();
  return st !== "annullato" && st !== "no_show";
};

// …evento “di Senior” se stato/flag riguardano il senior
const isSeniorFlow = (ex = {}) => {
  const code = String(ex.ui_state_code || ex.ui_state || "").toUpperCase();
  const sr   = normalizeSeniorEsito(ex.senior_esito ?? ex.esito_senior ?? "");
  const want = Number(ex.want_senior || ex.pass_to_senior || 0) === 1;
  // GIALLO (S3/S3S), ROSSO S5, VERDE SCURO S6, ARANCIONE S9, oppure esito impostato
  if (["S3","S3S","S5","S6","S9"].includes(code)) return true;
  if (sr === "chiuso" || sr === "non_chiuso") return true;
  if (want) return true;
  return false;
};

const real   = sameDayFascia.filter(e => isActive(e) && !isBlockEvent(e) && !isSeniorFlow(e.extendedProps));
const blocks = sameDayFascia.filter(e => isBlockEvent(e));

const MAX_PER_FASCIA = 8;
if (real.length >= MAX_PER_FASCIA) {
  alert(`Fascia piena: ci sono già ${real.length} appuntamenti attivi in questa fascia.`);
  chg.revert(); 
  return;
}

if (real.length < MAX_PER_FASCIA && real.length + blocks.length >= MAX_PER_FASCIA && blocks.length > 0) {
  const candidate = blocks.find(b => start < (b.end || b.start) && end > b.start) || blocks[0];
  const ok = window.confirm(
    `La fascia è piena per via dei BLOCCO.\n` +
    `Posso liberarne uno (${fmt(candidate.start)}–${fmt(candidate.end || candidate.start)}) e procedere?`
  );
  if (!ok) { chg.revert(); return; }
  try {
    await apiPost("delete_event.php", { id: Number(candidate.id) });
  } catch {
    try {
    await apiPost("cancel_event.php", {
      id: Number(candidate.id),
      stato: "annullato",
      motivo: "auto-unblock",
      cancelled_by_operator_id: UID || 1,
      operator_id: UID || 1,
      updated_by_operator_id: UID || 1,
    });

    } catch (err2) {
      alert(`Impossibile liberare un BLOCCO: ${err2.message || err2}`);
      chg.revert(); 
      return;
    }
  }
  candidate.remove();
  notifyChanged();
}




  // Salvataggio spostamento
  try {
    await apiPost("move_event.php", {
      id: Number(ev.id),
      start_dt: dateToSql(start),
      end_dt:   dateToSql(end),
      fascia:   targetFascia,
      operator_id: opId,
      updated_by_operator_id: opId,
    });
    notifyChanged();


  // 🔧 allinea subito l’istanza in memoria
  ev.setExtendedProp("start_dt", dateToSql(start));
  ev.setExtendedProp("end_dt",   dateToSql(end));
  ev.setExtendedProp("fascia",   targetFascia);




    // Patch note PF/ORA/LAST
    const oraStr = `${String(start.getHours()).padStart(2,"0")}:${String(start.getMinutes()).padStart(2,"0")}`;
    let note = String(ev.extendedProps?.note || "");
    note = upsertNoteTag(note, "PF",  targetFascia);
    note = upsertNoteTag(note, "ORA", oraStr);
    note = upsertNoteTag(note, "LAST", "move");


    try {
  await apiPost("update_event.php", {
    id: Number(ev.id),
    note,
    operator_id: opId,
    updated_by_operator_id: opId,
  });
  ev.setExtendedProp("note", note);
} catch {}



   
    // Usa il rilevatore (o in mancanza il senior) e persiste i dati su DB.
    try {
      const uidForKm =
        Number(ev.extendedProps?.rilevatore_id || 0) ||
        Number(ev.extendedProps?.senior_id || 0);

      if (uidForKm > 0) {
        const dayYmd = dateToSql(start).slice(0, 10); // YYYY-MM-DD

        const kmRes = await computeDayKmServer({
          userId:  uidForKm,
          day:     dayYmd,
          eventId: Number(ev.id),
          persist: 1,          // chiedi al BE di salvare
        });

        // current.distance_m (fallback: distance/meters)
        const meters =
          (kmRes?.current && (kmRes.current.distance_m ?? kmRes.current.distance ?? kmRes.current.meters)) ?? null;

        const partialKm = meters != null ? Number((Number(meters) / 1000).toFixed(1)) : null;

        // Se ho ottenuto il parziale → salva anche in evento.km_arrivo
        if (partialKm != null) {
  try {
    await apiPost("update_event.php", {
      id: Number(ev.id),
      km_arrivo: String(partialKm),
      operator_id: opId,
      updated_by_operator_id: opId,
    });
    ev.setExtendedProp("km_arrivo", String(partialKm));
  } catch {}
}


      }
    } catch (e) {
      console.warn("[km] auto calc after move:", e?.message || e);
    }

  } catch (err) {
    alert(`Errore spostamento: ${err.message || err}`);
    chg.revert();
  }
}, [capsMerged.canMoveEvent, capsMerged.readOnly, calRef, notifyChanged, UID]);



// ===== TIP ENGINE — sticky finché resti sull’evento o clicchi (no auto-hide) =====
Tip = (() => {
  let box = null;
  let showTimer = 0;
  let anchor = null;
  let locked = false;
  let raf = 0;
  let obs = null;
  let onAnchorLeave = null;

  // Per ri-ancorare se FullCalendar ri-renderizza l'evento
  let curEventId = null;
  let findAnchorFn = null;

  const ensure = () => {
    if (box && box.nodeType === 1) return box;
    try {
      box = document.createElement("div");
      box.id = "ev-pop-wrap";
      box.style.cssText = [
        "position:fixed","z-index:11000",
        "display:none","max-width:92vw","max-height:46vh","overflow:auto",
        "border-radius:12px","border:2px solid #0b0b0b",
        "box-shadow:0 10px 24px rgba(0,0,0,.45)",
        "background:#111827","color:#e5e7eb","padding:0",
        "overscroll-behavior:contain",
        "pointer-events:none" // il mouse non “entra” nel tip → niente appeso
      ].join(";");
      document.body.appendChild(box);
      return box;
    } catch { return null; }
  };




// === Mini tooltip per i "pallini" overlay (day header) ===
const OvTip = (() => {
  let box = null;
  const ensure = () => {
    if (box && document.body.contains(box)) return box;
    box = document.createElement('div');
    box.id = 'ov-tip';
    box.style.cssText = [
      'position:fixed','z-index:11050','display:none',
      'background:#111827','color:#e5e7eb','border:1px solid #0b0b0b',
      'border-radius:8px','padding:8px 10px','font-size:12px',
      'box-shadow:0 8px 24px rgba(0,0,0,.35)'
    ].join(';');
    document.body.appendChild(box);
    return box;
  };
  const show = (x, y, html) => {
    const el = ensure();
    el.innerHTML = html || '';
    el.style.display = 'block';
    // posizionamento
    const pad = 8;
    const maxX = window.innerWidth - el.offsetWidth - pad;
    const maxY = window.innerHeight - el.offsetHeight - pad;
    el.style.left = Math.max(pad, Math.min(x + 10, maxX)) + 'px';
    el.style.top  = Math.max(pad, Math.min(y + 10, maxY)) + 'px';
  };
  const hide = () => { if (box) box.style.display = 'none'; };
  return { show, hide };
})();



  const place = () => {
    if (!box || !anchor) return;
    const r = anchor.getBoundingClientRect?.();
    if (!r) return;
    const bw = box.offsetWidth, bh = box.offsetHeight;
    const top  = Math.max(8, r.top - bh - 10);
    const left = Math.min(window.innerWidth - bw - 8, Math.max(8, r.left + (r.width - bw)/2));
    box.style.top = `${top}px`;
    box.style.left = `${left}px`;
    raf = window.requestAnimationFrame(place);
  };

  const unbind = () => {
    if (raf) { cancelAnimationFrame(raf); raf = 0; }
    if (obs) { try { obs.disconnect(); } catch {} obs = null; }
    if (anchor && onAnchorLeave) { try { anchor.removeEventListener("mouseleave", onAnchorLeave); } catch {} }
    onAnchorLeave = null;
  };

  const tryReanchor = () => {
    if (anchor && document.body.contains(anchor)) return true;
    if (!findAnchorFn || !curEventId) return false;
    const next = findAnchorFn(curEventId);
    if (next) {
      anchor = next;
      if (onAnchorLeave) { try { anchor.removeEventListener("mouseleave", onAnchorLeave); } catch {} }
      onAnchorLeave = () => hide(true);
      anchor.addEventListener("mouseleave", onAnchorLeave, { once: true });
      return true;
    }
    return false;
  };

  const show = (el, html, opts = {}) => {
    if (locked) return;
    const b = ensure(); if (!b) return;

    clearTimeout(showTimer);
    unbind(); // reset bind precedenti

    curEventId   = opts.eventId || null;
    findAnchorFn = typeof opts.findAnchor === "function" ? opts.findAnchor : null;
    anchor       = el || null;

    showTimer = window.setTimeout(() => {
      b.innerHTML = String(html || "");
      b.style.display = "block";

      // chiudi quando ESC esce (se vuoi, puoi rimuovere ESC)
      const onKeyEsc = (e) => { if (e.key === "Escape") hide(true); };
      window.addEventListener("keydown", onKeyEsc, { once: true, capture: true });

      // chiudi appena esci dall'evento
      if (anchor) {
        onAnchorLeave = () => hide(true);
        anchor.addEventListener("mouseleave", onAnchorLeave, { once: true });
      }

      // osserva DOM: se l'evento viene ri-renderizzato, prova a ri-ancorarti
      if ("MutationObserver" in window) {
        obs = new MutationObserver(() => {
          if (!anchor || !document.body.contains(anchor)) {
            if (!tryReanchor()) {
              hide(true);
            }
          }
        });
        obs.observe(document.body, { childList: true, subtree: true });
      }

      place(); // segui la posizione dell'evento

      try { if (typeof opts.after === "function") opts.after(b); } catch {}
    }, typeof opts.delay === "number" ? opts.delay : 500);
  };

  const hide = (immediate = true) => {
    const b = ensure(); if (!b) return;
    clearTimeout(showTimer);
    unbind();
    b.style.display = "none";
    anchor = null;
    curEventId = null;
    findAnchorFn = null;
  };

  const cancel = () => { clearTimeout(showTimer); };
  const lock = (v = true) => { locked = !!v; if (locked) hide(true); };

  // sicurezza: se cambi tab o perdi focus, chiudi
  document.addEventListener("visibilitychange", () => { if (document.hidden) hide(true); });
  window.addEventListener("blur", () => hide(true));

  return { show, hide, cancel, lock, isLocked: () => locked };
})();




/* ==== distanza tra appuntamenti (km) ==== */
function haversineKm(lat1, lon1, lat2, lon2) {
  const toRad = (v) => (v * Math.PI) / 180;
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return Math.max(0, R * c);
}

// evento precedente (stesso rilevatore, stesso giorno) più vicino nel tempo
function findPrevEventSameDayForRid(current, allEvents) {
  const rid = Number(current?.extendedProps?.rilevatore_id || 0);
  if (!rid) return null;
  const sameDay = (e) => e.start && dayKey(e.start) === dayKey(current.start);
  const list = (allEvents || []).filter(e =>
    e.id !== current.id &&
    Number(e?.extendedProps?.rilevatore_id || 0) === rid &&
    sameDay(e) &&
    new Date(e.start) < new Date(current.start)
  );
  if (!list.length) return null;
  list.sort((a,b) => new Date(b.start) - new Date(a.start));
  return list[0];
}




// target per il TIP: come nella modale
function pickTargetValueForTip(ex = {}) {
  const readNum = (v) => {
    if (v == null || v === '') return 0;
    const n = Number(String(v).replace(/[^\d.-]/g, ''));
    return Number.isFinite(n) ? n : 0;
  };
  // 1) campi diretti
  let n = readNum(ex.pv_total ?? ex.preventivo_target_eur ?? ex.target);
  if (n > 0) return n;

  // 2) JSON del preventivatore (totals.target)
  try {
    const raw = ex.preventivo_json || null;
    if (raw) {
      const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
      n = readNum(obj?.totals?.target);
      if (n > 0) return n;
    }
  } catch {}
  return 0;
}

function renderEventPopover(
  ev,
  { isFieldUser = false, phoneDelay = false, calRefRef = null } = {}
) {
  const esc = (s) =>
    String(s ?? "").replace(/[&<>"']/g, (c) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
    }[c]));

  const eur = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? "€ " + n.toLocaleString("it-IT") : "€ 0";
  };

  const ex = ev.extendedProps || {};
  const start = ev.start instanceof Date ? ev.start : new Date(ev.start);
  const HH = (d) => String(d.getHours()).padStart(2, "0");
  const MM = (d) => String(d.getMinutes()).padStart(2, "0");
  const ora = `${HH(start)}:${MM(start)}`;

  const nome = esc(ex.nome_cliente || ex.cliente_nome || "Cliente");
  const telRaw = (ex._telView || ex.cliente_telefono || "").trim();
  const showPhone = (!phoneDelay || !isFieldUser) || canSeePhone(start);
  const tel = showPhone ? (telRaw || "—") : `${maskPhone(telRaw || "—")} <span style="opacity:.7">(20′ prima)</span>`;
  const addr = esc(ex.cliente_indirizzo || "—");
  const comune = (ex._comuneView || ex.comune || "—").toString().trim();
  const cap = String(ex.cap || "—");
  const comuneCap = `${comune} · ${cap}`;

  const ridName = esc((ex.rilevatore_name || "—").toString());
  const srName  = esc((ex.senior_name || "—").toString());

  // === Totale: usa il target “vero” ===
  const totPrev = eur(pickTargetValueForTip(ex));
  const budRil  = eur(ex.pv_budget_rilevatore_eur ?? ex.pv_budget ?? 0);
  const budSnr  = eur(ex.pv_budget_senior_eur ?? 0);

  // Campanello + Presenze
  const bell = pickBellStatus(ex);
  const bellTxt =
    bell === "rotto"   ? "Campanello rotto" :
    bell === "assente" ? "No campanello"    :
    bell === "ok"      ? "Campanello OK"     : "—";
  const pres = presInfo(ex);
  let presTxt;
  if (pres.flag) {
    if (pres.byName) {
      presTxt = `Inserito in Pres. · ${pres.byName}`;
    } else if (pres.byId) {
      presTxt = `Inserito in Pres. · da #${pres.byId}`;
    } else {
      presTxt = "Inserito in Pres";
    }
  } else {
    presTxt = "Presenze: no";
  }


  // Km: mostra SUBITO il salvato (se c'è); altrimenti placeholder (sarà idratato)
  let kmTra = "—";
  const kmSaved = Number(ex.km_arrivo);
  if (Number.isFinite(kmSaved) && kmSaved > 0) kmTra = `${kmSaved.toFixed(1)} km`;
  else {
    // piccolo tentativo Haversine immediato se possibile (non blocca)
    try {
      const all  = calRefRef?.current?.getApi?.()?.getEvents() || [];
      const prev = findPrevEventSameDayForRid(ev, all);
      const ex2  = ev.extendedProps || {};
      const pex  = prev?.extendedProps || {};
      const N = (v) => Number(v);
      const lat1 = N(ex2.addr_lat ?? ex2.lat ?? ex2.geo_lat ?? ex2.latitude);
      const lon1 = N(ex2.addr_lng ?? ex2.lng ?? ex2.geo_lng ?? ex2.longitude);
      const lat2 = N(pex.addr_lat ?? pex.lat ?? pex.geo_lat ?? pex.latitude);
      const lon2 = N(pex.addr_lng ?? pex.lng ?? pex.geo_lng ?? pex.longitude);
      if ([lat1, lon1, lat2, lon2].every((n) => Number.isFinite(n))) {
        kmTra = haversineKm(lat1, lon1, lat2, lon2).toFixed(1).replace(".", ",") + " km";
      }
    } catch {}
  }

  const css = `
    <style>
      #ev-pop-wrap .tp{ background:#111827; color:#e5e7eb; border:2px solid #0b0b0b; border-radius:12px; }
      #ev-pop-wrap .tp-inner{ background:#1f2937; border-radius:10px; padding:10px 12px; }
      #ev-pop-wrap .tp-title{ font-weight:900; font-size:20px; line-height:1; margin-bottom:6px; }
      #ev-pop-wrap .tp-ora{ font-weight:900; font-size:20px; margin-right:8px; }
      #ev-pop-wrap .tp-row{ display:grid; grid-template-columns:1fr 1fr; gap:10px; }
      #ev-pop-wrap .tp-cell{ display:flex; flex-direction:column; gap:4px; }
      #ev-pop-wrap .tp-line{ display:flex; align-items:center; gap:6px; font-size:13px; }
      #ev-pop-wrap .tp-thin{ border-top:1px solid #374151; margin:8px 0; }
      #ev-pop-wrap .tp-mini{ font-size:12px; opacity:.85; }
      #ev-pop-wrap .tp-strong{ font-weight:800; }
      #ev-pop-wrap .tp-history{ display:flex; flex-direction:column; gap:4px; font-size:12px; }
      #ev-pop-wrap .tp-hrow{ border-left:3px solid #374151; padding-left:8px; }
      #ev-pop-wrap .tp-when{ font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size:11px; opacity:.85; }
      a.tp-link{ color:#93c5fd; text-decoration:underline; }
     #ev-pop-wrap .tp-when{ font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size:11px; opacity:.85; }
      a.tp-link{ color:#93c5fd; text-decoration:underline; }

      #ev-pop-wrap .tp-act{ font-weight:600; }
      #ev-pop-wrap .tp-act-move{    color:#f97316; }   /* spostamenti: arancione */
      #ev-pop-wrap .tp-act-update{  color:#9ca3af; }   /* update generici (non mostrati in pratica) */
      #ev-pop-wrap .tp-act-cancel{  color:#ef4444; }   /* cancellazioni */
      #ev-pop-wrap .tp-act-create{  color:#eab308; }   /* CREATO (giallo) */
      #ev-pop-wrap .tp-act-assign{  color:#22c55e; }   /* assegnazioni */
      #ev-pop-wrap .tp-act-unassign{color:#f59e0b; }   /* dis-assegnazioni */
      #ev-pop-wrap .tp-act-status{  color:#38bdf8; }   /* cambi stato / esiti / posa */


    </style>
  `;

  const links = [
    ex.pdf_path ? `<a class="tp-link" href="${encodeURI(ex.pdf_path)}" target="_blank" rel="noopener">PDF</a>` : "—",
    ex.audio_path ? `<a class="tp-link" href="${encodeURI(ex.audio_path)}" target="_blank" rel="noopener">Audio</a>` : "—",
  ].join(" · ");

  return `
    ${css}
    <div class="tp">
      <div class="tp-inner">
        <div class="tp-title"><span class="tp-ora">${ora}</span>${nome}</div>

        <div class="tp-row">
          <div class="tp-cell">
            <div class="tp-line">📞 ${tel}</div>
            <div class="tp-line">📍 ${addr}</div>
          </div>
          <div class="tp-cell">
            <div class="tp-line">🏙️ ${esc(comuneCap)}</div>
            <div class="tp-line">👤 ${ridName} · 🧑‍🏫 ${srName}</div>
          </div>
        </div>

        <div class="tp-thin"></div>

        <div class="tp-row">
          <div class="tp-cell"><div class="tp-line">🔔 ${esc(bellTxt)}</div></div>
          <div class="tp-cell"><div class="tp-line">🕒 ${esc(presTxt)}</div></div>
        </div>

        <div class="tp-thin"></div>

        <div class="tp-row">
          <div class="tp-cell">
            <div class="tp-line"><span class="tp-strong">📊 Totale:</span> ${totPrev}</div>
            <div class="tp-line"><span class="tp-mini">Budget rilevatore:</span> ${budRil}</div>
          </div>
          <div class="tp-cell">
            <div class="tp-line"><span class="tp-mini">Link:</span> ${links}</div>
            <div class="tp-line"><span class="tp-mini">Budget senior:</span> ${budSnr}</div>
          </div>
        </div>

        <div class="tp-thin"></div>
        <div class="tp-line">
          <span class="tp-mini">Km tra appuntamenti (stesso rilevatore):</span>
          <b id="tp-kmval">${kmTra}</b>
        </div>

        <div class="tp-thin"></div>
        <div class="tp-line tp-strong">📝 Modifiche recenti</div>
        <div id="tp-history" class="tp-history">
          <div class="tp-hrow">⏳ Carico…</div>
        </div>
      </div>
    </div>
  `;
}




// helper per data log: niente secondi, formato breve
// =================== LOG HELPER (FORMATO ORA + COLORI + FROM→TO) ===================
// =================== LOG HELPER (FORMATO ORA + COLORI + FROM→TO) ===================

// data log senza anno: "09/12 09:00"












// =================== LOG HELPERS (STORIA EVENTO) ===================

// Data log senza anno: "09/12 09:00"


// ========= LOG / HISTORY HELPERS =========

// data log senza anno: "09/12 09:00"
function formatHistWhen(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";
  const iso = s.replace(" ", "T");
  const d = new Date(iso);
  if (isNaN(d.getTime())) {
    // fallback: prendo "MM-DD HH:MM" e lo giro in "DD/MM HH:MM"
    const m = s.replace("T", " ").slice(5, 16); // "MM-DD HH:MM"
    return m.replace(/^(\d{2})-(\d{2})/, "$2/$1");
  }
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// short per FROM/TO: "09/12 09:00"
function formatShortDt(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";
  const iso = s.replace(" ", "T");
  const d = new Date(iso);
  if (isNaN(d.getTime())) {
    const m = s.replace("T", " ").slice(5, 16);
    return m.replace(/^(\d{2})-(\d{2})/, "$2/$1");
  }
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// parser "semplice ma utile" per una riga di history → oggetto per UI




// ================= PARSER DELLA STORIA =================

// Costruisce max 8 righe leggibili dai log grezzi
function buildHistoryItems(rows) {
  if (!Array.isArray(rows) || !rows.length) return [];

  // helper: prova a ricavare il nome da window.__RIL_BY_ID / __SNR_BY_ID
  const idToName = (id, type) => {
    const n = Number(id || 0);
    if (!n) return "";
    try {
      if (type === "snr" && window.__SNR_BY_ID instanceof Map) {
        return window.__SNR_BY_ID.get(n) || `#${n}`;
      }
      if (window.__RIL_BY_ID instanceof Map) {
        return window.__RIL_BY_ID.get(n) || `#${n}`;
      }
    } catch {}
    return `#${n}`;
  };

  const items = [];

  for (const h of rows) {
    // payload (se c'è)
    let payload = null;
    try {
      if (h.payload) payload = JSON.parse(h.payload);
    } catch {}

    // codice azione: payload.action > action > what
    const ACT_BASE  = String(h.action || h.what || "").trim().toUpperCase();
    const ACT_INNER = payload?.action ? String(payload.action).trim().toUpperCase() : "";
    const ACT       = ACT_INNER || ACT_BASE;
    if (!ACT || ACT === "PATCH") continue; // PATCH rumorosi li salto

    const when = formatHistWhen(
      h.at || h.when || h.updated_at || h.created_at || ""
    );
    const who =
      h.by_name ||
      h.user ||
      h.operator ||
      (h.operator_id != null ? "ID " + h.operator_id : "—");

    const base = {
      when,
      who,
      label: "",
      detail: "",
      cssClass: "",
    };

    // --- CASI PRINCIPALI ---
    if (ACT === "CREATE") {
      items.push({
        ...base,
        label: "CREATO",
        cssClass: "tp-act-create",
      });
      continue;
    }

    if (ACT === "MOVE") {
      const from = payload?.from || {};
      const to   = payload?.to   || {};
      const fromStr = formatShortDt(from.start_dt || from.start || "");
      const toStr   = formatShortDt(to.start_dt   || to.start   || "");
      items.push({
        ...base,
        label: "SPOSTA APPUNTAMENTO",
        detail: (fromStr || toStr)
          ? ` (${fromStr || "?"} → ${toStr || "?"})`
          : "",
        cssClass: "tp-act-move",
      });
      continue;
    }

    if (ACT === "ASSIGN_RIL") {
      let rid =
        payload?.payload?.rilevatore_id ??
        payload?.args?.rilevatore_id ??
        payload?.rilevatore_id;
      rid = rid != null ? Number(rid) : 0;

      const name = rid ? idToName(rid, "ril") : "";
      items.push({
        ...base,
        label: rid > 0 ? "ASSEGNA RILEVATORE" : "TOGLI RILEVATORE",
        detail: rid > 0 ? ` → ${name}` : "",
        cssClass: rid > 0 ? "tp-act-assign" : "tp-act-unassign",
      });
      continue;
    }

    if (ACT === "ASSIGN_SENIOR") {
      let sid =
        payload?.payload?.senior_id ??
        payload?.args?.senior_id ??
        payload?.senior_id;
      sid = sid != null ? Number(sid) : 0;

      const name = sid ? idToName(sid, "snr") : "";
      items.push({
        ...base,
        label: sid > 0 ? "ASSEGNA SENIOR" : "TOGLI SENIOR",
        detail: sid > 0 ? ` → ${name}` : "",
        cssClass: sid > 0 ? "tp-act-assign" : "tp-act-unassign",
      });
      continue;
    }

    const LABELS = {
      IN_GESTIONE:      "IN GESTIONE",
      RIL_POS:          "PASSA AL SENIOR",
      RIL_NEG:          "RILIEVO NON BUONO",
      SENIOR_CHIUSO:    "SENIOR CHIUSO",
      SENIOR_NONCHIUSO: "SENIOR NON CHIUSO",
      DA_SPOSTARE:      "DA SPOSTARE",
      RESET:            "RESET",
      CANCEL:           "CANCELLAZIONE",
    };

    if (LABELS[ACT]) {
      const cls =
        ACT === "RIL_NEG" || ACT === "CANCEL"
          ? "tp-act-cancel"
          : "tp-act-status";
      items.push({
        ...base,
        label: LABELS[ACT],
        cssClass: cls,
      });
      continue;
    }

    // fallback: mostro comunque l’azione così com’è
    items.push({
      ...base,
      label: ACT,
      cssClass: "tp-act-status",
    });
  }

  // ritorna gli ULTIMI 8
  return items.slice(-8);
}



/* ================= POPUP: KM + STORICO (IDRATAZIONE) ================= */

async function hydratePopoverExtras(ev, box) {
  if (!ev || !box) return;

  const ex  = ev.extendedProps || {};
  const eid = Number(ev.id || ex.id || 0);

  const KM_CACHE   = window.__KM_CACHE   || (window.__KM_CACHE   = new Map());
  const HIST_CACHE = window.__HIST_CACHE || (window.__HIST_CACHE = new Map());

  // serve per capire se il popup è “vecchio” (es. hai mosso il mouse su un altro evento)
  try { box.setAttribute("data-eid", String(eid)); } catch {}
  const isStale = () => box.getAttribute("data-eid") !== String(eid);

  /* ================= KM (come prima, ma compatto) ================= */

  try {
    const kmNode = box.querySelector("#tp-kmval");
    if (kmNode) {
      const savedKm = Number(ex.km_arrivo ?? ex.km ?? ex.km_parziale);
      if (Number.isFinite(savedKm) && savedKm > 0) {
        kmNode.textContent = `${savedKm.toFixed(1)} km`;
        KM_CACHE.set(eid, savedKm);
      } else {
        const cached = KM_CACHE.get(eid);
        if (cached !== undefined) {
          kmNode.textContent = "calcolo…";
          const val = (typeof cached?.then === "function") ? await cached : cached;
          if (!isStale() && kmNode) {
            kmNode.textContent = (val != null) ? `${Number(val).toFixed(1)} km` : "—";
          }
        } else {
          const uid = Number(ex.rilevatore_id || 0) || Number(ex.senior_id || 0);
          if (uid > 0 && ev.start) {
            kmNode.textContent = "calcolo…";
            const d = ev.start instanceof Date ? ev.start : new Date(ev.start);
            const pad = (n) => String(n).padStart(2, "0");
            const ymd = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

            const p = (async () => {
              try {
                const j = await computeDayKmServer({
                  userId:  uid,
                  day:     ymd,
                  eventId: eid || 0,
                  persist: 0,
                });
                const meters =
                  j?.current &&
                  (j.current.distance_m ??
                   j.current.distance ??
                   j.current.meters);
                const kmFromCurrent = (meters != null)
                  ? Number(meters) / 1000
                  : null;
                const kmDirect = j?.current_km ?? j?.km ?? null;
                const km = (kmFromCurrent != null)
                  ? Number(kmFromCurrent.toFixed(1))
                  : (Number.isFinite(Number(kmDirect))
                      ? Number(Number(kmDirect).toFixed(1))
                      : null);
                return km;
              } catch {
                return null;
              }
            })();

            KM_CACHE.set(eid, p);
            const km = await p;
            if (!isStale() && kmNode) {
              kmNode.textContent = (km != null) ? `${km.toFixed(1)} km` : "—";
            }
          } else {
            kmNode.textContent = "—";
          }
        }
      }
    }
  } catch {
    // non bloccare per errori KM
  }

  /* ================= STORICO / MODIFICHE RECENTI ================= */

    const wrap = box.querySelector("#tp-history");
  if (!wrap) return;

  // carica le righe (solo da API, con cache JS)
  const fetchRows = async () => {
    // 1) cache JS in memoria
    const cached = HIST_CACHE.get(eid);
    if (cached !== undefined) {
      return (typeof cached?.then === "function") ? await cached : cached;
    }

    // 2) chiamata API event_history.php
    if (!eid) return [];
    const p = (async () => {
      try {
        const r = await fetch(
          `/preventivi/agenda/api/event_history.php?id=${encodeURIComponent(eid)}`,
          { credentials: "same-origin" }
        );
        const txt = await r.text();
        let j = {};
        try { j = JSON.parse(txt); } catch { j = {}; }

        const rows = Array.isArray(j.rows)
          ? j.rows
          : Array.isArray(j.history)
          ? j.history
          : [];

        return rows;
      } catch {
        return [];
      }
    })();

    HIST_CACHE.set(eid, p);
    return p;
  };



    const rows = await fetchRows();
  if (isStale()) return;

  console.log("HISTORY rows", eid, rows);

  if (!rows || !rows.length) {
    wrap.innerHTML = "<div class='tp-hrow'>—</div>";
    return;
  }

  // Costruisci le righe “intelligenti” ...
  const items = buildHistoryItems(rows);

  if (!items.length) {
    wrap.innerHTML = "<div class='tp-hrow'>—</div>";
    return;
  }

  wrap.innerHTML = items
    .map((it) => `
      <div class="tp-hrow">
        <span class="tp-when">${it.when || "-"}</span>
        &nbsp;·&nbsp;
        <b>${it.who || "-"}</b>
        &nbsp;—&nbsp;
        <span class="tp-act ${it.cssClass || ""}">${it.label || ""}</span>${it.detail || ""}
      </div>
    `)
    .join("");
} // fine hydratePopoverExtras







/* ================= /POPUP: KM + STORICO (IDRATAZIONE) ================= */


/* ===== stile event montato (annullati) ===== */
const onEventDidMount = useCallback((info) => {
  if (isBlockEvent(info.event)) { info.el.style.display = "none"; return; }
  const el = info.el;
  const main = el.querySelector(".fc-event-main") || el;
  const st = String(info.event.extendedProps?.stato || "").toLowerCase();
  const isCancelled = st === "annullato";
  el.style.backgroundImage = "";
  el.style.borderStyle = "";
  el.style.borderColor = "";
  main.style.color = "";
  if (isCancelled) {
    el.style.backgroundColor = "#fee2e2";
    el.style.borderColor     = "#ef4444";
    el.style.borderStyle     = "dashed";
    main.style.color         = "#991b1b";
  }
}, []);


/* ====== Dots mese/header per overlays ====== */





/* ===== refetch su filtro ===== */
useEffect(() => { refetch(); }, [refetch, zonaId, filterRil, fStato, q]);

/* ================= Modello “Nuovo evento” (solo ufficio) ================= */
const [openNew, setOpenNew] = useState(false);
const [newForm, setNewForm] = useState(makeEmptyNew(zonaId));

const submitNew = async (e) => {
  e.preventDefault();
  try {
    const start_dt = `${newForm.date} ${newForm.start_time}:00`;
    const end_dt   = `${newForm.date} ${newForm.end_time || newForm.start_time}:00`;
    const fas = fasciaFromDate(start_dt);



const opId = Number(
  user?.operatori_id ??
  user?.operatore_id ??
  user?.operator_id ??
  user?.id ??
  UID ??
  0
);

    const payload = {
      cliente_id: Number(newForm.cliente_id || 0),
      created_by_operator_id: opId || Number(newForm.created_by_operator_id) || 1,
      operator_id: opId,                        // 👈 per il log
      zona_id: Number(newForm.zona_id) || zonaId,
      start_dt,
      end_dt,
      fascia: fas,
      nome_cliente: newForm.nome_cliente || "Cliente",
      cliente_telefono: newForm.cliente_telefono || "0000000000",
      cliente_indirizzo: newForm.cliente_indirizzo || "",
      comune: newForm.comune || "",
      cap: newForm.cap || "",
      note: newForm.note || "",
    };


    const r = await fetch(`${API}/save_event.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    });
    const j = await r.json().catch(() => ({}));

    if (r.status === 409 && j.status === "DUPLICATE") {
      const dupLines = (j.duplicates || [])
        .map((d) => {
          const tel = d.telefono ? `(${d.telefono})` : "";
          return `#${d.id} · ${d.start_dt} → ${d.end_dt} · ${d.stato || "-"} · ${d.nome || ""} ${tel}`;
        })
        .join("\n");
      const ok = window.confirm(
        `Esistono appuntamenti in conflitto per questo cliente:\n\n${dupLines || "(dettagli non disponibili)"}\n\nVuoi SALVARE COMUNQUE?`
      );
      if (!ok) return;

      const r2 = await fetch(`${API}/save_event.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ ...payload, force: true }),
      });
      const j2 = await r2.json().catch(() => ({}));
      if (!r2.ok) throw new Error(j2.message || `HTTP ${r2.status}`);
    } else if (!r.ok) {
      throw new Error(j.message || `HTTP ${r.status}`);
    }

    setOpenNew(false);
    setNewForm(makeEmptyNew(zonaId));
    refetch();
    notifyChanged();
  } catch (err) {
    alert(err.message || "Errore salvataggio");
  }
};

const openBlankNew = () => { setNewForm(makeEmptyNew(zonaId)); setOpenNew(true); };


/* ===== filtro visibilità per ruolo (aggiornato) ===== */
function visibleForRole(
  ex,
  { isFieldUser = false, isResponsabile = false, isSeniorPosa = false } = {}
) {
  const now = new Date();
  const endIso = ex.end_dt || ex.end || ex.start_dt || ex.start || null;
  const endMs = endIso ? new Date(String(endIso).replace(' ', 'T')).getTime() : null;
  const isPast = Number.isFinite(endMs) ? (endMs < now.getTime()) : false;

  const esitoSenior = String(ex.senior_esito || ex.esito_senior || "").toLowerCase();
  const wantSenior  = Number(ex.want_senior || ex.pass_to_senior || 0) === 1;

  // 1) Solo AgendaPro (POSA usa un'altra pagina)
  if (isSeniorPosa) return false;

  // 2) Responsabile: vede solo eventi assegnati
  if (isResponsabile) {
    const assigned = Number(ex.rilevatore_id || 0) > 0 || Number(ex.senior_id || 0) > 0;
    if (!assigned) return false;
  }

  // 3) Field user (rilevatore/senior)
  if (isFieldUser) {
    // 3a) se non ha 'seniorViewEsiti', nascondi eventi con esito senior (chiuso/non_chiuso)
    const hasEsito = esitoSenior === "chiuso" || esitoSenior === "non_chiuso";
    if (hasEsito && !capsMerged.seniorViewEsiti) return false;

    // 3b) se non ha 'seniorViewPass', nascondi gli appuntamenti passati
    if (isPast && !capsMerged.seniorViewPass) return false;

    // 3c) nessun altro filtro forzato
  }

  return true;
}


const ensureAutoPosa = useCallback(async (rawRows) => {
  try {
    const now = Date.now();
    const ids = [];

    for (const row of (rawRows || [])) {
      const e = normalizeApiEventRow(row);
      const sr = normalizeSeniorEsito(e.senior_esito ?? e.esito_senior ?? "");
      const alreadyPosa =
        Number(e.posa_flag || e.in_posa || 0) === 1 || !!e.posa_transfer_at;

      if (sr === "chiuso" || alreadyPosa) continue;

      const endISO = sqlToIso(e.end_dt || e.end || e.start_dt || e.start);
      if (!endISO) continue;
      const endMs = new Date(endISO).getTime();
      if (!Number.isFinite(endMs)) continue;

      const diff = now - endMs;
      if (diff >= 48 * 3600 * 1000) {
        ids.push(Number(e.id));
      }
    }

    if (ids.length) {
   
      await apiPost("posa_transfer_batch.php", { ids });
    }
  } catch (err) {
    console.warn("[posa] auto-transfer skipped:", err?.message || err);
  }
}, []);



/* === sorgente eventi per FullCalendar (v2 con POSA) === */
const eventsFetcher = useCallback(
  async (info, success, failure) => {
    setLoading(true);
    try {
      const from = info.startStr.slice(0, 10);
      const to   = info.endStr.slice(0, 10);
      const includeBlocks = isFieldUser ? 0 : 1;

      const url =
        `${API}/list_events.php?from=${from}&to=${to}` +
        `&zona_id=${zonaId}` +
        `&rilevatore_id=${filterRil || 0}` +
        `&stato=${encodeURIComponent(fStato || "")}` +
        `&q=${encodeURIComponent(q || "")}` +
        `&include_blocks=${includeBlocks}` +
        `&include_deleted=0` +
        `&viewer_id=${UID || 0}` +
        `&viewer_role=${encodeURIComponent(roleNorm)}`;

      const res = await apiGet(url);
      const raw = Array.isArray(res?.events) ? res.events : [];

      // Ruolo POSA?
      const isSeniorPosa = /senior_posa|seniorposa|posa/.test(String(roleNorm));

      // === filtro visibilità per utente/ruolo ===
      const meId = Number(UID || 0);
      const meNameNorm = String(
        user?.nome ||
        user?.display_name ||
        user?.username ||
        user?.email ||
        ""
      ).trim().toLowerCase();

      const keepForUser = (ext) => {
        // Field user (rilevatore/senior) → solo i propri appuntamenti
        if (
          isFieldUser ||
          ["rilevatore", "rilievo", "ril", "junior", "tecnico", "field"].includes(
            roleNorm
          )
        ) {
          const rid = Number(ext.rilevatore_id || 0);
          const sid = Number(ext.senior_id || 0);

          // 1) match diretto su ID
          if (meId > 0 && (rid === meId || sid === meId)) return true;

          // 2) fallback su nome (in caso di mismatch ID fra FE e DB)
          const ridName = String(ext.rilevatore_name || "")
            .trim()
            .toLowerCase();
          const sidName = String(ext.senior_name || "")
            .trim()
            .toLowerCase();

          if (
            meNameNorm &&
            (ridName === meNameNorm || sidName === meNameNorm)
          ) {
            return true;
          }
          return false;
        }

        // altri ruoli ma con restrictAssignedOnly → solo eventi assegnati
        if (capsMerged?.restrictAssignedOnly) {
          return (
            Number(ext.rilevatore_id || 0) > 0 ||
            Number(ext.senior_id || 0) > 0
          );
        }

        // Senior posa: su AgendaPro non mostriamo nulla
        if (isSeniorPosa) return false;

        // admin / formatore / centralino ecc. → tutto
        return true;
      };

      const evs = raw
        .map((row) => {
          const e     = normalizeApiEventRow(row);
          const start = sqlToIso(e.start_dt || e.start);
          const end   = sqlToIso(e.end_dt   || e.end) || start;
          const ext   = {
            ...e,
            start_dt: e.start_dt ?? start?.replace("T", " "),
            end_dt:   e.end_dt   ?? end?.replace("T", " "),
          };
          return { e, start, end, ext };
        })
        .filter(({ ext }) => keepForUser(ext))
        .filter(({ ext }) =>
          visibleForRole(ext, {
            isFieldUser,
            isResponsabile,
            isSeniorPosa: /senior_posa|seniorposa|posa/.test(String(roleNorm)),
          })
        )
        .map(({ e, start, end, ext }) => {
          const sty = styleFromDBSafe(ext);
          return {
            id: String(e.id ?? Math.random()),
            title: e.nome_cliente || e.cliente_nome || e.title || "Cliente",
            start,
            end,
            backgroundColor: sty.backgroundColor,
            borderColor: sty.borderColor,
            classNames: sty.classNames,
            extendedProps: ext,
          };
        });

      markConflictsByRilevatore(evs, MIN_GAP_MINUTES);
      success?.(evs);
    } catch (err) {
      console.error("[list_events FAIL]", err);
      failure?.(err);
    } finally {
      setLoading(false);
    }
  },
  [
    zonaId,
    filterRil,
    fStato,
    q,
    isFieldUser,
    isResponsabile,
    roleNorm,
    UID,
    user,
    capsMerged,
    ensureAutoPosa, // NEW
  ]
);




const lastRangeRef = useRef({ from: "", to: "", zona: 0 });

const fetchOverlays = useCallback(async (info) => {
  try {
    const from = info?.startStr?.slice(0,10) || dayISO();
    const to   = info?.endStr?.slice(0,10)   || dayISO();

    // evita richieste duplicate sulla stessa finestra/zona
    const key = { from, to, zona: Number(zonaId || 0) };
    const prev = lastRangeRef.current;
    if (prev.from === key.from && prev.to === key.to && prev.zona === key.zona) return;
    lastRangeRef.current = key;

    const url  = `/preventivi/agenda/overlays/list.php?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&zona_id=${zonaId}`;
    const r = await fetch(url, { credentials: "same-origin" });
    const j = await r.json().catch(()=> ({}));
    if (j?.status !== "OK" || !Array.isArray(j.rows)) return;

    // setState solo se cambiano davvero (shallow compare su id+hash minimo)
const next = j.rows.map(o => ({
  id:        Number(o.id),
  start_dt:  String(o.start_dt || ''),
  end_dt:    String(o.end_dt   || ''),
  color:     String(o.color    || ''),
  note:      String(o.note     || ''),
  // 👇 NON perdere i flag globali
  global_rilevatori: Number(o.global_rilevatori || 0),
  global_senior:     Number(o.global_senior     || 0),
}));

    setOverlays(prevArr => {
      if (prevArr.length === next.length &&
          prevArr.every((p,i)=> p.id===next[i].id && p.start_dt===next[i].start_dt && p.end_dt===next[i].end_dt && p.color===next[i].color && p.note===next[i].note)) {
        return prevArr; // no re-render
      }
      return next;
    });
  } catch { /* no-op */ }
}, [zonaId, dayISO]);



// === Overlay event source (memo) ===
const overlaySource = useCallback((info, success) => {
  const from = +info.start;
  const to   = +info.end;
  const rows = (overlays || [])
    .map(o => ({
      id: `ov_${o.id}`,
      start: o.start_dt.replace(" ", "T"),
      end:   o.end_dt.replace(" ", "T"),
      display: "background",
      backgroundColor: o.color,
      title: o.note || "",
      classNames: ["overlay-ev"],    
      extendedProps: {
        overlay: true,
        color: o.color,
        note: o.note,
        overlay_id: o.id,
      },
    }))
    .filter(e => {
      const s  = +new Date(e.start);
      const e2 = +new Date(e.end || e.start);
      return s < to && e2 > from;
    });
  success(rows);
}, [overlays]);






// === FullCalendar eventSources (memo) ===
const calendarSources = useMemo(() => ([
  { events: eventsFetcher },  // già useCallback → identità stabile
  { events: overlaySource },  // definito sopra
]), [eventsFetcher, overlaySource]);



// 🔄 overlays → ricostruisce i dots sugli header visibili
useEffect(() => {
  rebuildHeaderDots(overlays, openOverlayNew, openOverlayEdit);
}, [overlays, openOverlayNew, openOverlayEdit]);








// Subito dopo aver definito UID/roleNorm/isFieldUser/isResponsabile/isSeniorPosa/caps:
const operatorId = useMemo(() => {
  const raw =
    user?.operatori_id ??
    user?.operatore_id ??
    user?.operator_id ??
    0;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 0;
}, [user]);




// selezione da barra "disponibilità"
const onPickSlot = useCallback((slot) => {
  const api = calRef.current?.getApi?.();
  if (!api || !slot) return;

  try {
    // vai al giorno scelto
    if (slot.day) api.gotoDate(slot.day);

    // opzionale: assicurati di essere nella vista 3 giorni
    if (api.changeView && api.view?.type !== 'timeGridThreeDay') {
      api.changeView('timeGridThreeDay');
    }


  } catch {
    /* no-op */
  }
}, [calRef]);

// --- Conflitti "soft": evidenzia solo lo stato e avvisa, poi salva ---
const [ridConflictIds, setRidConflictIds] = React.useState(new Set());


const onEventDropSoft = React.useCallback((info) => {
  // rispetto dei permessi
  if (!capsMerged.canMoveEvent || capsMerged.readOnly) return info.revert?.();

  const ev = info.event;
  const ex = ev?.extendedProps || {};

  // 🔎 chi è il “titolare” dei vincoli?
  const wantSenior   = Number(ex.want_senior || ex.pass_to_senior || 0) === 1;
  const ownerIsSenior = wantSenior && Number(ex.senior_id || 0) > 0;
  const ownerKey = ownerIsSenior ? "senior_id" : "rilevatore_id";
  const ownerId  = Number(ex[ownerKey] || 0);

  if (ownerId) {
    // altri eventi dello stesso owner (stesso giorno la check la fa handleEventChange)
    const others = info.view.calendar.getEvents().filter(e =>
      e.id !== ev.id && Number(e?.extendedProps?.[ownerKey] || 0) === ownerId
    );

    // gap: 110' per rilevatore, 150' per senior (override-safe se le costanti non esistono)
    const GAP_RID = typeof MIN_GAP_MINUTES !== "undefined" ? MIN_GAP_MINUTES : 110;
    const GAP_SNR = typeof MIN_GAP_SENIOR  !== "undefined" ? MIN_GAP_SENIOR  : 150;
    const minGap  = ownerIsSenior ? GAP_SNR : GAP_RID;

    // Messaggio “soft” (solo avviso)
    const msg = softConflictMessage(ev, others, minGap);
    if (msg) alert(msg);

    // Evidenzia graficamente gli eventi molto vicini
    const ids = new Set([String(ev.id)]);
    const startMs = +new Date(ev.start || ex.start);
    for (const o of others) {
      const oStartMs = +new Date(o.start || o.extendedProps?.start);
      const gapMin = Math.abs(oStartMs - startMs) / 60000;
      if (gapMin < minGap) ids.add(String(o.id));
    }
    setRidConflictIds(ids);
  } else {
    setRidConflictIds(new Set());
  }

  // Continua con il salvataggio “vero”
  try { handleEventChange(info); } catch {/* no-op */}
}, [capsMerged.canMoveEvent, capsMerged.readOnly, handleEventChange]);





const SHOW_PERMESSI = false; // <— metti true per ri-mostrarla quando vuoi


/* ---------------- RENDER ---------------- */
/* ---------------- RENDER ---------------- */
return (
  <div className="AgendaPro page-container" style={{ padding: 12 }}>
    {/* TITOLONE */}
    <h2 className="page-title">
      Agenda <span className="sub">FullCalendar</span>
      {loading ? <span className="loading"> · Carico…</span> : null}
    </h2>

    {/* Permessi: visibili solo se attivi il flag */}
    {SHOW_PERMESSI && (
      <PermessiBar role={roleNorm || "unknown"} zonaId={zonaId} caps={caps} />
    )}

   {/* ====== RIGA FILTRI (4×24%) ====== */}
{!isFieldUser && (
  <div className="ap-row ap-filters">
    <div className="ap-col">
      <label>Zona</label>
      <select
        value={zonaId}
        onChange={(e) => setZonaId(Number(e.target.value))}
        disabled={isResponsabile}
        title={isResponsabile ? "Zona fissata per il tuo ruolo" : "Seleziona zona"}
      >
        {ZONE.map((z) => (
          <option key={z.id} value={z.id}>{z.label}</option>
        ))}
      </select>
    </div>

    <div className="ap-col">
      <label>Rilevatore</label>
      <select value={filterRil} onChange={(e) => setFilterRil(Number(e.target.value))}>
        <option value={0}>Tutti</option>
        {rilevatori.map((r) => (
          <option key={r.id} value={r.id}>{r.nome || r.label}</option>
        ))}
      </select>
    </div>

    <div className="ap-col">
      <label>Stato</label>
      <select value={fStato} onChange={(e) => setFStato(e.target.value)}>
        {STATI.map((s) => (
          <option key={s || "all"} value={s}>{s || "Tutti"}</option>
        ))}
      </select>
    </div>

    <div className="ap-col">
      <label>Cerca</label>
      <input
        type="text"
        placeholder="nome / telefono / indirizzo…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
    </div>
  </div>
)}

{/* ====== RIGA COMANDI ====== */}
<div className="ap-row ap-toolbar">
  <button className="btn" onClick={refetch}>
    Ricarica
  </button>

  <button className="btn" onClick={openBlankNew}>
    + Nuovo
  </button>

    <div className="ap-split">
    <button
      className="btn"
      disabled={assignLoading || loading || geoLoading || !caps?.canAssignRilevatore}
      onClick={autoAssignWithGeo}   
      title="Geolocalizza i mancanti e auto-assegna (usa la data a destra)"
    >
      {(assignLoading || geoLoading) ? "Lavoro…" : "⚙️ Auto-assegna"}
    </button>
    {/* 👉 Data per auto-assegna (default oggi) */}
    <input
      className="ap-date"
      type="date"
      value={assignDate}
      onChange={(e) => setAssignDate(e.target.value)}
      title="Data usata per auto-assegna"
    />
  </div>


  <button
    className="btn"
    disabled={geoLoading || loading || assignLoading}
    onClick={() => geocodeDay("missing")}
    title="Geolocalizza solo i mancanti"
  >
    {geoLoading ? "Geo…" : "📍 Geolocalizza"}
  </button>
</div>







    {/* Stripe disponibilità */}
    <SlotsStripe slots={slots} onPick={onPickSlot} />

    {/* Mini report azioni */}
    {(geoReport || assignReport) && (
      <div style={{ marginTop: 10, fontSize: 12, lineHeight: 1.4 }} aria-live="polite">
        {geoReport && (
          <div>
            <strong>Geo:</strong>{" "}
            {geoReport.status === "OK" ? (
              <>
                scope={<b>{geoReport.scope ?? "missing"}</b>} · target={geoReport.target ?? "-"} · updated={<b>{geoReport.updated ?? "-"}</b>} · remaining=
                {geoReport.remaining_missing ?? "-"}
              </>
            ) : (
              <>ERRORE: {geoReport.message || geoReport.hint || "unknown"}</>
            )}
          </div>
        )}

        {assignReport && (
          <div>
            <strong>Assegna:</strong>{" "}
            {assignReport.status === "OK" ? (
              (() => {
                const counts = assignReport.assigned_count
                  ? assignReport.assigned_count
                  : assignReport.assigned
                  ? Object.fromEntries(
                      Object.entries(assignReport.assigned).map(([k, v]) => [k, Array.isArray(v) ? v.length : 0])
                    )
                  : {};

                const assignedTot = Object.values(counts).reduce((s, v) => s + Number(v || 0), 0);
                const s = assignReport.slots || {};
                const totEvents = Number(s.M || 0) + Number(s.P || 0) + Number(s.S || 0);
                const notAssigned = Math.max(0, totEvents - assignedTot);
                const km = typeof assignReport.total_km !== "undefined" ? assignReport.total_km : "-";
                const code = assignReport.code ? ` (${assignReport.code})` : "";

                return (
                  <>
                    OK{code} · tot={<b>{assignedTot}</b>} · rilevatori={<b>{Object.keys(counts).length}</b>} · M={s.M ?? "-"} P={s.P ?? "-"} S={s.S ?? "-"} · km={<b>{km}</b>} · non assegnati={<b>{notAssigned}</b>}
                  </>
                );
              })()
            ) : (
              <>ERRORE: {assignReport.message || assignReport.hint || "unknown"}</>
            )}
          </div>
        )}
      </div>
    )}








{/* …qui sotto il tuo calendario FullCalendar … */}
<FullCalendar
  ref={calRef}
  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}

  /* 👇 se arrivo da /agenda-pro?day=YYYY-MM-DD → vista settimanale su quel giorno */
   initialView="standard"          // 👈 nuova vista di default
  initialDate={boot.day || undefined}


  views={{
    // 👇 nuova vista "standard": oggi + 6 giorni
    standard: {
      type: "timeGrid",
      duration: { days: 7 },        // 7 giorni (giorno corrente + 6)
      buttonText: "Standard",
    },
    // vista 3 giorni che già usi per gli slot
    timeGridThreeDay: {
      type: "timeGrid",
      duration: { days: 3 },
      dateIncrement: { days: 1 },
      buttonText: "3 giorni",
    },
  }}

  headerToolbar={{
    left: "prev,next today",
    center: "title",
    right: "dayGridMonth,standard,timeGridWeek,timeGridThreeDay,timeGridDay,listWeek",
  }}
  buttonText={{
    today: "Oggi",
    month: "Mese",
    week: "Settimana",
    day: "Giorno",
    list: "Lista",
  }}
  locale={itLocale}
  height="auto"
  firstDay={1}
  hiddenDays={[0]}
  allDaySlot={false}
  nowIndicator
  expandRows
  slotDuration="00:30"
  slotLabelInterval="01:00"
  slotMinTime="08:00:00"
  slotMaxTime="20:00:00"
  selectable={false}
  selectMirror={false}
  editable={capsMerged.canMoveEvent && !capsMerged.readOnly}
  eventOverlap={true}

  eventSources={calendarSources}

  datesSet={(arg) => {
    fetchOverlays(arg);
    requestAnimationFrame(() => {
      rebuildHeaderDots(overlays, openOverlayNew, openOverlayEdit);
    });
  }}

  dayCellDidMount={decorateDayCell}
  dayHeaderDidMount={decorateDayHeader}

  eventDrop={onEventDropSoft}
  eventResize={handleEventChange}

  eventDragStart={() => { try { Tip.lock?.(true);  __tipOff?.(true); } catch {} }}
  eventDragStop={()  => { try { Tip.lock?.(false); __tipOff?.(true); } catch {} }}
  eventResizeStart={() => { try { Tip.lock?.(true);  __tipOff?.(true); } catch {} }}
  eventResizeStop={()  => { try { Tip.lock?.(false); __tipOff?.(true); } catch {} }}

  eventClick={handleEventClick}

  eventMouseEnter={(info) => {
    if (isTouchRef.current) return;
    if (openAction) return;
    if (isBlockEvent(info.event)) return;
    if (Tip?.isLocked && Tip.isLocked()) return;
    if (!info.el || !document.body.contains(info.el)) return;

    __tipOff?.(true);

    const findAnchor = (id) => {
      const n = document.querySelector(`.ev-wrap[data-id="${String(id)}"]`);
      return n ? (n.closest('.fc-event') || n) : null;
    };

    Tip.show(
      info.el,
      renderEventPopover(info.event, {
        isFieldUser,
        phoneDelay: !!capsMerged.phoneDelay,
        calRefRef: calRef,
      }),
      {
        delay: 400,
        eventId: info.event.id,
        findAnchor,
        after: (box) => hydratePopoverExtras(info.event, box),
      }
    );
  }}
  eventMouseLeave={() => { __tipOff?.(true); }}

  eventDidMount={onEventDidMount}
  eventClassNames={(arg) =>
    (ridConflictIds.has(String(arg.event.id)) ? ["ev-conflict"] : [])
  }
  eventsSet={onEventsSetSafe}

  eventTimeFormat={{ hour: "2-digit", minute: "2-digit", hour12: false }}
  eventDisplay="block"
  dayMaxEventRows={3}

 eventContent={(arg) => {
  const ex = arg.event.extendedProps || {};

  // ⬇️ Overlay: NON usare eventContent → lascia il background
  if (ex.overlay) return;

    // 👇 POSA (qualsiasi forma mappata, escluso quando chiuso dal senior)
    const isPosa =
      (Number(ex.posa_flag || 0) === 1 || !!ex.posa_transfer_at) &&
      String(ex.senior_esito || "").toLowerCase() !== "chiuso";

    // 👇 Confermato / non assegnato
    const isConfirmed =
      String(ex.stato || "").toLowerCase() === "confermato" || !!ex.confirmed_at;
    const noRilevatore = Number(ex.rilevatore_id || 0) === 0;
    const showUnassigned =
      isConfirmed &&
      noRilevatore &&
      !isPosa &&
      String(ex.stato || "").toLowerCase() !== "annullato";

    const comune = ex._comuneView || ex.comune || "";
    const comuneCap = comune ? `${comune}${ex.cap ? " · " + ex.cap : ""}` : "-";

    const rilName =
      (ex.rilevatore_name || rilById.get(Number(ex.rilevatore_id)) || "").trim();
    const srName =
      (ex.senior_name || snrById.get(Number(ex.senior_id)) || "").trim();

    const rilInit = rilName ? initials(rilName) : "";
    const srInit = srName ? initials(srName) : "";
    const whoText = [rilName, srName].filter(Boolean).join(" + ");

    return (
      <div className="ev-wrap" data-id={arg.event.id}>
        <div className="ev-time">{arg.timeText}</div>
        <div className="ev-ellipsis ev-name">
          {ex.nome_cliente || ex.cliente_nome || "Cliente"}
        </div>
        <div className="ev-ellipsis">{comuneCap}</div>
        {ex.cliente_indirizzo ? (
          <div className="ev-ellipsis">{ex.cliente_indirizzo}</div>
        ) : null}

        {!isFieldUser && whoText && (
          <div className="ev-ellipsis ev-ril-text">👤 {whoText}</div>
        )}

        {(rilInit || srInit || showUnassigned || isPosa) && (
          <div className="ev-badges">
            {rilInit && (
              <span className="ev-ril-badge" title={`Rilevatore: ${rilName}`}>
                {rilInit}
              </span>
            )}
            {srInit && (
              <span className="ev-sr-badge" title={`Senior: ${srName}`}>
                {srInit}
              </span>
            )}
            {showUnassigned && (
              <span
                className="ev-unassigned"
                title="Non assegnato"
                aria-label="Non assegnato"
              >
                Non assegnato
              </span>
            )}
            {isPosa && (
              <span className="ev-posa-chip" title="In Posa" aria-label="In Posa">
                POSA
              </span>
            )}
          </div>
        )}
      </div>
    );
  }}
/>







{!isFieldUser && (
  <Modal
    open={openNew}
    onClose={() => setOpenNew(false)}
    title="Nuovo appuntamento"
    width={980}
  >
    <form
      onSubmit={submitNew}
      style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}
    >
      <div>
        <label>Zona</label>
        <select
          value={newForm.zona_id}
          onChange={(e) =>
            setNewForm({ ...newForm, zona_id: Number(e.target.value) })
          }
        >
          {ZONE.map((z) => (
            <option key={z.id} value={z.id}>
              {z.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label>
          Cliente ID <small style={{ opacity: 0.6 }}>(vuoto/0 = auto)</small>
        </label>
        <input
          type="number"
          value={newForm.cliente_id}
          onChange={(e) =>
            setNewForm({ ...newForm, cliente_id: Number(e.target.value) })
          }
          min={0}
          placeholder="0"
        />
      </div>

      <div>
        <label>Operatore (creator)</label>
        <input
          type="number"
          value={newForm.created_by_operator_id}
          onChange={(e) =>
            setNewForm({
              ...newForm,
              created_by_operator_id: Number(e.target.value),
            })
          }
        />
      </div>

      <div>
        <label>Data</label>
        <input
          type="date"
          value={newForm.date}
          onChange={(e) => setNewForm({ ...newForm, date: e.target.value })}
          required
        />
      </div>

      <div>
        <label>Ora inizio</label>
        <input
          type="time"
          value={newForm.start_time}
          onChange={(e) =>
            setNewForm({
              ...newForm,
              start_time: e.target.value,
              end_time: addMinutesHHMM(e.target.value, 60),
            })
          }
          required
        />
      </div>

      <div>
        <label>Ora fine</label>
        <input
          type="time"
          value={newForm.end_time}
          onChange={(e) =>
            setNewForm({ ...newForm, end_time: e.target.value })
          }
          required
        />
      </div>

      <div>
        <label>Telefono</label>
        <input
          value={newForm.cliente_telefono}
          onChange={(e) =>
            setNewForm({ ...newForm, cliente_telefono: e.target.value })
          }
          required
        />
      </div>

      <div>
        <label>Nome e cognome</label>
        <input
          value={newForm.nome_cliente}
          onChange={(e) =>
            setNewForm({ ...newForm, nome_cliente: e.target.value })
          }
          required
        />
      </div>

      <div>
        <label>Città / Paese</label>
        <input
          value={newForm.comune}
          onChange={(e) => setNewForm({ ...newForm, comune: e.target.value })}
        />
      </div>

      <div>
        <label>CAP</label>
        <input
          value={newForm.cap}
          onChange={(e) => setNewForm({ ...newForm, cap: e.target.value })}
        />
      </div>

      <div style={{ gridColumn: "1 / span 4" }}>
        <label>Indirizzo</label>
        <input
          value={newForm.cliente_indirizzo}
          onChange={(e) =>
            setNewForm({ ...newForm, cliente_indirizzo: e.target.value })
          }
        />
      </div>

      <div style={{ gridColumn: "1 / span 4" }}>
        <label>Note</label>
        <textarea
          rows={3}
          value={newForm.note}
          onChange={(e) =>
            setNewForm({ ...newForm, note: e.target.value })
          }
          style={{ width: "100%", resize: "vertical" }}
        />
      </div>

      <div style={{ gridColumn: "1 / span 4", textAlign: "right" }}>
        <button
          type="button"
          onClick={() => setOpenNew(false)}
          style={{ marginRight: 8 }}
        >
          Annulla
        </button>
        <button type="submit">Crea</button>
      </div>
    </form>
  </Modal>
)}

{/* MODALE AZIONI EVENTO */}
{actionEvent && (
<ActionModal
  key={String(actionEvent.id)}
  open={openAction}
  event={actionEvent}
  operatorId={operatorId}
  rilevatori={rilevatori || []}
  seniori={seniori || []}
  caps={capsMerged}
  overlays={overlays}  
  meEmail={meEmail}              
  onClose={() => setOpenAction(false)}
  onDidChange={() => { refetch(); notifyChanged(); }}
/>

)}

{/* MODALE OVERLAY (blocchi agenda pastello) */}
<OverlayModal
  open={overlayOpen}
  onClose={() => setOverlayOpen(false)}
  onSaved={() => {
    const api = calRef.current?.getApi?.();
    if (api) {
      fetchOverlays({
        startStr: api.view.activeStart.toISOString(),
        endStr:   api.view.activeEnd.toISOString(),
      });
    }
    setEditOverlay(null);
  }}
  defaultDay={ovDefaultDay}
  zonaId={zonaId}
  operatorId={operatorId}
  editData={editOverlay}
  rilevatori={rilevatori}
  seniori={seniori}
  seniorPosa={seniorPosa}
  formatori={formatori}
/>


</div>
); // ← CHIUDE il return
} // ← CHIUDE il componente AgendaPro
